// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0px;
  padding: 0px;
}

/* Base styling */
.bulk-collection-v1-container {
  padding: 0;
  width: 100%;
  margin: 0;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  position: relative;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  font-size: 0.9rem;
  padding-top: 60px;
}

.bulk-collection-content {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
}

.bulk-collection-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  border-bottom: none;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  width: 100%;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
  position: relative;
  z-index: 1001;
}

.back-button-bulk {
  display: flex;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  padding: 8px 12px;
  margin-right: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.2);
  font-size: 13px;
}

.back-button-bulk:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
  border-color: rgba(255, 255, 255, 0.4);
}

.back-button-bulk svg {
  margin-right: 8px;
}

.bulk-collection-header .bulk-heading {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  flex-grow: 1;
  letter-spacing: -0.5px;
}

.bulk-collection-header .header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* Premium Dairy Info Card - Updated Styling */
.dairy-owner-info-card {
  flex: 1 1;
  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 120px;
  border: 1px solid rgba(59, 130, 246, 0.15);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.dairy-owner-info-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6 0%, #8b5cf6 100%);
}

.dairy-owner-info-card:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
  border-color: rgba(59, 130, 246, 0.25);
}

/* Current Rate Info Card - New Styling */
.current-rate-info-card-bulk {
  flex: 1 1;
  background: linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%);
  border-radius: 12px;
  padding: 0.5rem 1rem 1rem 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 120px;
  border: 1px solid rgba(34, 197, 94, 0.15);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.current-rate-info-card-bulk::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #22c55e 0%, #10b981 100%);
}

.current-rate-info-card-bulk:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
  border-color: rgba(34, 197, 94, 0.25);
}

/* Card Heading Styling */
.card-heading {
  /* margin: 0 0 1rem 0; */
  font-size: 1.1rem;
  font-weight: 600;
  color: #1f2937;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid rgba(59, 130, 246, 0.2);
  text-align: center;
  letter-spacing: -0.3px;
}

.current-rate-info-card-bulk .card-heading {
  border-bottom-color: rgba(34, 197, 94, 0.2);
  color: #065f46;
}

/* Rate Card Heading - No Top Padding */
.rate-card-heading {
  margin-bottom: 20px;
  padding: 0.5rem 0 0.5rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #065f46;
  border-bottom: 2px solid rgba(34, 197, 94, 0.2);
  text-align: center;
  letter-spacing: -0.3px;
}

.dairy-owner-info-content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 16px;
  align-items: flex-start;
}

.dairy-info-wrapper {
  /* border: solid 2px red; */
  display: flex;
  gap: 16px;
  width: 100%;
  align-items: stretch;
  margin-bottom: 10px;
  padding: 12px;
  border-radius: 12px;
}

/* Mobile and Tablet Layout - Stack cards vertically */
@media (max-width: 1024px) {
  .dairy-info-wrapper {
    flex-direction: column;
    gap: 1rem;
  }

  .rate-settings-modern-card,
  .wallet-simple-card {
    /* flex: 1; */
    width: 100%;
  }
}

.dairy-details-bulk,
.owner-details-bulk {
  flex: 0 1 auto;
  min-width: 45%;
  display: flex;
  flex-direction: row;
  gap: 6px;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  gap: 0.4rem;
}

.info-icon {
  font-size: 0.9rem;
  color: #2563eb;
  margin-right: 0;
  width: 16px;
  flex-shrink: 0;
}

.info-label {
  font-weight: 600;
  color: #2563eb;
  margin-right: 0.2rem;
  min-width: auto;
  font-size: 0.7rem;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.info-value {
  color: #1f2937;
  font-size: 0.75rem;
  font-weight: 600;
}

.info-loading {
  color: #6c757d;
  text-align: center;
  padding: 10px;
  font-style: italic;
}

/* Loading state */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #007bff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Messages */
.success-message,
.error-message {
  display: flex;
  align-items: center;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
  animation: fadeIn 0.3s ease-in-out;
}

.success-message {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.error-message {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  justify-content: space-between;
}

.success-message svg,
.error-message svg {
  margin-right: 10px;
  font-size: 1.2em;
}

.close-error {
  background: none;
  border: none;
  color: #721c24;
  cursor: pointer;
  padding: 5px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Current Rate - Outer Card with Green Border */
.current-rate-info {
  flex: 1 1;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 110px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
  margin-bottom: 12px;
  position: relative;
  overflow: hidden;
}

.current-rate-info::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #10b981 0%, #059669 100%);
}

.current-rate-info:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

/* 50-50 Layout for Rate Info */
.rate-info-row {
  display: flex;
  gap: 12px;
  align-items: stretch;
}

/* Premium Rate Info Items - Compact (No Green Border) */
.rate-info-item {
  flex: 1 1;
  min-width: 0;
  background: linear-gradient(135deg, #f0f9ff 0%, #ffffff 100%);
  border: 1px solid rgba(59, 130, 246, 0.15);
  border-radius: 8px;
  padding: 0.6rem;
  min-height: 45px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.rate-info-item:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-color: rgba(59, 130, 246, 0.25);
}

/* Premium Global Settings - Compact */
.global-settings {
  background: linear-gradient(135deg, #fef3c7 0%, #ffffff 100%);
  border-radius: 10px;
  padding: 0.75rem;
  margin-bottom: 0.75rem;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.06);
  width: 100%;
  max-width: 100%;
  border: 1px solid rgba(251, 191, 36, 0.2);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.global-settings::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #f59e0b 0%, #f97316 100%);
}

.global-settings:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
  border-color: rgba(251, 191, 36, 0.3);
}

.global-settings-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.global-setting {
  flex: 1 1;
  min-width: 150px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.global-setting label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #374151;
  font-size: 13px;
}

.global-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  transition: all 0.2s ease;
}

.global-input:focus {
  border-color: #2563eb;
  outline: none;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

/* Rate display styles */
.rate-display {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1rem;
}

.rate-display p {
  margin: 0;
  font-weight: 500;
  color: #333;
}

/* Rate Type Section - Now part of rate-info-item */

.rate-type-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;
}

.rate-type-display p {
  margin: 0;
  font-weight: 500;
  color: #333;
}

.rate-edit {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
}

.rate-type-edit {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
}

.rate-type-edit label {
  margin: 0;
  font-weight: 500;
  color: #333;
}

.rate-type-input-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.rate-type-input-group label {
  margin: 0;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
}

.rate-type-select {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 12px;
  padding-right: 30px;
  background-color: #fff;
  font-size: 13px;
  transition: all 0.2s ease;
}

.rate-type-select:hover {
  border-color: #2563eb;
}

.rate-type-select:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.rate-type-saving-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #10b981;
  font-size: 0.85rem;
  margin-left: 10px;
  padding: 4px 8px;
  background-color: rgba(16, 185, 129, 0.1);
  border-radius: 4px;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }
}

.edit-rate-button {
  display: flex;
  align-items: center;
  background: #2563eb;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white !important;
  font-weight: 500;
  font-size: 13px;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.15);
}

.edit-rate-button:hover {
  background: #1d4ed8;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.edit-rate-button:hover svg {
  color: black !important;
}

.edit-rate-button svg {
  margin-right: 8px;
  color: white !important;
  transition: color 0.3s ease;
}

/* Rate Edit Form */
.rate-edit {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rate-edit label {
  margin: 0;
  font-weight: 500;
  color: #333;
}

.rate-input {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  margin-right: 10px;
  width: 120px;
  font-size: 13px;
  transition: all 0.2s ease;
}

.rate-input:focus {
  border-color: #2563eb;
  outline: none;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.save-rate-button-bulk {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white !important;
  font-weight: 600;
  font-size: 13px;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
}

.save-rate-button-bulk:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.3);
}

.save-rate-button-bulk svg {
  margin-right: 8px;
}

.save-rate-button-bulk:disabled {
  background: #d1d5db;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* CSV/Excel Grid Layout */
.csv-grid-container {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 12px;
  width: 100%;
  overflow-x: auto;
  max-width: 100%;
  margin: 0 auto;
  border: 1px solid #e5e7eb;
}

.excel-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8fafc 0%, #f0f4f8 100%);
  border-bottom: 1px solid #e5e7eb;
  border-radius: 8px 8px 0 0;
  gap: 10px;
}

.toolbar-left {
  display: flex;
  gap: 8px;
}

.toolbar-right {
  display: flex;
  align-items: center;
  margin-left: auto;
}

/* Collection Date Time Controls - New Larger Design */
.collection-date-time-controls {
  display: flex;
  gap: 16px;
  align-items: center;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.collection-date-control,
.collection-time-control {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 180px;
}

.collection-date-control label,
.collection-time-control label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
}

.collection-date-input,
.collection-time-input {
  padding: 8px 12px;
  margin: 0;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  color: #374151;
  transition: all 0.2s ease;
  width: 100%;
  height: 36px;
  text-align: center;
  box-sizing: border-box;
  font-weight: 500;
}

.collection-date-input:focus,
.collection-time-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.collection-date-input:hover,
.collection-time-input:hover {
  border-color: #94a3b8;
}

/* Responsive adjustments for collection date time controls */
@media (max-width: 768px) {
  .collection-date-time-controls {
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
    padding: 10px 12px;
  }

  .collection-date-control,
  .collection-time-control {
    min-width: 160px;
  }

  .collection-date-input,
  .collection-time-input {
    height: 32px;
    font-size: 13px;
    padding: 6px 10px;
  }
}

.date-control,
.time-control {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-width: 70px;
}

.date-control label,
.time-control label {
  font-size: 0.7rem;
  font-weight: 500;
  color: #64748b;
  white-space: nowrap;
  margin-bottom: 1px;
}

.toolbar-date-input,
.toolbar-time-input {
  padding: 2px 8px;
  margin: 0;
  border: 1px solid #cbd5e1;
  border-radius: 3px;
  font-size: 11px;
  background: white;
  color: #374151;
  transition: all 0.2s ease;
  width: 100%;
  height: 22px;
  text-align: center;
  box-sizing: border-box;
}

.toolbar-date-input:focus,
.toolbar-time-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.1);
}

.toolbar-date-input:hover,
.toolbar-time-input:hover {
  border-color: #94a3b8;
}

.add-row-button,
.preview-button {
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 13px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.add-row-button {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white !important;
}

.add-row-button:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

/* Mobile Add Customer Button Styling */
.mobile-add-customer-button {
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 13px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white !important;
}

.mobile-add-customer-button:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.mobile-add-customer-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.mobile-add-customer-button svg {
  margin-right: 6px;
  font-size: 14px;
}

/* Edit Supplier Button Positioning */
.edit-supplier-btn {
  margin-left: auto !important;
  position: relative;
  z-index: 10;
}

.excel-toolbar {
  position: relative;
}

/* Mobile responsive styles for Edit Supplier button */
@media (max-width: 768px) {
  .edit-supplier-btn {
    width: 100%;
    margin-left: 0 !important;
    margin-top: 8px;
    order: 3;
  }

  .excel-toolbar {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .submit-preview-button {
    width: 100%;
    margin-top: 10px;
    order: 4;
  }
}

@media (max-width: 576px) {
  .edit-supplier-btn {
    width: 100%;
    margin-left: 0 !important;
    margin-top: 8px;
    order: 3;
  }

  .excel-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .submit-preview-button {
    width: 100%;
    margin-top: 10px;
    order: 4;
  }
}

/* Submit/Preview Button Styling */
.submit-preview-button {
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 13px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white !important;
}

.submit-preview-button:hover {
  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.submit-preview-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.submit-preview-button svg {
  margin-right: 6px;
  font-size: 14px;
}

/* Preview Button (for other uses) - keep existing styling */
.preview-button {
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 13px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white !important;
}

.preview-button:hover {
  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.preview-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.preview-button svg {
  margin-right: 6px;
  font-size: 14px;
}

.add-row-button svg,
.preview-button svg {
  margin-right: 6px;
  font-size: 14px;
}

.preview-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* Excel Table Styling */
.excel-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1200px;
  /* Ensure minimum width to fit all columns */
}

.excel-table th,
.excel-table td {
  border: 1px solid #e5e7eb;
  padding: 0;
  position: relative;
  height: 34px;
  overflow: visible;
  font-size: 13px;
}

.excel-table th {
  background-color: #f3f4f6;
  font-weight: 600;
  text-align: center;
  padding: 8px 4px;
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid #e5e7eb;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #374151;
}

.excel-table tbody {
  max-height: 400px;
  overflow-y: auto;
}

.excel-table .data-row:hover {
  background-color: #f8fafc;
}

.excel-table .data-row:nth-child(even) {
  background-color: #f9f9f9;
}

.excel-table .data-row:nth-child(even):hover {
  background-color: #f0f5fa;
}

.excel-table td.has-error {
  background-color: rgba(255, 0, 0, 0.05);
}

.excel-cell-input,
.excel-cell-select {
  width: 100%;
  height: 100%;
  padding: 0 6px;
  border: none;
  background: transparent;
  font-size: 16px !important;
}

/* Style for disabled inputs to make them appear faded */
.excel-cell-input:disabled,
.excel-cell-select:disabled {
  background-color: #f5f5f5;
  color: #9e9e9e;
  cursor: not-allowed;
  opacity: 0.7;
  border-left: 2px solid #e0e0e0;
}

.excel-cell-input:focus,
.excel-cell-select:focus {
  outline: none;
  box-shadow: inset 0 0 0 2px #4d90fe;
}

.excel-cell-select {
  appearance: none;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 6px center;
  background-size: 12px;
  padding-right: 24px;
}

.calculated-cell {
  position: relative;
}

.calc-indicator {
  position: absolute;
  top: 0;
  right: 2px;
  color: #0066cc;
  font-size: 12px;
  font-weight: bold;
}

.calc-indicator.auto {
  color: #28a745;
  background-color: rgba(40, 167, 69, 0.1);
  padding: 0 4px;
  border-radius: 2px;
  right: 4px;
  top: 2px;
  font-size: 10px;
}

/* Special styling for calculated fields based on rate type */
.calculated-cell .excel-cell-input:disabled {
  background-color: #f0f8ff;
  /* Light blue background */
  color: #006699;
  border-left: 2px solid #4dabf7;
  opacity: 0.8;
}

/* Auto-calculated field style */
.excel-cell-input.auto-calculated {
  background-color: #f0f8ff;
  font-style: italic;
}

/* Disabled field container */
.disabled-field {
  position: relative;
  width: 100%;
  height: 100%;
}

/* Readonly field container */
.readonly-field {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

/* Editable field container */
.editable-field {
  position: relative;
  width: 100%;
  height: 100%;
}

/* Editable Base SNF input style - removed color to look like regular input */
.editable-field .excel-cell-input {
  font-weight: 500;
}

.editable-field .excel-cell-input:focus {
  outline: none;
  box-shadow: inset 0 0 0 2px #4d90fe;
}

/* Readonly input style */
.excel-cell-input.readonly-input {
  background-color: #f0f7ff;
  color: #495057;
  cursor: default;
  border-color: #b8daff;
  font-weight: 500;
}

/* Readonly indicator */
.readonly-indicator {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #6c757d;
  pointer-events: none;
}

/* Disabled input style */
.excel-cell-input.disabled-input {
  background-color: #f6f6f6;
  color: #b0b0b0;
  text-decoration: line-through;
  opacity: 0.6;
}

/* Indicator for disabled fields */
.disabled-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  color: #999;
  background-color: rgba(0, 0, 0, 0.05);
  padding: 1px 4px;
  border-radius: 2px;
  pointer-events: none;
  /* Prevent it from blocking interactions */
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.8;
}

.calc-info {
  margin-top: -15px;
  margin-bottom: 15px;
  color: #0066cc;
  font-size: 13px;
  font-style: italic;
}

.cell-error {
  position: absolute;
  bottom: -18px;
  left: 0;
  width: 100%;
  background-color: #f8d7da;
  color: #721c24;
  font-size: 12px;
  padding: 2px 4px;
  text-align: center;
  z-index: 20;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cell-warning {
  position: absolute;
  bottom: -18px;
  left: 0;
  width: 100%;
  background-color: #fff3cd;
  color: #856404;
  font-size: 12px;
  padding: 2px 4px;
  text-align: center;
  z-index: 20;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.empty-message {
  text-align: center;
  padding: 20px;
  color: #6c757d;
  font-style: italic;
}

.delete-row-btn {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-row-btn:hover {
  background-color: rgba(220, 53, 69, 0.1);
}

/* Customer search cell and dropdown styling */
.customer-search-cell {
  position: relative;
  width: 100%;
}

.excel-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.dropdown-item {
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  transition: background-color 0.2s;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
  cursor: pointer;
}

.dropdown-item.selected {
  background-color: #e9ecef;
  font-weight: bold;
}

.dropdown-item.add-new {
  color: #007bff;
  font-weight: 500;
  background-color: #f8f9fa;
  border-top: 1px solid #ddd;
}

.no-results {
  padding: 8px 12px;
  color: #888;
  font-style: italic;
  text-align: center;
}

/* Make sure the dropdown appears above other elements */
.excel-table .data-row td {
  position: relative;
}

/* Highlight active search cell */
.excel-cell-input:focus {
  outline: 2px solid #1a73e8;
  border-color: #1a73e8;
}

/* Enhance the visibility of customer cell */
.excel-table td:first-child .excel-cell-input {
  width: 100%;
  min-width: 150px;
}

/* Premium Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1002;
  overflow-y: auto;
  padding: 20px;
  backdrop-filter: blur(8px);
  animation: modalFadeIn 0.3s ease-out;
}

.modal-content {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 800px;
  max-height: 95vh;
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(59, 130, 246, 0.1);
  animation: modalSlideIn 0.3s ease-out;
}

.modal-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6 0%, #8b5cf6 100%);
  border-radius: 16px 16px 0 0;
}

/* Modal Styles */
.preview-modal,
.new-customer-modal {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: modalFadeIn 0.3s ease-in-out;
  overflow: hidden;
}

.new-customer-modal {
  max-width: 550px;
  /* Slightly wider */
  margin: 20px;
}

.preview-modal {
  max-width: 1600px;
  /* Increased for better desktop viewing */
  margin: 20px;
  width: 98%;
  /* Nearly full width */
  max-height: 95vh;
  /* Increased height to reduce scrolling */
}

/* Specific padding adjustments for the new customer modal */
.new-customer-modal .modal-header {
  padding: 22px 28px;
}

.new-customer-modal .modal-body {
  padding: 28px 32px;
}

.new-customer-modal .modal-footer {
  padding: 20px 28px;
}

.new-customer-modal .modal-footer button {
  padding: 12px 20px;
  min-width: 100px;
}

/* Specific styling for the preview modal */
.preview-modal .modal-header {
  padding: 22px 28px;
}

.preview-modal .modal-body {
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 0;
  /* Remove default gap to ensure proper spacing */
}

.preview-modal .modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 28px;
}

.preview-modal .modal-footer .rate-settings-btn {
  order: -1;
  /* Move rate settings button to the left */
  margin-right: auto;
  /* Push it to the far left */
}

.preview-modal .modal-footer .cancel-button {
  margin-left: auto;
  /* Keep cancel on the right */
}

.preview-modal .modal-footer .confirm-button {
  margin-left: 12px;
  /* Space between cancel and confirm */
}

.preview-modal .modal-footer button {
  padding: 12px 20px;
  min-width: 100px;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid rgba(59, 130, 246, 0.1);
  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
  position: relative;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.2rem;
  color: #1e293b;
  font-weight: 700;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.close-modal-button {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border: 1px solid rgba(148, 163, 184, 0.3);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #64748b;
  font-size: 0.9rem;
}

.close-modal-button:hover {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border-color: #ef4444;
  color: #ef4444;
  transform: rotate(90deg);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
}

.modal-body {
  padding: 1.5rem;
  overflow-y: auto;
  flex-grow: 1;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem 1.5rem;
  border-top: 1px solid rgba(59, 130, 246, 0.1);
  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
}

.modal-footer button {
  margin-left: 8px;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  font-size: 0.85rem;
}

.cancel-button {
  background: linear-gradient(135deg, #6c757d 0%, #dc3545 100%);
  color: white;
  border: 1px solid #dc3545;
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.2);
}

.cancel-button:hover {
  background: linear-gradient(135deg, #5a6268 0%, #c53030 100%);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
  transform: translateY(-1px);
}

.confirm-button {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: 1px solid #059669;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
}

.confirm-button:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  transform: translateY(-1px);
}

.save-button:disabled {
  background: #c2c7c7;
  cursor: not-allowed;
  box-shadow: none;
}

.confirm-button svg,
.save-button svg {
  margin-right: 8px;
}

/* New customer form */
.form-instructions {
  margin-bottom: 24px;
  color: #5f6368;
  font-size: 14px;
  grid-column: span 2;
}

.form-group {
  margin-bottom: 10px;
  position: relative;
}

.form-group label {
  display: block;
  margin-bottom: 10px;
  font-weight: 500;
  color: #3c4043;
  font-size: 14px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #dadce0;
  border-radius: 4px;
  font-size: 14px;
  color: #202124;
  transition: all 0.2s;
  background-color: #fff;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: #1a73e8;
  outline: none;
  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: #80868b;
}

.form-group input:hover,
.form-group textarea:hover {
  border-color: #bdc1c6;
}

/* Required field indicator */
.form-group label[for="customer-name"]::after {
  content: " *";
  color: #d93025;
}

/* Organize form in columns for larger screens */
@media (min-width: 576px) {
  .modal-body {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .new-customer-modal .modal-body {
    gap: 24px;
  }

  .form-group:last-child {
    grid-column: span 2;
    margin-top: 8px;
  }
}

/* Column widths in the Excel table */
.excel-table th:nth-child(1),
/* Serial Number */
.excel-table td:nth-child(1) {
  width: 50px;
  min-width: 50px;
  text-align: center;
}

.excel-table th:nth-child(2),
/* Customer */
.excel-table td:nth-child(2) {
  width: 180px;
  min-width: 180px;
}

.excel-table th:nth-child(3),
/* Weight */
.excel-table th:nth-child(4),
/* Fat */
.excel-table th:nth-child(5),
/* SNF */
.excel-table th:nth-child(6),
/* CLR */
.excel-table th:nth-child(7),
/* Milk Rate */
.excel-table td:nth-child(3),
.excel-table td:nth-child(4),
.excel-table td:nth-child(5),
.excel-table td:nth-child(6),
.excel-table td:nth-child(7) {
  width: 85px;
  min-width: 85px;
}

.excel-table th:nth-child(8),
/* Base SNF */
.excel-table th:nth-child(9),
/* Time */
.excel-table th:nth-child(10),
/* Animal Type */
.excel-table td:nth-child(8),
.excel-table td:nth-child(9),
.excel-table td:nth-child(10) {
  width: 100px;
  min-width: 100px;
}

.excel-table th:nth-child(11),
/* Actions */
.excel-table td:nth-child(11) {
  width: 60px;
  min-width: 60px;
}

/* Style the serial number cell */
.serial-number-cell {
  text-align: center;
  font-weight: 500;
  background-color: #f8f9fa;
}

/* Preview table column widths with serial number */

/* Bulk Preview Modal - Responsive Design */
.bulk-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow-y: auto;
  padding: 10px;
  backdrop-filter: blur(8px);
  animation: bulkModalFadeIn 0.3s ease-out;
}

.bulk-preview-modal {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  width: 95%;
  max-width: 1400px;
  max-height: 95vh;
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(59, 130, 246, 0.1);
  animation: bulkModalSlideIn 0.3s ease-out;
}

.bulk-preview-modal::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6 0%, #8b5cf6 100%);
  border-radius: 12px 12px 0 0;
}

@keyframes bulkModalFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes bulkModalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Modal Header */
.bulk-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(59, 130, 246, 0.1);
  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
  position: relative;
}

.bulk-modal-title {
  margin: 0;
  font-size: 1.25rem;
  color: #1e293b;
  font-weight: 700;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.bulk-close-modal-button {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border: 1px solid rgba(148, 163, 184, 0.3);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #64748b;
  font-size: 1rem;
}

.bulk-close-modal-button:hover {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border-color: #ef4444;
  color: #ef4444;
  transform: rotate(90deg);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
}

/* Modal Body */
.bulk-modal-body {
  padding: 20px;
  overflow-y: auto;
  flex-grow: 1;
  max-height: calc(95vh - 180px);
}

.bulk-preview-header {
  margin-bottom: 20px;
}

.bulk-preview-info {
  margin: 0;
  color: #64748b;
  font-size: 0.95rem;
  font-weight: 500;
  text-align: center;
  padding: 12px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 8px;
  border: 1px solid rgba(59, 130, 246, 0.1);
}

/* Table Container */
.bulk-preview-table-container {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  overflow-x: hidden;
  /* Hide horizontal scrollbar on desktop */
}

.bulk-table-wrapper {
  min-width: 100%;
}

.bulk-preview-table {
  width: 100%;
  min-width: auto;
  border-collapse: collapse;
  font-size: 0.85rem;
  table-layout: fixed;
}

/* Table Header */
.bulk-table-header {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  position: sticky;
  top: 0;
  z-index: 10;
}

.bulk-header-row {
  border-bottom: 2px solid #e5e7eb;
}

.bulk-header-row .bulk-cell {
  padding: 12px 8px;
  text-align: center;
  font-weight: 600;
  color: #374151;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-right: 1px solid #e5e7eb;
  white-space: nowrap;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.bulk-header-row .bulk-cell:last-child {
  border-right: none;
}

/* Table Body */
.bulk-table-body .bulk-data-row {
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.bulk-table-body .bulk-data-row:hover {
  background-color: #f8fafc;
  transform: scale(1.001);
}

.bulk-table-body .bulk-data-row:nth-child(even) {
  background-color: #fafbfc;
}

.bulk-table-body .bulk-cell {
  padding: 10px 8px;
  text-align: center;
  border-right: 1px solid #f1f5f9;
  font-size: 0.85rem;
  color: #374151;
  vertical-align: middle;
}

.bulk-table-body .bulk-cell:last-child {
  border-right: none;
}

/* Cell Specific Styles */
.bulk-cell-number {
  width: 60px;
  font-weight: 600;
  background-color: #f8fafc !important;
}

.bulk-cell-customer {
  width: 200px;
  text-align: left;
  font-weight: 500;
  padding-left: 12px;
}

.bulk-cell-date {
  width: 100px;
}

.bulk-cell-time {
  width: 80px;
}

.bulk-cell-quantity {
  width: 100px;
}

.bulk-quantity-value {
  font-weight: 600;
  color: #059669;
}

.bulk-cell-fat,
.bulk-cell-clr,
.bulk-cell-snf,
.bulk-cell-base-snf {
  width: 70px;
}

.bulk-cell-fat-kg,
.bulk-cell-snf-kg {
  width: 80px;
}

.bulk-cell-rate {
  width: 90px;
}

.bulk-rate-value {
  font-weight: 600;
  color: #2563eb;
}

.bulk-cell-amount {
  width: 100px;
}

.bulk-amount-value {
  font-weight: 700;
  color: #059669;
  font-size: 0.9rem;
}

/* Table Footer */
.bulk-table-footer {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-top: 2px solid #e5e7eb;
  position: sticky;
  bottom: 0;
  z-index: 10;
}

.bulk-footer-row .bulk-cell {
  padding: 12px 8px;
  font-weight: 600;
  border-right: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.bulk-footer-row .bulk-cell:last-child {
  border-right: none;
}

.bulk-total-label {
  text-align: center;
  color: #374151;
  font-size: 16px !important;
  font-weight: 700;
}

.bulk-total-label span {
  color: #007bff;
}

.bulk-total-value {
  text-align: center;
  font-weight: 700;
  font-size: 0.95rem;
}

.bulk-total-amount {
  color: #059669;
}

.bulk-total-quantity {
  color: #2563eb;
}

/* Modal Footer */
.bulk-modal-footer {
  padding: 16px 20px;
  border-top: 1px solid rgba(59, 130, 246, 0.1);
  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
}

.bulk-footer-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.bulk-action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.bulk-footer-actions button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  min-height: 40px;
}

.bulk-cancel-button {
  background: #f8f9fa;
  color: #6c757d;
  border: 1px solid #dee2e6;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.bulk-cancel-button:hover {
  background: #e9ecef;
  color: #495057;
  border-color: #adb5bd;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.bulk-preview-settings-button {
  background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.2);
  width: fit-content;
  padding: 5px;
}

.bulk-preview-settings-button:hover {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
  transform: translateY(-1px);
}

.bulk-confirm-button {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
}

.bulk-confirm-button:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  transform: translateY(-1px);
}

.bulk-confirm-button:disabled {
  background: #d1d5db;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Responsive Design */

/* Large Desktop (1200px and up) */
@media (min-width: 1200px) {
  .bulk-preview-modal {
    width: 95%;
    max-width: 1800px;
    max-height: 95vh;
    overflow: visible;
  }

  .bulk-modal-body {
    max-height: calc(95vh - 180px);
    overflow-x: hidden;
    /* Hide horizontal scrollbar on desktop */
    overflow-y: auto;
  }

  .bulk-preview-table-container {
    overflow-x: hidden;
    /* Hide horizontal scrollbar on desktop */
  }

  .bulk-preview-table {
    width: 100%;
    min-width: auto;
    table-layout: fixed;
  }

  .bulk-cell-customer {
    width: 200px;
    min-width: 200px;
  }
}

/* Desktop (992px to 1199px) */
@media (max-width: 1199px) {
  .bulk-preview-modal {
    width: 95%;
    max-width: 1400px;
    max-height: 95vh;
    overflow: visible;
  }

  .bulk-modal-body {
    padding: 16px;
    max-height: calc(95vh - 160px);
    overflow-x: auto;
    overflow-y: auto;
  }

  .bulk-preview-info {
    font-size: 0.9rem;
    padding: 12px;
  }

  .bulk-preview-table {
    width: 100%;
    min-width: auto;
    table-layout: fixed;
  }

  .bulk-modal-header {
    padding: 14px 18px;
  }

  .bulk-modal-footer {
    padding: 14px 18px;
  }
}

/* Tablet (768px to 991px) */
@media (max-width: 991px) {
  .bulk-modal-overlay {
    padding: 8px;
  }

  .bulk-preview-modal {
    width: 98%;
    max-width: none;
    border-radius: 8px;
    max-height: 95vh;
  }

  .bulk-preview-table-container {
    overflow-x: auto;
  }

  .bulk-preview-table {
    width: 100%;
    min-width: 700px;
    font-size: 0.8rem;
    table-layout: auto;
  }

  .bulk-modal-header {
    padding: 12px 16px;
  }

  .bulk-modal-title {
    font-size: 1.1rem;
  }

  .bulk-modal-body {
    padding: 12px;
    max-height: calc(95vh - 160px);
    overflow-x: auto;
    overflow-y: auto;
  }

  .bulk-preview-info {
    font-size: 0.85rem;
    padding: 10px;
  }

  .bulk-header-row .bulk-cell,
  .bulk-table-body .bulk-cell {
    padding: 6px 4px;
    font-size: 0.75rem;
  }

  .bulk-footer-row .bulk-cell {
    padding: 8px 4px;
    font-size: 0.8rem;
  }

  .bulk-footer-actions {
    gap: 8px;
  }

  .bulk-action-buttons {
    gap: 6px;
  }

  .bulk-footer-actions button {
    padding: 8px 12px;
    font-size: 0.8rem;
    min-height: 36px;
  }

  .bulk-cell-number {
    width: 50px;
  }

  .bulk-cell-customer {
    width: 120px;
    min-width: 120px;
  }

  .bulk-cell-date {
    width: 80px;
    min-width: 80px;
  }

  .bulk-cell-time {
    width: 60px;
    min-width: 60px;
  }

  .bulk-cell-quantity {
    width: 80px;
    min-width: 80px;
  }

  .bulk-cell-fat,
  .bulk-cell-clr,
  .bulk-cell-snf {
    width: 60px;
    min-width: 60px;
  }

  .bulk-cell-fat-kg,
  .bulk-cell-snf-kg {
    width: 70px;
    min-width: 70px;
  }

  .bulk-cell-rate {
    width: 70px;
    min-width: 70px;
  }

  .bulk-cell-amount {
    width: 80px;
    min-width: 80px;
  }
}

/* Mobile Large (576px to 767px) */
@media (max-width: 767px) {
  .bulk-modal-overlay {
    padding: 4px;
    align-items: center;
    justify-content: center;
  }

  .bulk-preview-modal {
    width: 95%;
    max-width: none;
    border-radius: 8px;
    max-height: 95vh;
    margin: auto;
  }

  .bulk-preview-table-container {
    overflow-x: auto;
  }

  .bulk-preview-table {
    width: 100%;
    min-width: 550px;
    font-size: 0.75rem;
    table-layout: auto;
  }

  .bulk-modal-header {
    padding: 12px;
    position: sticky;
    top: 0;
    z-index: 20;
  }

  .bulk-modal-title {
    font-size: 1rem;
  }

  .bulk-close-modal-button {
    width: 32px;
    height: 32px;
    font-size: 0.9rem;
  }

  .bulk-modal-body {
    padding: 8px;
    max-height: calc(95vh - 140px);
    overflow-x: auto;
    overflow-y: auto;
  }

  .bulk-preview-header {
    margin-bottom: 12px;
  }

  .bulk-preview-info {
    font-size: 0.8rem;
    padding: 8px;
  }

  .bulk-header-row .bulk-cell,
  .bulk-table-body .bulk-cell {
    padding: 5px 3px;
    font-size: 0.7rem;
  }

  .bulk-footer-row .bulk-cell {
    padding: 6px 3px;
    font-size: 0.75rem;
  }

  .bulk-modal-footer {
    padding: 12px;
    position: sticky;
    bottom: 0;
    z-index: 20;
  }

  .bulk-footer-actions {
    justify-content: center;
    gap: 6px;
  }

  .bulk-action-buttons {
    gap: 8px;
    flex: 1 1;
    justify-content: center;
  }

  .bulk-footer-actions button {
    padding: 8px 14px;
    font-size: 0.75rem;
    min-height: 32px;
    flex: 1 1;
    min-width: 100px;
  }

  .bulk-footer-actions button span {
    display: inline;
    font-size: 0.55rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bulk-cell-number {
    width: 40px;
  }

  .bulk-cell-customer {
    width: 100px;
    min-width: 100px;
  }

  .bulk-cell-date {
    width: 70px;
    min-width: 70px;
  }

  .bulk-cell-time {
    width: 50px;
    min-width: 50px;
  }

  .bulk-cell-quantity {
    width: 70px;
    min-width: 70px;
  }

  .bulk-cell-fat,
  .bulk-cell-clr,
  .bulk-cell-snf {
    width: 50px;
    min-width: 50px;
  }

  .bulk-cell-fat-kg,
  .bulk-cell-snf-kg {
    width: 60px;
    min-width: 60px;
  }

  .bulk-cell-rate {
    width: 60px;
    min-width: 60px;
  }

  .bulk-cell-amount {
    width: 70px;
    min-width: 70px;
  }

}

/* Mobile Small (480px to 575px) */
@media (max-width: 575px) {
  .bulk-modal-overlay {
    padding: 4px;
    align-items: center;
    justify-content: center;
  }

  .bulk-preview-modal {
    width: 95%;
    max-width: none;
    border-radius: 8px;
    max-height: 95vh;
    margin: auto;
  }

  .bulk-preview-table-container {
    overflow-x: auto;
  }

  .bulk-preview-table {
    width: 100%;
    min-width: 450px;
    font-size: 0.7rem;
    table-layout: auto;
  }

  .bulk-modal-header {
    padding: 10px;
  }

  .bulk-modal-title {
    font-size: 0.95rem;
  }

  .bulk-modal-body {
    padding: 6px;
    max-height: calc(95vh - 130px);
    overflow-x: auto;
    overflow-y: auto;
  }

  .bulk-preview-info {
    font-size: 0.75rem;
    padding: 6px;
  }

  .bulk-header-row .bulk-cell,
  .bulk-table-body .bulk-cell {
    padding: 4px 2px;
    font-size: 0.65rem;
  }

  .bulk-footer-row .bulk-cell {
    padding: 6px 2px;
    font-size: 0.7rem;
  }

  .bulk-modal-footer {
    padding: 8px;
  }

  .bulk-footer-actions {
    gap: 4px;
  }

  .bulk-action-buttons {
    gap: 6px;
    flex-direction: column;
  }

  .bulk-footer-actions button {
    padding: 6px 10px;
    font-size: 0.7rem;
    min-height: 30px;
    min-width: 85px;
  }

  .bulk-footer-actions button span {
    display: inline;
    font-size: 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bulk-cell-number {
    width: 35px;
  }

  .bulk-cell-customer {
    width: 80px;
    min-width: 80px;
  }

  .bulk-cell-date {
    width: 65px;
    min-width: 65px;
  }

  .bulk-cell-time {
    width: 45px;
    min-width: 45px;
  }

  .bulk-cell-quantity {
    width: 65px;
    min-width: 65px;
  }

  .bulk-cell-fat,
  .bulk-cell-clr,
  .bulk-cell-snf {
    width: 45px;
    min-width: 45px;
  }

  .bulk-cell-fat-kg,
  .bulk-cell-snf-kg {
    width: 50px;
    min-width: 50px;
  }

  .bulk-cell-rate {
    width: 50px;
    min-width: 50px;
  }

  .bulk-cell-amount {
    width: 55px;
    min-width: 55px;
  }

}

/* Extra Small Mobile (320px to 479px) */
@media (max-width: 479px) {
  .bulk-modal-overlay {
    padding: 4px;
    align-items: center;
    justify-content: center;
  }

  .bulk-preview-modal {
    width: 95%;
    max-width: none;
    border-radius: 8px;
    max-height: 80vh;
    margin: auto;
  }

  .bulk-preview-table-container {
    overflow-x: auto;
  }

  .bulk-preview-table {
    width: 100%;
    min-width: 380px;
    font-size: 0.65rem;
    table-layout: auto;
  }

  .bulk-modal-title {
    font-size: 0.9rem;
  }

  .bulk-modal-body {
    padding: 4px;
    max-height: calc(80vh - 120px);
    overflow-x: auto;
    overflow-y: auto;
  }

  .bulk-preview-info {
    font-size: 0.7rem;
    padding: 4px;
  }

  .bulk-header-row .bulk-cell,
  .bulk-table-body .bulk-cell {
    padding: 3px 1px;
    font-size: 0.6rem;
  }

  .bulk-footer-row .bulk-cell {
    padding: 4px 1px;
    font-size: 0.65rem;
  }

  .bulk-footer-actions button {
    padding: 4px 8px;
    font-size: 0.65rem;
    min-height: 28px;
    min-width: 75px;
  }

  .bulk-action-buttons {
    gap: 4px;
  }

  .bulk-footer-actions button span {
    display: inline;
    font-size: 0.45rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bulk-cell-number {
    width: 30px;
  }

  .bulk-cell-customer {
    width: 70px;
    min-width: 70px;
  }

  .bulk-cell-date {
    width: 55px;
    min-width: 55px;
  }

  .bulk-cell-time {
    width: 40px;
    min-width: 40px;
  }

  .bulk-cell-quantity {
    width: 55px;
    min-width: 55px;
  }

  .bulk-cell-fat,
  .bulk-cell-clr,
  .bulk-cell-snf {
    width: 40px;
    min-width: 40px;
  }

  .bulk-cell-fat-kg,
  .bulk-cell-snf-kg {
    width: 45px;
    min-width: 45px;
  }

  .bulk-cell-rate {
    width: 45px;
    min-width: 45px;
  }

  .bulk-cell-amount {
    width: 50px;
    min-width: 50px;
  }

}

/* Landscape Orientation Adjustments */
@media (max-height: 600px) and (orientation: landscape) {
  .bulk-modal-overlay {
    padding: 4px;
  }

  .bulk-preview-modal {
    max-height: 95vh;
  }

  .bulk-modal-body {
    max-height: calc(95vh - 120px);
  }

  .bulk-preview-header {
    margin-bottom: 8px;
  }

  .bulk-preview-info {
    padding: 4px 8px;
    font-size: 0.75rem;
  }

  .bulk-header-row .bulk-cell,
  .bulk-table-body .bulk-cell {
    padding: 4px 2px;
    font-size: 0.7rem;
  }

  .bulk-footer-row .bulk-cell {
    padding: 6px 2px;
    font-size: 0.75rem;
  }

  .bulk-modal-header {
    padding: 8px 12px;
  }

  .bulk-modal-footer {
    padding: 8px 12px;
  }

  .bulk-footer-actions button {
    padding: 6px 10px;
    font-size: 0.75rem;
    min-height: 32px;
  }
}

/* Print Styles */
@media print {
  .bulk-modal-overlay {
    position: static;
    background: white;
    padding: 0;
  }

  .bulk-preview-modal {
    box-shadow: none;
    border: 1px solid #000;
    max-height: none;
    width: 100%;
  }

  .bulk-modal-header,
  .bulk-modal-footer {
    display: none;
  }

  .bulk-preview-table {
    min-width: auto;
    width: 100%;
    font-size: 0.8rem;
  }

  .bulk-preview-table-container {
    overflow: visible;
  }
}

.preview-table th:nth-child(1),
/* Serial Number */
.preview-table td:nth-child(1) {
  width: 40px;
  min-width: 40px;
  text-align: center;
}

.preview-table th:nth-child(2),
/* Customer */
.preview-table td:nth-child(2) {
  width: 20%;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* For responsive behavior, adjust the container and table */
.excel-container {
  width: 100%;
  overflow-x: auto;
  padding: 0;
  margin: 0;
}

@media (max-width: 1200px) {
  .excel-table {
    font-size: 12px;
    /* Smaller font on smaller screens */
    width: 100%;
    min-width: 1200px;
  }

  .csv-grid-container {
    overflow-x: auto;
    width: 100%;
  }

  .excel-table th,
  .excel-table td {
    padding: 4px 6px;
    height: 32px;
  }
}

@media (max-width: 992px) {

  .cell-customer select,
  .cell-animal-type select,
  .cell-milk-type select {
    min-width: auto;
    width: 100%;
  }
}

/* Make all inputs more compact */
.excel-table input,
.excel-table select {
  padding: 4px 6px;
  width: 100%;
  box-sizing: border-box;
}

/* Table header font size fix */
.excel-table th {
  font-size: 16px !important;
  font-weight: 600;
}

/* Mobile and tablet font size fix for excel-cell-input */
@media (max-width: 1024px) {

  .excel-cell-input,
  .excel-cell-select {
    font-size: 14px !important;
  }

  .global-time-header-select,
  .global-base-snf-header-select,
  .global-animal-type-header-select {
    font-size: 14px !important;
  }
}

/* Responsive styles */
@media (max-width: 1400px) {
  .bulk-collection-content {
    width: 100%;
    max-width: 100%;
    padding: 0 15px;
  }

  .csv-grid-container {
    max-width: 100%;
    overflow-x: auto;
  }
}

@media (max-width: 1200px) {
  .preview-modal {
    max-width: 95%;
    margin: 15px;
  }

  .preview-table {
    min-width: 800px;
  }
}

@media (max-width: 992px) {
  .preview-modal {
    max-width: 98%;
    margin: 10px;
  }

  .preview-table {
    min-width: 700px;
  }
}

/* Tablet specific styles */
@media (min-width: 769px) and (max-width: 1024px) {
  .bulk-collection-v1-container {
    padding: 1rem;
    padding-top: 60px;
  }

  .dairy-info-wrapper {
    flex-direction: row;
    gap: 1.5rem;
    padding: 1.5rem;
    align-items: flex-start;
    width: 100%;
  }

  .rate-settings-info-card {
    min-height: 110px;
    padding: 1.25rem;
  }

  .rate-settings-info-header {
    margin-bottom: 0.875rem;
  }

  .rate-settings-icon-bg {
    width: 34px;
    height: 34px;
    font-size: 15px;
  }

  .rate-settings-info-title {
    font-size: 1.05rem;
  }

  .rate-settings-checklist li {
    font-size: 0.85rem;
    margin-bottom: 0.45rem;
  }

  .rate-settings-action-btn {
    padding: 11px 18px;
    font-size: 0.85rem;
  }

  .rate-settings-heading {
    font-size: 1.05rem;
    margin-bottom: 0.875rem;
  }

  .rate-settings-primary-btn {
    padding: 11px 22px !important;
    font-size: 0.9rem !important;
    min-width: 130px !important;
  }

  .dairy-info-container {
    flex: 1 1;
    min-width: 0;
    padding: 1.25rem;
    overflow: visible;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    border: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
  }

  .rate-info-container {
    flex: 1 1;
    min-width: 0;
    padding: 1.25rem;
    overflow: visible;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    border: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
  }

  .dairy-info-content {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 0.8rem;
  }

  .dairy-details-bulk,
  .owner-details-bulk {
    gap: 0.6rem;
    flex: 1 1 100%;
  }

  .info-item {
    padding: 0.6rem 0.8rem;
    min-height: auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    flex: 1 1 auto;
    min-width: 0;
  }

  .info-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #6b7280;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .info-value {
    font-size: 0.85rem;
    color: #1f2937;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 1;
    min-width: 0;
  }

  .rate-info-row {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: stretch;
    width: 100%;
  }

  .bulk-preview-settings-button {
    width: 100%;
    max-width: 200px;
    padding: 8px 12px;
    font-size: 0.85rem;
  }

  .rate-info-item {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-width: 0;
    width: 100%;
  }

  .current-rate-info {
    padding: 1rem;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
  }

  .rate-type-input-group {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    width: 100%;
    align-items: center;
  }

  .rate-type-input-group label {
    font-size: 0.8rem;
    font-weight: 600;
    color: #374151;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .rate-type-select {
    flex: 1 1;
    min-width: 0;
    padding: 0.5rem;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 0.9rem;
    background: white;
  }

  .submit-btn {
    width: 100%;
    padding: 0.6rem 1rem;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 0.5rem;
  }

  .submit-btn:hover {
    background: linear-gradient(135deg, #059669 0%, #047857 100%);
    transform: translateY(-1px);
  }

  .submit-btn:disabled {
    background: #9ca3af;
    cursor: not-allowed;
    transform: none;
  }

  .dairy-details-bulk,
  .owner-details-bulk {
    gap: 0.6rem;
  }

  .info-item {
    padding: 0.6rem 1rem;
    min-height: 40px;
  }

  .info-icon {
    font-size: 0.9rem;
    width: 18px;
  }

  .info-label {
    font-size: 0.8rem;
  }

  .info-value {
    font-size: 0.9rem;
    gap: 1rem;
  }

  .add-money-btn {
    padding: 0.35rem 0.6rem;
    font-size: 0.75rem;
    height: 30px;
    min-width: 80px;
  }

  .current-rate-info {
    padding: 1rem;
  }

  .rate-info-item {
    padding: 0.8rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .rate-info-item .rate-type-dropdown {
    width: 100%;
  }

  .rate-info-item .submit-btn {
    margin-top: 0.5rem;
    width: 100%;
  }

  .collection-controls {
    flex-direction: column;
    gap: 1rem;
  }

  .customer-management,
  .rate-configuration {
    width: 100%;
  }

  .preview-table {
    min-width: 600px;
    font-size: 0.9rem;
  }

  .preview-table th,
  .preview-table td {
    padding: 10px 8px;
    font-size: 0.85rem;
  }
}

@media (max-width: 768px) {
  .bulk-collection-v1-container {
    padding: 10px;
    padding-top: 56px;
  }

  .bulk-collection-content {
    padding: 0 5px;
  }

  .excel-toolbar {
    flex-direction: column;
    gap: 10px;
  }

  .toolbar-left {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    width: 100%;
  }

  .toolbar-left .add-row-button,
  .toolbar-left .submit-preview-button {
    flex: 1 1;
    min-width: 0;
    width: 48%;
    /* 50-50 layout with small gap */
    max-width: 48%;
    justify-content: center;
    padding: 10px 8px;
    font-size: 12px;
    min-height: 44px;
  }

  .toolbar-right {
    justify-content: center;
    width: 100%;
    margin-left: 0;
  }

  .date-time-controls {
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px;
    padding: 4px 8px;
  }

  .date-control,
  .time-control {
    min-width: 60px;
  }

  .toolbar-date-input,
  .toolbar-time-input {
    width: 100%;
    height: 20px;
    font-size: 10px;
    /* padding: 2px 4px;
     */
    margin: 0;
    box-sizing: border-box;
  }

  .add-row-button,
  .preview-button {
    width: 100%;
    justify-content: center;
  }

  .preview-modal,
  .new-customer-modal {
    padding: 1rem;
    margin-bottom: 20px;
  }

  .bulk-collection-header .bulk-heading {
    font-size: 20px;
  }

  .back-button-bulk {
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
  }

  .dairy-info-container {
    padding: 0.6rem;
    min-height: 90px;
  }

  .dairy-info-content {
    flex-direction: column !important;
    gap: 0.6rem;
  }

  .dairy-details-bulk,
  .owner-details-bulk {
    min-width: 100%;
    flex-direction: column;
    gap: 0.4rem;
  }

  .info-item {
    gap: 0.3rem;
  }

  .info-label {
    font-size: 0.65rem;
  }

  .info-value {
    gap: 0.8rem;
  }

  .add-money-btn {
    padding: 0.3rem 0.5rem;
    font-size: 0.7rem;
    font-weight: 600;
    border-radius: 6px;
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    color: white;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(40, 167, 69, 0.15);
    flex-shrink: 0;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    min-width: 70px;
  }

  .add-money-btn:hover {
    background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(40, 167, 69, 0.3);
  }

  .rate-info-row {
    flex-direction: row;
    gap: 0.8rem;
  }
}


/* Preview modal */
.preview-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8eaed;
  width: 100%;
}

.preview-info {
  margin-bottom: 0;
  color: #5f6368;
  font-size: 14px;
  display: block;
  width: 100%;
}

.preview-table-container {
  overflow-x: auto;
  margin-bottom: 20px;
  border-radius: 4px;
  border: 1px solid #e8eaed;
  margin-top: 0;
  display: block;
  width: 100%;
  /* Remove max-height to prevent scrolling issues on desktop */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.preview-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  min-width: 1000px;
  /* Increased from 900px to accommodate the new CLR column */
}

.preview-table th,
.preview-table td {
  padding: 14px 16px;
  border-bottom: 1px solid #e8eaed;
  white-space: nowrap;
}

/* Column width adjustments for preview table */
.preview-table th:nth-child(1),
/* Customer */
.preview-table td:nth-child(1) {
  width: 22%;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.preview-table th:nth-child(2),
/* Date */
.preview-table td:nth-child(2) {
  width: 11%;
}

.preview-table th:nth-child(3),
/* Time */
.preview-table td:nth-child(3) {
  width: 9%;
}

.preview-table th:nth-child(4),
/* Weight */
.preview-table th:nth-child(5),
/* Fat % */
.preview-table th:nth-child(6),
/* CLR */
.preview-table th:nth-child(7),
/* SNF % */
.preview-table td:nth-child(4),
.preview-table td:nth-child(5),
.preview-table td:nth-child(6),
.preview-table td:nth-child(7) {
  width: 9%;
  text-align: right;
}

.preview-table th:nth-child(8),
/* Rate */
.preview-table th:nth-child(9),
/* Amount */
.preview-table td:nth-child(8),
.preview-table td:nth-child(9) {
  width: 10.5%;
  text-align: right;
}

.preview-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #3c4043;
  font-size: 14px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.preview-table tbody tr:hover {
  background-color: #f8f9fa;
}

.preview-table tfoot tr {
  font-weight: 600;
}

.preview-table tfoot td {
  padding: 16px;
  border-top: 2px solid #e8eaed;
}

.total-label {
  text-align: right;
  color: #3c4043;
  font-weight: 500;
}

.total-value {
  color: #1a73e8;
  font-weight: 700;
}

/* Preview table styles */
.preview-modal .preview-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1300px;
  /* Increased to match modal width */
}

.preview-modal .preview-table th,
.preview-modal .preview-table td {
  padding: 8px 4px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
}

.preview-modal .preview-table th:first-child,
.preview-modal .preview-table td:first-child {
  width: 18%;
  max-width: 250px;
}

.preview-modal .preview-table th:nth-child(2),
.preview-modal .preview-table td:nth-child(2) {
  width: 10%;
}

.preview-modal .preview-table th:nth-child(3),
.preview-modal .preview-table td:nth-child(3) {
  width: 8%;
}

.preview-modal .preview-table th:nth-child(4),
.preview-modal .preview-table td:nth-child(4),
.preview-modal .preview-table th:nth-child(5),
.preview-modal .preview-table td:nth-child(5),
.preview-modal .preview-table th:nth-child(6),
.preview-modal .preview-table td:nth-child(6),
.preview-modal .preview-table th:nth-child(7),
.preview-modal .preview-table td:nth-child(7),
.preview-modal .preview-table th:nth-child(8),
.preview-modal .preview-table td:nth-child(8),
.preview-modal .preview-table th:nth-child(9),
.preview-modal .preview-table td:nth-child(9) {
  width: 8%;
  text-align: right;
}

.preview-modal .preview-table th:nth-child(10),
.preview-modal .preview-table td:nth-child(10),
.preview-modal .preview-table th:nth-child(11),
.preview-modal .preview-table td:nth-child(11) {
  width: 9%;
  text-align: right;
}

/* For read-only calculated fields */
input.excel-cell-input[readonly] {
  background-color: #f8f9fa;
  color: #495057;
  cursor: default;
  border: 1px solid #e0e0e0;
}

/* Highlight calculated SNF fields */
.calculated-cell input[readonly] {
  background-color: #e8f4ff;
  border-color: #b8daff;
  font-weight: 500;
}

/* Full-screen loading overlay */
.submission-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  backdrop-filter: blur(4px);
}

.submission-spinner {
  border: 6px solid rgba(255, 255, 255, 0.3);
  border-top: 6px solid #007bff;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.submission-message {
  color: white;
  font-size: 18px;
  text-align: center;
  max-width: 80%;
  margin-bottom: 15px;
  font-weight: 500;
}

.submission-progress {
  color: #fff;
  font-size: 14px;
  margin-top: 10px;
}

.global-button {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: all 0.2s;
  cursor: pointer;
  white-space: nowrap;
}

.add-customer-button {
  background-color: #17a2b8;
  color: white;
  width: 100%;
  justify-content: center;
}

.add-customer-button:hover {
  background-color: #138496;
}

.add-customer-button svg {
  margin-right: 8px;
}

/* Delete Confirmation Modal Styles */
.delete-confirmation-modal {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 420px;
  margin: auto;
  overflow: hidden;
  animation: modalPop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transform-origin: center;
}

@keyframes modalPop {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.warning-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  color: #343a40;
  display: flex;
  align-items: center;
  padding: 18px 24px;
  position: relative;
}

.warning-header h2 {
  font-size: 18px;
  margin: 0;
  font-weight: 600;
}

.warning-icon {
  font-size: 22px;
  margin-right: 12px;
  color: #e74c3c;
}

.delete-confirmation-modal .modal-body {
  padding: 28px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
}

.confirmation-icon-container {
  margin-bottom: 20px;
  width: 64px;
  height: 64px;
  background-color: rgba(231, 76, 60, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-text {
  color: #e74c3c;
  font-weight: 600;
  margin-bottom: 16px;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: rgba(231, 76, 60, 0.08);
  font-size: 15px;
  border-left: 3px solid #e74c3c;
  width: 100%;
  max-width: 90%;
  text-align: left;
}


.delete-confirmation-modal .modal-body p:last-child {
  margin-bottom: 0;
  color: #495057;
  font-size: 15px;
}

.delete-confirmation-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px 20px;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.delete-confirmation-modal .cancel-button {
  background-color: #f8f9fa;
  color: #495057;
  border: 1px solid #ced4da;
  padding: 10px 16px;
  border-radius: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
  margin-right: 12px;
}

.delete-confirmation-modal .cancel-button:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

.delete-confirmation-modal .delete-button {
  background-color: #e74c3c;
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(231, 76, 60, 0.2);
}

.delete-confirmation-modal .delete-button:hover {
  background-color: #c0392b;
  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.3);
}

.delete-button svg {
  font-size: 14px;
  margin-right: 8px;
}

.cancel-button svg {
  font-size: 14px;
  margin-right: 8px;
}

.delete-confirmation-modal .close-modal-button {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #6c757d;
  transition: all 0.2s;
}

.delete-confirmation-modal .close-modal-button:hover {
  background-color: rgba(108, 117, 125, 0.1);
  color: #343a40;
}

/* Add styles for the low balance alert popup */
.alert-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease;
}

.alert-popup {
  background-color: #fff;
  width: 90%;
  max-width: 400px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: slideUp 0.3s ease;
}

.alert-popup-header {
  background-color: #f8d7da;
  color: #721c24;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f5c6cb;
}

.alert-popup-header h3 {
  margin: 0;
  font-size: 18px;
  flex-grow: 1;
}

.alert-icon {
  margin-right: 10px;
  font-size: 20px;
}

.close-alert-button {
  background: none;
  border: none;
  color: #721c24;
  cursor: pointer;
  font-size: 16px;
  padding: 0;
  margin-left: 10px;
}

.alert-popup-body {
  padding: 20px;
  color: #333;
}

.alert-balance {
  margin-top: 15px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.low-balance-amount {
  font-weight: bold;
  color: #dc3545;
  font-size: 18px;
}

.alert-popup-footer {
  padding: 15px 20px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #e9ecef;
}

.close-alert-btn {
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 20px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.close-alert-btn:hover {
  background-color: #5a6268;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Date input wrapper styles */
.date-input-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.date-input-wrapper input[type="date"] {
  width: 100%;
  cursor: pointer;
  padding-right: 30px;
  /* Make room for the calendar icon */
  position: relative;
  z-index: 1;
  /* Ensure the input is clickable */
}

/* Style to make it more obvious the entire field is clickable */
.date-input-wrapper::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 30px;
  /* Width of the clickable area on the right */
  background-color: transparent;
  cursor: pointer;
  pointer-events: none;
  /* Allow clicks to pass through to the input */
}

/* Delete confirmation modal styles */
.confirmation-modal {
  background-color: white;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.confirmation-modal .modal-header {
  background-color: #f8f9fa;
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef;
}

.confirmation-modal .modal-header h3 {
  margin: 0;
  color: #343a40;
}

.confirmation-modal .modal-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.confirmation-modal .modal-body p {
  margin-bottom: 10px;
}

.confirmation-modal .warning-text {
  color: #dc3545;
  font-weight: bold;
  margin-top: 10px;
  background-color: rgba(220, 53, 69, 0.1);
  padding: 8px 12px;
  border-radius: 4px;
  border-left: 3px solid #dc3545;
}

.confirmation-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 15px 20px;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
  gap: 10px;
}

.confirmation-modal .cancel-button {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.confirmation-modal .delete-button {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.confirmation-modal .cancel-button:hover {
  background-color: #5a6268;
}

.confirmation-modal .delete-button:hover {
  background-color: #c82333;
}

/* Confirmation Modal Styles */
.confirmation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  padding: 16px;
}

.confirmation-modal-container {
  background: white;
  width: 100%;
  max-width: 350px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.confirmation-modal-header {
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}

.confirmation-modal-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.confirmation-modal-close-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #666;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
}

.confirmation-modal-close-btn:hover {
  background: #f5f5f5;
}

.confirmation-modal-body {
  padding: 16px 20px;
  text-align: center;
}

.confirmation-modal-message {
  font-size: 14px;
  color: #333;
  margin-bottom: 12px;
  font-weight: 500;
}

.confirmation-modal-value-display {
  background: #0047AB;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 12px;
}

.confirmation-modal-description {
  font-size: 12px;
  color: #666;
  margin: 0;
}

.confirmation-modal-footer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
}

.confirmation-modal-cancel-btn {
  padding: 10px 16px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-weight: 500;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.confirmation-modal-cancel-btn:hover {
  background: #f8f9fa;
}

.confirmation-modal-confirm-btn {
  padding: 10px 16px;
  background-color: #0047AB;
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.confirmation-modal-confirm-btn:hover {
  background-color: #003680;
}

/* Total row styles */
.excel-table tfoot {
  background-color: #f0f7ff;
  border-top: 2px solid #d0e3ff;
}

.excel-table .total-row {
  font-weight: bold;
  background-color: #f0f7ff;
}

.excel-table .total-label {
  text-align: right;
  padding-right: 15px;
  font-weight: bold;
  color: #333;
}

.excel-table .total-value {
  text-align: left;
  font-weight: bold;
  font-size: 1.1em;
  color: #0056b3;
}

/* Add styles for the weight and amount totals */
.excel-table .total-value.weight-total {
  color: #116644;
  font-size: 1.15em;
  background-color: #e3f5ee;
  border-radius: 4px;
  padding: 5px 10px;
}

.excel-table .total-value.amount-total {
  color: #662211;
  font-size: 1.15em;
  background-color: #f9e8e3;
  border-radius: 4px;
  padding: 5px 10px;
}

@media(max-width: 768px) {
  .bulk-collection-header {
    flex-direction: row;
    gap: 0.5rem;
    padding: 0.75rem;
    align-items: center;
    min-height: auto;
    justify-content: space-between;
    position: relative;
    z-index: 1001;
  }

  .bulk-collection-header .bulk-heading {
    font-size: 20px !important;
    /* Increased from 16px */
    text-align: center;
    order: 2;
    margin: 0;
    line-height: 1.2;
    padding: 0.25rem 0;
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .back-button-bulk {
    order: 1;
    align-self: center;
    padding: 0.4rem 0.8rem !important;
    font-size: 12px !important;
    white-space: nowrap;
    margin: 0;
    flex-shrink: 0;
  }

  .bulk-collection-header .header-actions {
    order: 3;
    align-self: center;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
  }

  /* Mobile header actions styling */
  .bulk-collection-header .header-actions .lang-btn {
    padding: 0.3rem 0.6rem;
    font-size: 11px;
    white-space: nowrap;
  }

  .bulk-collection-header .profile-button {
    padding: 0.3rem 0.6rem;
    font-size: 11px;
  }

  .bulk-collection-header .profile-icon {
    font-size: 14px;
  }
}

/* Tablet responsive styles - maintain desktop layout */
@media (min-width: 769px) and (max-width: 1024px) {

  /* Keep desktop layout for tablets */
  .bulk-collection-header {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    height: 70px;
  }

  .bulk-collection-header .bulk-heading {
    font-size: 20px;
    text-align: center;
    flex: 1 1;
    order: 2;
  }

  .back-button-bulk {
    order: 1;
    padding: 8px 12px;
    font-size: 14px;
  }

  .bulk-collection-header .header-actions {
    order: 3;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  /* Keep cards in desktop layout for tablets */
  .dairy-info-wrapper {
    flex-direction: row;
    gap: 1rem;
    padding: 1rem;
  }

  .rate-settings-modern-card,
  .wallet-simple-card {
    flex: 0 1 280px;
    min-height: 120px;
    /* padding: 0.875rem; */
  }

  .rate-settings-info-card,
  .wallet-info-card {
    min-height: 120px;
    padding: 1rem;
  }

  /* Keep desktop font sizes for tablets */
  .rate-settings-title,
  .wallet-title {
    font-size: 0.95rem;
  }

  .rate-settings-info-title {
    font-size: 1rem;
  }

  .rate-card-title h4,
  .wallet-card-title h4 {
    font-size: 1rem;
  }

  /* Keep desktop icon sizes for tablets */
  .rate-settings-icon-bg,
  .wallet-icon-bg {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  .rate-card-icon,
  .wallet-card-icon {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  /* Keep desktop button sizes for tablets */
  .rate-settings-action-button,
  .wallet-action-button {
    padding: 8px 12px;
    font-size: 0.75rem;
    min-height: 44px;
    margin-top: 0.75rem;
  }

  /* Keep desktop spacing for tablets */
  .rate-card-content,
  .wallet-card-content {
    padding: 0.5rem 0;
  }

  .dairy-owner-info-card,
  .current-rate-info-card-bulk {
    margin-bottom: 12px;
    padding: 12px;
    min-height: 80px;
  }
}

/* Additional mobile responsive styles */
@media(max-width: 768px) {
  .dairy-info-wrapper {
    flex-direction: column;
    gap: 0.5rem;
    /* Reduced gap for more compact layout */
  }

  /* Make cards smaller and more compact for mobile */
  .rate-settings-modern-card {
    min-height: 60px;
    /* Further reduced from 80px */
    padding: 0.4rem;
    /* Reduced from 0.5rem */
    flex: 1 1;
    width: 100%;
  }

  .rate-settings-info-card {
    min-height: 60px;
    /* Further reduced from 80px */
    padding: 0.4rem;
    /* Reduced from 0.6rem */
  }

  .rate-settings-info-header {
    margin-bottom: 0.3rem;
    /* Reduced from 0.5rem */
  }

  .rate-settings-icon-bg {
    width: 20px;
    /* Further reduced from 24px */
    height: 20px;
    /* Further reduced from 24px */
    font-size: 10px;
    /* Reduced from 12px */
  }

  .rate-settings-info-title {
    font-size: 0.8rem;
    /* Reduced from 0.9rem */
  }

  .rate-settings-checklist li {
    font-size: 0.7rem;
    /* Reduced from 0.75rem */
    margin-bottom: 0.2rem;
    /* Reduced from 0.3rem */
  }

  .rate-settings-action-btn {
    padding: 6px 8px;
    /* Reduced from 8px 12px */
    font-size: 0.7rem;
    min-height: 30px;
    /* Reduced from 36px */
  }

  /* Make wallet card smaller */
  .wallet-simple-card {
    min-height: 50px;
    padding: 8px 12px;
    flex: 1 1;
    width: 100%;
  }

  .wallet-top-right {
    /* position: fixed; */
    /* z-index: 100; */
    margin: auto;
    top: 60px;
    right: 8px;
    padding: 6px 10px;
  }

  .wallet-top-right .wallet-info {
    gap: 4px;
  }

  .wallet-top-right .icon-wallet {
    font-size: 12px;
  }


  .wallet-top-right .wallet-info span:last-child {
    font-size: 0.7rem;
  }

  .wallet-info-card {
    min-height: 60px;
    /* Further reduced from 80px */
    padding: 0.4rem;
    /* Reduced from 0.6rem */
  }

  .wallet-info-header {
    margin-bottom: 0.3rem;
    /* Reduced from 0.5rem */
  }

  .wallet-icon-bg {
    width: 20px;
    /* Further reduced from 24px */
    height: 20px;
    /* Further reduced from 24px */
    font-size: 10px;
    /* Reduced from 12px */
  }

  .wallet-title {
    font-size: 0.8rem;
    /* Reduced from 0.9rem */
  }

  .wallet-description {
    font-size: 0.7rem;
    /* Reduced from 0.75rem */
  }

  .wallet-balance-amount {
    font-size: 0.9rem;
    /* Reduced from 1rem */
  }

  .wallet-balance-label {
    font-size: 0.65rem;
    /* Reduced from 0.7rem */
  }

  /* Make dairy info cards smaller */
  .dairy-owner-info-card,
  .current-rate-info-card-bulk {
    margin-bottom: 6px;
    /* Reduced from 8px */
    padding: 0.4rem;
    /* Reduced from 0.6rem */
    min-height: 50px;
    /* Further reduced from 60px */
  }

  /* Reduce card title sizes */
  .rate-card-title h4,
  .wallet-card-title h4 {
    font-size: 0.8rem;
    /* Reduced from 0.9rem */
  }

  .rate-card-title p,
  .wallet-card-title p {
    font-size: 0.65rem;
    /* Reduced from 0.7rem */
  }

  /* Make card icons smaller */
  .rate-card-icon,
  .wallet-card-icon {
    width: 28px;
    /* Further reduced from 32px */
    height: 28px;
    /* Further reduced from 32px */
    font-size: 12px;
    /* Reduced from 14px */
  }

  /* Reduce card content padding */
  .rate-card-content,
  .wallet-card-content {
    padding: 0.3rem 0;
    /* Reduced from 0.5rem 0 */
  }

  /* Make action buttons smaller */
  .rate-settings-action-button,
  .wallet-action-button {
    padding: 4px 8px;
    /* Reduced from 6px 10px */
    font-size: 0.65rem;
    /* Reduced from 0.7rem */
    min-height: 28px;
    /* Reduced from 32px */
    margin-top: 0.3rem;
    /* Reduced from 0.5rem */
  }

  /* Improved mobile spacing and touch targets */
  .bulk-collection-v1-container {
    padding: 8px !important;
    padding-top: 56px !important;
  }

  .bulk-collection-content {
    padding: 0 2px;
  }

  /* Better mobile table responsiveness */
  .excel-table {
    font-size: 12px;
  }

  .excel-table th,
  .excel-table td {
    padding: 6px 4px;
    height: 40px;
  }

  .excel-cell-input,
  .excel-cell-select {
    font-size: 14px !important;
    padding: 8px 6px;
  }

  /* Improved mobile button sizing */
  .add-row-button,
  .preview-button {
    padding: 10px 14px;
    font-size: 12px;
    min-height: 44px;
    /* Better touch target */
  }

  /* Mobile modal improvements */
  .modal-content {
    width: 95%;
    margin: 10px auto;
    max-height: 90vh;
  }

  .modal-header {
    padding: 12px 16px;
  }

  .modal-body {
    padding: 16px;
  }

  .modal-footer {
    padding: 12px 16px;
    flex-direction: column;
    gap: 8px;
  }

  .modal-footer button {
    width: 100%;
    min-height: 44px;
  }

  /* Better mobile form inputs */
  .global-input {
    padding: 12px;
    font-size: 16px;
    /* Prevents zoom on iOS */
    min-height: 44px;
  }

  .global-button {
    padding: 12px 16px;
    font-size: 14px;
    min-height: 44px;
  }

  /* Mobile dropdown improvements */
  .excel-dropdown {
    max-height: 150px;
  }

  .dropdown-item {
    padding: 12px;
    font-size: 14px;
    min-height: 44px;
    display: flex;
    align-items: center;
  }

  /* Better mobile card spacing */
  .dairy-owner-info-card,
  .current-rate-info-card-bulk {
    margin-bottom: 12px;
    padding: 12px;
  }

  /* Mobile-specific utility classes */
  .mobile-hidden {
    display: none;
  }

  .mobile-full-width {
    width: 100%;
  }

  .mobile-text-center {
    text-align: center;
  }

  .mobile-stack {
    flex-direction: column;
  }

  /* Improved mobile navigation */
  .back-button-bulk {
    min-width: 80px;
    justify-content: center;
  }

  /* Better mobile profile dropdown */
  .profile-dropdown {
    z-index: 1003;
  }

  .profile-menu {
    right: 0;
    min-width: 200px;
    max-width: 250px;
  }

  /* Mobile-specific rate settings modal */
  .change-rates-modal-bulkcollection {
    width: 98%;
    max-width: none;
    margin: 5px auto;
    max-height: 95vh;
  }

  .change-rates-section-bulkcollection {
    margin-bottom: 8px;
    padding: 8px;
  }

  .option-btn {
    padding: 12px 8px;
    font-size: 12px;
    min-height: 44px;
  }
}

.rate-settings-heading {
  font-size: 1rem;
  margin-bottom: 0.75rem;
}

.rate-settings-primary-btn {
  padding: 10px 20px !important;
  font-size: 0.85rem !important;
  min-width: 120px !important;
}

.dairy-info-container {
  width: 100%;
  padding: 0.75rem;
  overflow: visible;
}

.dairy-info-content {
  flex-direction: column;
  gap: 0.4rem;
}

.info-item {
  padding: 0.4rem 0.6rem;
  min-height: 32px;
  overflow: visible;
  white-space: normal;
}

.info-label {
  font-size: 0.7rem;
  margin-right: 0.25rem;
}

.info-value {
  font-size: 0.75rem;
  gap: 0.4rem;
  overflow: visible;
}

.add-money-btn {
  padding: 0.2rem 0.4rem;
  font-size: 0.65rem;
  height: 24px;
  min-width: 60px;
}

.rate-type-input-group {
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.rate-info-row {
  display: flex;
  flex-direction: row;
}

.save-rate-button-bulk {
  width: 80%;
  padding: 5px 7px;
  text-align: center;
  justify-content: center;
  align-items: center;
}



@media(width: 768px) {
  .bulk-collection-header {
    padding: 1rem 1.5rem;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(135deg, #0056b3 0%, #003d82 100%);
    border-radius: 0 0 16px 16px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  }

  .bulk-collection-header .bulk-heading {
    font-size: 18px !important;
    text-align: center;
    order: unset;
    margin: 0;
    line-height: 1.3;
    padding: 0;
    font-weight: 600;
    letter-spacing: -0.3px;
    flex: 1 1;
  }

  .back-button-bulk {
    order: unset;
    align-self: auto;
    padding: 0.5rem 1rem !important;
    font-size: 13px !important;
    white-space: nowrap;
    margin: 0;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  .bulk-collection-header .header-actions {
    order: unset;
    align-self: auto;
    display: flex;
    align-items: center;
    margin: 0;
  }

  .dairy-info-wrapper {
    flex-direction: row;
    gap: 1.5rem;
    padding: 1.5rem;
    align-items: flex-start;
    width: 100%;
  }

  .dairy-info-container {
    flex: 1 1;
    min-width: 0;
    padding: 1.5rem;
    overflow: visible;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    border: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
  }

  .dairy-info-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex: 1 1;
  }

  .dairy-details-bulk {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
    margin-bottom: 1rem;
  }

  .owner-details-bulk {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
  }

  .info-item {
    padding: 0.75rem 1rem;
    min-height: 44px;
    overflow: hidden;
    white-space: nowrap;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1 1;
    min-width: 0;
    transition: all 0.2s ease;
  }

  .info-item:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: #e0e0e0;
  }

  .info-label {
    font-size: 0.85rem;
    margin-right: 0.6rem;
    color: #666;
    font-weight: 600;
    flex-shrink: 0;
  }

  .info-value {
    font-size: 0.95rem;
    gap: 0.6rem;
    overflow: hidden;
    font-weight: 700;
    color: #333;
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .add-money-btn {
    padding: 0.4rem 0.8rem;
    font-size: 0.75rem;
    height: 32px;
    min-width: 80px;
    border-radius: 8px;
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    box-shadow: 0 3px 8px rgba(40, 167, 69, 0.2);
    flex-shrink: 0;
    transition: all 0.2s ease;
  }

  .add-money-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
  }

  .current-rate-info {
    flex: 1 1;
    min-width: 0;
    padding: 1.25rem;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    border: 1px solid #e5e7eb;
  }

  .rate-info-item {
    padding: 1rem;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 10px;
    border: 1px solid #f0f0f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .rate-type-input-group {
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
  }

  .rate-info-row {
    flex-direction: row;
    align-items: stretch;
    gap: 0.75rem;
  }

  .collection-controls {
    padding: 1rem 1.5rem;
    gap: 1rem;
  }

  .preview-table {
    font-size: 0.9rem;
    min-width: 700px;
  }

  .preview-table th,
  .preview-table td {
    padding: 12px 10px;
    font-size: 0.85rem;
  }
}

@media (max-width: 576px) {
  .bulk-collection-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

}

/* Change Rates Modal Styles */
.change-rates-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
  font-size: 0.8rem;
}

.change-rates-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e0e0e0;
  background: #007bff;
  border-radius: 12px 12px 0 0;
}

.change-rates-header h3 {
  margin: 0;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
}

.change-rates-body {
  padding: 20px;
  font-size: 0.8rem;
}

/* Premium Change Rates Section - Compact */
.change-rates-section {
  margin-bottom: 1.5rem;
  padding: 1rem;
  border: 1px solid rgba(59, 130, 246, 0.15);
  border-radius: 10px;
  background: linear-gradient(135deg, #f8faff 0%, #ffffff 100%);
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.change-rates-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #8b5cf6 0%, #ec4899 100%);
}

.change-rates-section h4 {
  margin: 0 0 0.75rem 0;
  color: #1e293b;
  font-size: 1rem;
  font-weight: 700;
  background: linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-description {
  margin: 0 0 1rem 0;
  color: #64748b;
  font-size: 0.85rem;
  line-height: 1.4;
  font-weight: 500;
}

.option-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.option-btn {
  flex: 1 1;
  min-width: 80px;
  padding: 0.5rem 0.75rem;
  border: 2px solid rgba(148, 163, 184, 0.3);
  border-radius: 6px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
  position: relative;
  overflow: hidden;
}

.option-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.1), transparent);
  transition: left 0.5s ease;
}

.option-btn:hover {
  border-color: #3b82f6;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  color: #1e40af;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
}

.option-btn:hover::before {
  left: 100%;
}

.option-btn.active {
  border-color: #3b82f6 !important;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
  color: white !important;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
}

.edit-rate-btn {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
  font-size: 0.75rem;
}

.edit-rate-btn:hover {
  background-color: #e3f2fd;
}

.option-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.option-btn {
  padding: 10px 16px;
  border: 2px solid #007bff;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.8rem;
  font-weight: 500;
  color: #007bff;
  flex: 1 1;
  min-width: 150px;
}

.option-btn:hover {
  border-color: #0056b3;
  background: #e3f2fd;
  color: #0056b3;
}

.option-btn.active {
  border-color: #007bff;
  background: #007bff;
  color: white;
}

.change-rates-footer {
  padding: 16px 20px;
  border-top: 1px solid #e0e0e0;
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;
  display: flex;
  justify-content: flex-end;
}

.change-rates-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.change-rates-button:hover {
  background: #0056b3;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Make content smaller overall */
.bulk-collection-v1-container {
  font-size: 0.85rem !important;
}

.bulk-collection-v1-container .global-heading {
  font-size: 1.5rem !important;
}

.bulk-collection-v1-container .section-title {
  font-size: 1.1rem !important;
}

.bulk-collection-v1-container .global-input {
  padding: 8px 12px !important;
  font-size: 0.85rem !important;
}

.bulk-collection-v1-container .global-button {
  padding: 8px 12px !important;
  font-size: 0.85rem !important;
}

/* Bulk Data Table Styling - Same as ProRataCollection */
.bulk-data-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1200px;
  margin-bottom: 50px;
  table-layout: fixed;
  /* Ensure minimum width to fit all columns */
}

.bulk-data-table th,
.bulk-data-table td {
  border: 1px solid #dee2e6;
  padding: 0;
  position: relative;
  height: 32px;
  overflow: visible;
  font-size: 12px;
}

.bulk-data-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}

.bulk-data-table th:hover {
  background-color: #e9ecef;
}

.bulk-data-table th:nth-child(2):hover {
  background-color: #e3f2fd;
  cursor: pointer;
}

.bulk-data-table th:nth-child(2):active {
  background-color: #bbdefb;
}

.bulk-data-table th:nth-child(3):hover {
  background-color: #fff3e0;
  cursor: pointer;
}

.bulk-data-table th:nth-child(3):active {
  background-color: #ffe0b2;
}

.bulk-data-table th:nth-child(10):hover {
  background-color: #e8f5e8;
  cursor: pointer;
}

.bulk-data-table th:nth-child(10):active {
  background-color: #c8e6c9;
}

.bulk-data-table th:nth-child(11):hover {
  background-color: #fff3e0;
  cursor: pointer;
}

.bulk-data-table th:nth-child(11):active {
  background-color: #ffe0b2;
}

.bulk-data-table th {
  padding: 6px 3px;
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 2px solid #dee2e6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px !important;
  /* Updated from 18px */
  font-weight: 600;
}

.bulk-data-table tbody {
  max-height: 400px;
  overflow-y: auto;
}

.bulk-data-table .bulk-data-row:hover {
  background-color: #f5f9fc;
}

.bulk-data-table .bulk-data-row:nth-child(even) {
  background-color: #f9f9f9;
}

.bulk-data-table .bulk-data-row:nth-child(even):hover {
  background-color: #f0f5fa;
}

.bulk-data-table td.bulk-collection-has-error {
  background-color: rgba(255, 0, 0, 0.05);
}

.bulk-text-input,
.bulk-select-input {
  width: 100%;
  height: 100%;
  padding: 0 4px;
  border: none;
  background: transparent;
  font-size: 16px !important;
}

.bulk-collection-excel-cell-input,
.bulk-collection-excel-cell-select,
.bulk-collection-text-input {
  width: 100%;
  height: 100%;
  padding: 0 4px;
  border: none;
  background: transparent;
  font-size: 16px !important;
}

.bulk-text-input:disabled,
.bulk-select-input:disabled,
.bulk-collection-excel-cell-input:disabled,
.bulk-collection-excel-cell-select:disabled,
.bulk-collection-text-input:disabled {
  background-color: #f5f5f5;
  color: #9e9e9e;
  cursor: not-allowed;
  opacity: 0.7;
  border-left: 2px solid #e0e0e0;
}

.bulk-text-input:focus,
.bulk-select-input:focus,
.bulk-collection-excel-cell-input:focus,
.bulk-collection-excel-cell-select:focus,
.bulk-collection-text-input:focus {
  outline: none;
  box-shadow: inset 0 0 0 2px #4d90fe;
}

.bulk-select-input,
.bulk-collection-excel-cell-select {
  appearance: none;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 6px center;
  background-size: 12px;
  padding-right: 24px;
}

.bulk-collection-calculated-cell {
  position: relative;
}

.bulk-collection-calc-indicator {
  position: absolute;
  top: 0;
  right: 2px;
  color: #0066cc;
  font-size: 12px;
  font-weight: bold;
}

.bulk-collection-calc-indicator.auto {
  color: #28a745;
  background-color: rgba(40, 167, 69, 0.1);
  padding: 0 4px;
  border-radius: 2px;
  right: 4px;
  top: 2px;
  font-size: 10px;
}

.bulk-collection-calculated-cell .bulk-text-input:disabled,
.bulk-collection-calculated-cell .bulk-collection-excel-cell-input:disabled,
.bulk-collection-calculated-cell .bulk-collection-text-input:disabled {
  background-color: #f0f8ff;
  /* Light blue background */
  color: #006699;
  border-left: 2px solid #4dabf7;
  opacity: 0.8;
}

.bulk-text-input.bulk-collection-auto-calculated,
.bulk-collection-excel-cell-input.bulk-collection-auto-calculated,
.bulk-collection-text-input.bulk-collection-auto-calculated {
  background-color: #f0f8ff;
  font-style: italic;
}

.bulk-collection-disabled-field {
  position: relative;
  width: 100%;
  height: 100%;
}

.bulk-text-input.bulk-collection-disabled-input,
.bulk-collection-excel-cell-input.bulk-collection-disabled-input,
.bulk-collection-text-input.bulk-collection-disabled-input {
  background-color: #f6f6f6;
  color: #b0b0b0;
  text-decoration: line-through;
  opacity: 0.6;
}

.bulk-collection-disabled-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  color: #999;
  background-color: rgba(0, 0, 0, 0.05);
  padding: 1px 4px;
  border-radius: 2px;
  pointer-events: none;
  /* Prevent it from blocking interactions */
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.8;
}

.bulk-collection-cell-error {
  position: absolute;
  bottom: -18px;
  left: 0;
  width: 100%;
  background-color: #f8d7da;
  color: #721c24;
  font-size: 12px;
  padding: 2px 4px;
  text-align: center;
  z-index: 20;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bulk-collection-cell-warning {
  position: absolute;
  bottom: -18px;
  left: 0;
  width: 100%;
  background-color: #fff3cd;
  color: #856404;
  font-size: 12px;
  padding: 2px 4px;
  text-align: center;
  z-index: 20;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bulk-empty-message {
  text-align: center;
  padding: 20px;
  color: #6c757d;
  font-style: italic;
}

.bulk-delete-btn,
.bulk-collection-delete-btn {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bulk-delete-btn:hover,
.bulk-collection-delete-btn:hover {
  background-color: rgba(220, 53, 69, 0.1);
}

.bulk-customer-search-cell {
  position: relative;
  width: 100%;
}

.bulk-collection-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-top: none;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.bulk-collection-dropdown-item {
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  transition: background-color 0.2s;
  cursor: pointer;
}

.bulk-collection-dropdown-item:hover,
.bulk-collection-dropdown-item.bulk-collection-selected {
  background-color: #a7a7a7;
  color: #212529;
}

.bulk-collection-dropdown-item-add-new {
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  transition: background-color 0.2s;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  font-weight: bold;
}

.bulk-collection-dropdown-item-add-new:hover {
  background-color: #0056b3;
}

.bulk-collection-no-results {
  padding: 8px 12px;
  color: #888;
  font-style: italic;
  text-align: center;
}

.bulk-text-input:focus,
.bulk-collection-excel-cell-input:focus,
.bulk-collection-text-input:focus {
  outline: 2px solid #1a73e8;
  border-color: #1a73e8;
}

.bulk-data-table td:first-child .bulk-text-input,
.bulk-data-table td:first-child .bulk-collection-excel-cell-input,
.bulk-data-table td:first-child .bulk-collection-text-input {
  width: 100%;
  min-width: 150px;
}

.bulk-serial-cell {
  text-align: center;
  font-weight: 500;
  background-color: #f8f9fa;
}

.bulk-date-input-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.bulk-date-input-wrapper input[type="date"] {
  width: 100%;
  cursor: pointer;
}

.bulk-collection-editable-field .bulk-text-input,
.bulk-collection-editable-field .bulk-collection-excel-cell-input,
.bulk-collection-editable-field .bulk-collection-text-input {
  font-weight: 500;
}

.bulk-collection-editable-field .bulk-text-input:focus,
.bulk-collection-editable-field .bulk-collection-excel-cell-input:focus,
.bulk-collection-editable-field .bulk-collection-text-input:focus {
  outline: none;
  box-shadow: inset 0 0 0 2px #4d90fe;
}

.bulk-data-table th:nth-child(1),
.bulk-data-table td:nth-child(1) {
  width: 50px;
  min-width: 50px;
  text-align: center;
}

.bulk-data-table th:nth-child(2),
.bulk-data-table td:nth-child(2) {
  width: 120px;
  min-width: 120px;
}

.bulk-data-table th:nth-child(3),
.bulk-data-table td:nth-child(3) {
  width: 90px;
  min-width: 90px;
}

.bulk-data-table th:nth-child(4),
.bulk-data-table td:nth-child(4) {
  width: 180px;
  min-width: 180px;
}

.bulk-data-table th:nth-child(5),
.bulk-data-table th:nth-child(6),
.bulk-data-table th:nth-child(7),
.bulk-data-table th:nth-child(8) {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
}

.bulk-data-table td:nth-child(5),
.bulk-data-table td:nth-child(6),
.bulk-data-table td:nth-child(7),
.bulk-data-table td:nth-child(8) {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
}

.bulk-data-table th:nth-child(9),
.bulk-data-table td:nth-child(9) {
  width: 85px;
  min-width: 85px;
}

.bulk-data-table th:nth-child(10),
.bulk-data-table th:nth-child(11),
.bulk-data-table td:nth-child(10),
.bulk-data-table td:nth-child(11) {
  width: 100px;
  min-width: 100px;
}

.bulk-data-table th:nth-child(12),
.bulk-data-table td:nth-child(12) {
  width: 60px;
  min-width: 60px;
}

@media (max-width: 1024px) {

  .bulk-text-input,
  .bulk-select-input,
  .bulk-collection-excel-cell-input,
  .bulk-collection-excel-cell-select,
  .bulk-collection-text-input {
    font-size: 14px !important;
  }

}

.global-time-header-select,
.global-base-snf-header-select,
.global-animal-type-header-select {
  border: none !important;
  outline: none !important;
  background: transparent !important;
  font-weight: 600;
  font-size: 16px !important;
  /* Updated from 18px */
  color: inherit;
  text-align: center;
  width: 100%;
}

input.bulk-text-input[readonly],
input.bulk-collection-excel-cell-input[readonly],
input.bulk-collection-text-input[readonly] {
  background-color: #f8f9fa;
  color: #495057;
  cursor: default;
}

.bulk-collection-total-row {
  background-color: #f0f7ff;
  font-weight: 700;
  font-size: 16px;
}

.bulk-collection-total-label {
  text-align: right;
  font-weight: 700;
  color: #495057;
  font-size: 16px !important;
}

.bulk-collection-total-value {
  text-align: center;
  font-weight: 700;
  color: #007bff;
  font-size: 1.2em;
}

.bulk-collection-weight-total {
  color: #28a745;
  font-size: 16px !important;
}

.bulk-excel-container {
  width: 100%;
  overflow-x: auto;
  padding: 0;
  margin: 0;
}

@media (max-width: 1200px) {
  .bulk-data-table {
    font-size: 12px;
    /* Smaller font on smaller screens */
    width: 100%;
    min-width: 1200px;
  }

  .bulk-data-table th,
  .bulk-data-table td {
    padding: 4px 6px;
    height: 32px;
  }
}

.bulk-collection-v1-container .add-row-button,
.bulk-collection-v1-container .preview-button {
  padding: 8px 12px !important;
  font-size: 0.85rem !important;
}

.bulk-collection-v1-container .modal-btn {
  padding: 8px 16px !important;
  font-size: 0.85rem !important;
}

/* Responsive adjustments for smaller content */
@media(max-width: 768px) {
  .bulk-collection-v1-container {
    font-size: 0.8rem !important;
    padding: 10px !important;
    padding-top: 56px !important;
  }

  .bulk-collection-v1-container .global-input {
    padding: 6px 10px !important;
    font-size: 0.8rem !important;
  }

  .bulk-collection-v1-container .global-button {
    padding: 6px 10px !important;
    font-size: 0.8rem !important;
  }

  /* .bulk-collection-v1-container .excel-cell-input {
    font-size: 0.75rem !important;
    padding: 4px 6px !important;
  } */

  .change-rates-modal {
    width: 95%;
    max-width: 400px;
    font-size: 0.7rem;
  }

  .change-rates-header {
    padding: 12px 16px;
  }

  .change-rates-header h3 {
    font-size: 0.9rem;
  }

  .change-rates-body {
    padding: 16px;
    font-size: 0.7rem;
  }

  .change-rates-section {
    margin-bottom: 16px;
  }

  .change-rates-section h4 {
    font-size: 0.75rem;
  }

  .section-description {
    font-size: 0.7rem;
  }

  .current-milk-rate-display {
    padding: 10px;
  }

  .rate-label {
    font-size: 0.7rem;
  }

  .rate-value {
    font-size: 0.8rem;
  }

  .edit-rate-btn {
    font-size: 0.7rem;
    padding: 3px;
  }

  .option-btn {
    padding: 8px 12px;
    font-size: 0.7rem;
    min-width: 80px;
  }

  .change-rates-footer {
    padding: 12px 16px;
  }

  .change-rates-button {
    padding: 6px 10px;
    font-size: 0.7rem;
    gap: 4px;
  }

  /* Mobile responsive header with language switcher */
  .bulk-collection-header {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .bulk-collection-header .bulk-heading {
    text-align: center;
    order: 2;
    font-size: 1.2rem;
  }

  .back-button-bulk {
    order: 1;
    align-self: flex-start;
  }

  .bulk-collection-header .header-actions {
    order: 3;
    align-self: flex-end;
  }
}

/* Language Switcher Styling for Bulk Collection V1 Header */
.bulk-collection-header .lang-btn {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.bulk-collection-header .lang-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.4);
}

.bulk-collection-header .lang-icon {
  color: white;
}

.bulk-collection-header .lang-text {
  color: white;
}

.bulk-collection-header .lang-chevron {
  color: rgba(255, 255, 255, 0.9);
}

.bulk-collection-header .lang-menu {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 150px;
}

.bulk-collection-header .lang-item {
  color: #333;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
}

.bulk-collection-header .lang-item:hover {
  background-color: #f5f5f5;
}

.bulk-collection-header .lang-item.active {
  background-color: #e3f2fd;
  color: #2563eb;
  font-weight: 600;
}

/* BulkCollectionV1 Rate Settings Modal Styles */
.change-rates-modal-bulkcollection {
  background: #f0f8ff;
  /* Single blue background color */
  border-radius: 16px;
  max-width: 800px;
  width: 95%;
  height: auto;
  max-height: 95vh;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(37, 99, 235, 0.15);
  font-size: 0.9rem;
  border: 1px solid #2563eb;
  margin: 20px auto;
}

.change-rates-header-bulkcollection {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #2563eb;
  /* Blue header */
  color: white;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
}

.change-rates-body-bulkcollection {
  padding: 16px;
  overflow-y: hidden;
  flex: 1 1;
  font-size: 0.85rem;
  background: #f0f8ff;
  /* Single blue background */
  min-height: 0;
  max-height: calc(95vh - 140px);
  /* Account for header and footer */
}

.change-rates-section-bulkcollection {
  margin-bottom: 12px;
  /* Reduced from 16px */
  padding: 12px;
  /* Reduced from 14px */
  background: #e6f3ff;
  /* Light blue background */
  border-radius: 8px;
  /* Reduced from 10px */
  /* border removed */
  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.1);
  /* Blue shadow */
}

.change-rates-section-bulkcollection:last-child {
  margin-bottom: 0;
}

.change-rates-section-bulkcollection h4 {
  margin: 0 0 6px 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e40af;
  /* Dark blue text */
  letter-spacing: -0.01em;
}

.section-description {
  font-size: 0.7rem;
  /* Reduced from 0.75rem */
  color: #1e40af;
  /* Dark blue text */
  line-height: 1.3;
  /* Reduced from 1.4 */
  margin-bottom: 8px;
  /* Reduced from 10px */
  font-weight: 400;
}

.option-btn {
  padding: 6px 12px;
  /* Reduced from 8px 16px */
  border: 1px solid #2563eb;
  /* Blue border */
  border-radius: 4px;
  /* Reduced from 6px */
  background: #ffffff;
  /* White background */
  color: #1e40af;
  /* Dark blue text */
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.8rem;
  /* Reduced from 0.85rem */
  font-weight: 500;
  min-width: 80px;
  /* Added for consistency */
}

.option-btn:hover {
  border-color: #1e40af;
  /* Darker blue border */
  background: #f0f8ff;
  /* Light blue background */
}

.option-btn.active {
  background: #2563eb;
  /* Blue background */
  color: white;
  border-color: #2563eb;
  /* Blue border */
}

.rate-settings-modal-option-btn {
  padding: 10px 12px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  background: white;
  color: #374151;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.rate-settings-modal-option-btn:hover {
  border-color: #2563eb;
  color: #2563eb;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
  transform: translateY(-1px);
}

.rate-settings-modal-option-btn.active {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  border-color: #2563eb;
  color: white !important;
  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.3);
  transform: translateY(-1px);
}

/* Current Milk Rate Display */
.current-milk-rate-display {
  background: #e6f3ff;
  /* Light blue background */
  border: 1px solid #2563eb;
  /* Blue border */
  border-radius: 8px;
  padding: 8px;
  /* Reduced padding for smaller card */
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.1);
  /* Blue shadow */
  position: relative;
  /* Add relative positioning for edit button */
}

.current-milk-rate-display:hover {
  background: #d1e7ff;
  /* Lighter blue background */
  border-color: #1e40af;
  /* Darker blue border */
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
  transform: translateY(-1px);
}

.rate-label {
  font-weight: 500;
  color: #1e40af;
  /* Dark blue text */
  font-size: 0.85rem;
  margin-right: 8px;
}

.rate-value {
  font-size: 1.2rem;
  font-weight: 700;
  color: #2563eb;
  /* Blue text */
}

.edit-icon {
  color: #1e40af;
  /* Dark blue icon */
  margin-left: 8px;
  font-size: 0.9rem;
}

/* Edit button styling for milk rate display */
.edit-rate-btn {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
}

.edit-rate-btn:hover {
  background: #1e40af;
  transform: scale(1.05);
}

.edit-rate-btn svg {
  margin: 0;
}

.change-rates-footer-bulkcollection {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #f0f8ff;
  /* Light blue background */
  border-top: 1px solid #2563eb;
  /* Blue border */
  border-radius: 0 0 16px 16px;
  justify-content: flex-end;
}

/* Two-row layout for top sections in BulkCollectionV1 */
.change-rates-top-row-bulkcollection {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 16px;
}

.change-rates-top-row-bulkcollection .change-rates-section-bulkcollection {
  margin-bottom: 0;
}

/* Second row layout for Base SNF and CLR sections */
.change-rates-bottom-row-bulkcollection {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 16px;
}

.change-rates-bottom-row-bulkcollection .change-rates-section-bulkcollection {
  margin-bottom: 0;
}

/* Mobile responsive styles for BulkCollectionV1 Rate Settings Modal */
@media (max-width: 768px) {
  .change-rates-modal-bulkcollection {
    max-width: 98%;
    width: 95%;
    margin: 2px auto;
    /* Minimal margin */
    max-height: 98vh;
    /* Maximum height */
    overflow-y: auto;
    /* Enable scrolling for mobile */
  }

  .change-rates-header-bulkcollection {
    padding: 8px 12px;
    /* Minimal header padding */
  }

  .change-rates-header-bulkcollection h3 {
    font-size: 0.85rem;
    /* Smaller header */
  }

  .change-rates-body-bulkcollection {
    padding: 8px;
    /* Minimal body padding */
    font-size: 0.75rem;
    /* Smaller font */
    max-height: calc(98vh - 80px);
    /* Optimized height calculation */
    overflow-y: auto;
    /* Enable scrolling for mobile */
  }

  .change-rates-section-bulkcollection {
    margin-bottom: 8px;
    /* Minimal margin */
    padding: 8px;
    /* Minimal padding */
  }

  .change-rates-section-bulkcollection h4 {
    font-size: 0.75rem;
    /* Smaller headers */
    margin-bottom: 2px;
    /* Minimal margin */
  }

  .section-description {
    font-size: 0.65rem;
    /* Smaller descriptions */
    margin-bottom: 4px;
    /* Minimal margin */
    line-height: 1.2;
  }

  .rate-value {
    font-size: 0.9rem;
    /* Smaller rate value */
  }

  .current-milk-rate-display span {
    font-size: 0.7rem;
    /* Smaller milk rate label */
    margin-bottom: 2px;
  }

  .option-btn {
    padding: 6px 8px;
    /* Minimal button padding */
    font-size: 0.7rem;
    /* Smaller button font */
    max-width: 80px;
    /* Smaller max width */
    min-height: 32px;
    /* Touch-friendly but compact */
  }

  /* Mobile single column layout for top row */
  .change-rates-top-row-bulkcollection {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  /* Mobile single column layout for bottom row */
  .change-rates-bottom-row-bulkcollection {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  /* Enhanced mobile styling for option buttons */
  .option-buttons {
    flex-wrap: wrap;
    gap: 4px;
    /* Reduced gap */
  }

  .option-btn {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 2px);
    min-width: 70px;
    /* Smaller min width */
    padding: 6px 8px;
    font-size: 0.7rem;
  }

  /* Mobile edit button positioning */
  .edit-rate-btn {
    top: 6px;
    right: 6px;
    min-width: 28px;
    min-height: 28px;
    font-size: 0.7rem;
  }

  /* Mobile milk rate display adjustments */
  .current-milk-rate-display {
    padding: 6px;
    /* Smaller padding */
  }

  .rate-label {
    font-size: 0.65rem;
    /* Smaller label */
  }

  .rate-value {
    font-size: 0.8rem;
    /* Smaller value */
  }
}

/* Very small mobile screens */
@media (max-width: 480px) {
  .change-rates-modal-bulkcollection {
    margin: 2px auto;
    /* Minimal margin */
    overflow-y: auto;
    /* Enable scrolling for very small screens */
  }

  .change-rates-body-bulkcollection {
    padding: 6px;
    /* Even smaller padding */
    max-height: calc(98vh - 70px);
    /* Optimized height */
  }

  .change-rates-section-bulkcollection {
    padding: 6px;
    /* Minimal padding */
    margin-bottom: 6px;
    /* Minimal margin */
  }

  .change-rates-section-bulkcollection h4 {
    font-size: 0.7rem;
    /* Even smaller headers */
  }

  .section-description {
    font-size: 0.6rem;
    /* Even smaller descriptions */
    margin-bottom: 3px;
  }

  .option-btn {
    padding: 5px 6px;
    /* Minimal padding */
    font-size: 0.65rem;
    /* Even smaller font */
    min-width: 60px;
    /* Smaller min width */
    min-height: 28px;
  }

  .edit-rate-btn {
    top: 4px;
    right: 4px;
    min-width: 24px;
    min-height: 24px;
    font-size: 0.6rem;
  }

  .rate-label {
    font-size: 0.6rem;
  }

  .rate-value {
    font-size: 0.7rem;
  }

  .current-milk-rate-display {
    padding: 4px;
    /* Minimal padding */
  }
}

/* Profile Dropdown Styles */
.profile-dropdown {
  position: relative;
  display: inline-block;
}

.profile-button {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.profile-button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
  border-color: rgba(255, 255, 255, 0.4);
}

.profile-icon {
  font-size: 18px;
}

.profile-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.1);
  min-width: 280px;
  z-index: 1000;
  margin-top: 8px;
  overflow: hidden;
  animation: dropdownSlideDown 0.3s ease;
}

@keyframes dropdownSlideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.profile-header {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.profile-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}

.profile-content {
  padding: 16px;
}

.profile-content .info-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  position: relative;
  border: none !important;
  border-bottom: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
}

.wallet-section {
  padding: 12px 16px;
  border-top: 1px solid #f0f0f0;
  background: #f8f9fa;
}

.wallet-section .info-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  position: relative;
  border: none !important;
  border-bottom: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
}

.profile-content .info-item:last-child {
  border-bottom: none;
}

.profile-content .info-icon {
  color: #2563eb;
  font-size: 14px;
  width: 20px;
  margin-right: 12px;
  flex-shrink: 0;
}

.profile-content .info-label {
  font-weight: 500;
  color: #374151;
  margin-right: 8px;
  min-width: 80px;
  flex-shrink: 0;
}

.profile-content .info-value {
  color: #1f2937;
  font-weight: 400;
  flex-grow: 1;
}

.profile-content .add-money-btn {
  background: #10b981;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.3s ease;
  margin-left: 8px;
  flex-shrink: 0;
}

.profile-content .add-money-btn:hover {
  background: #059669;
}

.info-loading {
  padding: 16px;
  text-align: center;
  color: #6b7280;
  font-size: 14px;
}

/* Rate Settings Card Styles */
.rate-settings-card-bulk {
  flex: 1 1;
  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 120px;
  border: 1px solid rgba(59, 130, 246, 0.15);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

/* Wallet Card Styles */
.wallet-card-bulk {
  flex: 1 1;
  background: linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%);
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 120px;
  border: 1px solid rgba(16, 185, 129, 0.15);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

/* Rate Settings Card Styles */
.rate-settings-dairy-card {
  flex: 1 1;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 120px;
  border: 1px solid rgba(251, 191, 36, 0.2);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.rate-settings-heading {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #92400e;
  display: flex;
  align-items: center;
  gap: 8px;
}

.rate-settings-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1;
}

.rate-settings-primary-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 14px 28px !important;
  font-size: 0.9rem !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.25) !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  min-width: 160px !important;
  justify-content: center !important;
}

.rate-settings-primary-btn:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4) !important;
}

.rate-settings-primary-btn:active {
  transform: translateY(0) !important;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3) !important;
}

/* Modern Rate Settings Card */
.rate-settings-modern-card {
  flex: 1 1 350px;
  background: #ffffff;
  border-radius: 10px;
  padding: 0.8rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  /* border: 1px solid #e5e7eb; */
  border: solid 2px black;
  display: flex;
  width: 100%;
  flex-direction: column;
  min-height: 70px;
}

.rate-settings-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0.3rem;
}

.rate-settings-icon-wrapper {
  background: #3b82f6;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.rate-settings-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.rate-settings-list {
  flex: 1 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
}

/* Desktop: 3 columns */
@media (min-width: 1024px) {
  .rate-settings-list {
    grid-template-columns: repeat(3, 1fr);
  }
}

.rate-settings-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.65rem;
  color: #4b5563;
}

.check-icon {
  color: #10b981;
  font-size: 10px;
  flex-shrink: 0;
}

.rate-settings-action-button {
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 6px 10px;
  font-size: 0.7rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  margin-top: 0.5rem;
  transition: all 0.2s ease;
}

.rate-settings-action-button:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

/* Top Right Wallet Positioning */

.wallet-rate-card {
  /* border: solid 2px red; */
  display: flex;
  flex-direction: column;
}

.wallet-top-right {
  display: inline;
  margin-top: 10px;
  max-width: 300px;
  margin-left: auto;
  background: #ffffff;
  border-radius: 8px;
  padding: 12px 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border: 1px solid #e5e7eb;
}

.wallet-top-right .wallet-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wallet-top-right .icon-wallet {
  color: #16a34a;
  font-size: 18px;
}


.wallet-top-right .wallet-info span:last-child {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
}

/* Simple Wallet Card */
.wallet-simple-card {
  flex: 0 1 240px;
  background: #ffffff;
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
}

.wallet-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon-wallet {
  color: #16a34a;
  font-size: 16px;
}

.wallet-recharge-link {
  color: #3b82f6;
  font-size: 18px !important;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s ease;
}

.wallet-recharge-link:hover {
  color: #2563eb;
  text-decoration: underline;
}

.wallet-amount {
  font-size: 18px;
  font-weight: 700;
  color: #000 !important;
}

/* .wallet-simple-card .wallet-info span:last-child {
  margin-left: auto;
  font-size: 0.875rem;
  font-weight: 600;
  color: #1f2937;
} */

.wallet-card-heading {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #059669;
  text-align: center;
}

.wallet-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.wallet-info-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: rgba(16, 185, 129, 0.1);
  border-radius: 8px;
  border: none;
}

.wallet-icon {
  color: #059669;
  font-size: 1.2rem;
  flex-shrink: 0;
}

.wallet-label {
  font-weight: 500;
  color: #374151;
  font-size: 0.9rem;
}

.wallet-value {
  color: #1f2937;
  font-weight: 600;
  font-size: 1.1rem;
}

.add-money-btn-main {
  background: #059669;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}

.add-money-btn-main:hover {
  background: #047857;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

/* ==================== EDIT SUPPLIER MODAL STYLES ==================== */

/* Edit Supplier Modal */
.edit-supplier-modal {
  max-width: 500px;
  width: 95%;
  max-height: 85vh;
  overflow: hidden;
}

.edit-supplier-modal .modal-body {
  padding: 0;
  overflow-y: auto;
  max-height: calc(85vh - 120px);
  display: flex;
  flex-direction: column;
}

/* Search Input Wrapper with Icon */
.supplier-search-input-wrapper {
  position: relative;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8f9fa;
}

.supplier-search-input-wrapper .search-icon {
  position: absolute;
  left: 32px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 16px;
  z-index: 1;
}

.supplier-search-input {
  width: 100%;
  padding: 12px 16px 12px 44px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 15px;
  background: white;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.supplier-search-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Supplier List Container - Simple */
.supplier-list-container-simple {
  width: 100%;
  background: white;
  max-height: 400px;
  overflow-y: auto;
}

/* Supplier List - Simple */
.supplier-list-simple {
  display: flex;
  flex-direction: column;
}

/* Supplier List Item - Simple */
.supplier-list-item-simple {
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f3f4f6;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.supplier-list-item-simple:hover {
  background: #f9fafb;
}

.supplier-list-item-simple:active {
  background: #f3f4f6;
}

.supplier-name-simple {
  font-weight: 500;
  font-size: 16px;
  color: #1f2937;
}

.supplier-id-simple {
  font-size: 14px;
  color: #6b7280;
}

/* No Suppliers Found - Simple */
.no-suppliers-found-simple {
  padding: 40px 20px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
}

/* Edit Supplier Button - Green styling */
.edit-supplier-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
}

.edit-supplier-btn:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;
}

/* Selected Supplier Info */
.edit-supplier-modal .form-instructions strong {
  color: #3b82f6;
}

/* Responsive adjustments for Edit Supplier Modal */
@media (max-width: 768px) {
  .edit-supplier-modal {
    max-width: 95%;
    width: 95%;
    max-height: 90vh;
  }

  .edit-supplier-modal .modal-body {
    max-height: calc(90vh - 100px);
  }

  .supplier-search-input-wrapper {
    padding: 12px 16px;
  }

  .supplier-list-container-simple {
    max-height: 350px;
  }

  .supplier-list-item-simple {
    padding: 14px 16px;
  }

  .supplier-name-simple {
    font-size: 15px;
  }

  .bulk-dairy-info-wrapper {
    width: 100% !important;
  }
}

@media (max-width: 480px) {
  .edit-supplier-modal {
    max-width: 98%;
    width: 98%;
  }

  .bulk-dairy-info-wrapper {
    width: 100%;
  }

  .supplier-list-item-simple {
    padding: 12px 14px;
  }

  .supplier-name-simple {
    font-size: 14px;
  }

  .supplier-id-simple {
    font-size: 13px;
  }
}

/* Bulk Collection V1 - Modern Rate Settings and Dairy Info Cards */
.bulk-dairy-info-wrapper {
  display: flex;
  gap: 16px;
  width: 40%;
  align-items: stretch;
  margin-bottom: 10px;
  padding: 12px;
  border-radius: 12px;
}

/* Mobile and Tablet Layout - Stack cards vertically */
@media (max-width: 1024px) {
  .bulk-dairy-info-wrapper {
    flex-direction: column;
    gap: 1rem;
  }

  .bulk-rate-settings-card,
  .bulk-dairy-info-card {
    width: 100%;
  }

  /* Hide dairy info card on mobile */
  .bulk-dairy-info-card {
    display: none !important;
  }
}

/* Additional mobile-specific rule for smaller screens */
@media (max-width: 768px) {
  .bulk-dairy-info-card {
    display: none !important;
    visibility: hidden !important;
    height: 0 !important;
    overflow: hidden !important;
  }
}

/* Bulk Rate Settings Card */
.bulk-rate-settings-card {
  flex: 1 1 50%;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 12px;
  padding: 0.6rem 0.8rem;
  box-shadow: 0 2px 12px rgba(59, 130, 246, 0.06), 0 1px 3px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.bulk-rate-settings-card:hover {
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.12), 0 2px 6px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-color: rgba(59, 130, 246, 0.15);
}

.bulk-rate-settings-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6 0%, #8b5cf6 50%, #06b6d4 100%);
}

.bulk-rate-settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid rgba(59, 130, 246, 0.08);
}

.bulk-rate-settings-title-section {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.bulk-rate-settings-icon-bg {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);
}

.bulk-rate-settings-main-icon {
  color: white;
  font-size: 12px;
}

.bulk-rate-settings-title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  line-height: 1.2;
}

.bulk-rate-settings-subtitle {
  display: none !important;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.bulk-rate-settings-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border: none;
  border-radius: 6px;
  padding: 0.25rem 0.5rem;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.7rem;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);
}

.bulk-rate-settings-btn:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
}

.bulk-rate-settings-content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.bulk-rate-settings-row {
  display: flex;
  gap: 0.5rem;
}

.bulk-rate-settings-row .bulk-rate-setting-item {
  flex: 1 1;
  min-width: 0;
}

.bulk-rate-setting-item {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  border: 1px solid rgba(59, 130, 246, 0.06);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.bulk-rate-setting-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, #3b82f6 0%, #8b5cf6 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.bulk-rate-setting-item:hover::before {
  opacity: 1;
}

.bulk-rate-setting-item:hover {
  background: rgba(255, 255, 255, 1);
  border-color: rgba(59, 130, 246, 0.15);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.08);
}

.bulk-setting-icon-wrapper {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.bulk-setting-icon {
  color: #3b82f6;
  font-size: 12px;
}

.bulk-setting-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.bulk-setting-name {
  font-size: 0.6rem;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.bulk-setting-value {
  font-size: 0.8rem;
  color: #1e293b;
  font-weight: 700;
  line-height: 1.2;
}

.bulk-setting-value.highlight {
  color: #3b82f6;
  font-size: 0.85rem;
}

/* Mobile responsive - Hide dairy info cards */
@media (max-width: 768px) {
  .wallet-rate-card>div:first-child {
    flex-direction: column;
    gap: 0.5rem;
  }

  .bulk-dairy-info-item {
    display: none !important;
  }

  .wallet-info {
    width: 100%;
    justify-content: space-between;
  }
}

/* Single line card layout */
.wallet-rate-card>div:first-child {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
}

.wallet-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-weight: 700;
  white-space: nowrap;
  color: #1e293b;
}

.wallet-recharge-link {
  cursor: pointer;
  text-decoration: underline;
  color: #3b82f6;
}

.wallet-recharge-link:hover {
  color: #10b981;
}

/* .wallet-info span:last-child {
  font-weight: 600;
  font-size: 1rem;
} */

.bulk-dairy-info-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0.75rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.bulk-dairy-info-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.bulk-dairy-info-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #3b82f6;
  color: white;
  border-radius: 4px;
  font-size: 12px;
}

.bulk-dairy-info-content {
  display: flex;
  flex-direction: row;
  gap: 5px;
}

.bulk-dairy-info-name {
  font-size: 1rem;
  color: #000000;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.bulk-dairy-info-value {
  font-size: 18px;
  color: #1e293b;
  font-weight: 700;
  display: flex;
  align-items: center;
}

/* Global header dropdown styling */
.global-time-header-select,
.global-base-snf-header-select,
.global-animal-type-header-select {
  border: none !important;
  outline: none !important;
  background: transparent !important;
  font-weight: 600;
  font-size: 16px !important;
  color: inherit;
  text-align: center;
  width: 100%;
}

.global-time-header-select:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.global-animal-type-header-select:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.global-base-snf-header-select:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Rate Change Modal Styling */
.rate-change-modal {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.rate-change-modal .modal-header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid #e8eaed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.rate-change-modal .modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #202124;
}

.rate-change-modal .modal-body {
  padding: 20px 24px;
}

.rate-change-modal .form-group {
  margin-bottom: 20px;
}

.rate-change-modal .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #3c4043;
  font-size: 14px;
}

.rate-change-modal .rate-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #dadce0;
  border-radius: 4px;
  font-size: 16px;
  color: #202124;
  transition: border-color 0.2s;
}

.rate-change-modal .rate-input:focus {
  outline: none;
  border-color: #1a73e8;
  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);
}

.rate-change-modal .modal-footer {
  padding: 16px 24px 20px;
  border-top: 1px solid #e8eaed;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.rate-change-modal .cancel-button {
  padding: 10px 20px;
  border: 1px solid #dadce0;
  background: white;
  color: #3c4043;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.rate-change-modal .cancel-button:hover {
  background: #f8f9fa;
}

.rate-change-modal .confirm-button {
  padding: 10px 20px;
  border: none;
  background: #1a73e8;
  color: white;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.rate-change-modal .confirm-button:hover {
  background: #1765cc;
}

.rate-change-modal .confirm-button:disabled {
  background: #9aa0a6;
  cursor: not-allowed;
}

/* Centered confirmation message positioning */
.success-message-centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  border-radius: 8px;
  padding: 20px 30px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: fadeInScale 0.3s ease-in-out;
  min-width: 300px;
  max-width: 500px;
}

.success-message-centered svg {
  margin-right: 12px;
  font-size: 1.4em;
  flex-shrink: 0;
}

.success-message-centered span {
  font-weight: 500;
  font-size: 16px;
}

.success-message-close-btn {
  background: none;
  border: none;
  color: #155724;
  cursor: pointer;
  padding: 4px;
  margin-left: 12px;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.success-message-close-btn:hover {
  background-color: rgba(21, 87, 36, 0.1);
  color: #0d5422;
}

.success-message-close-btn svg {
  font-size: 14px;
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

/* Date/Shift Mode Toggle Segmented Control */
.date-shift-toggle-group {
  display: flex;
  align-items: center;
  background-color: #e9ecef;
  border-radius: 6px;
  padding: 3px;
  margin-left: 12px;
}

.date-shift-toggle-btn {
  padding: 6px 12px;
  border: none;
  background: transparent;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
}

.date-shift-toggle-btn.active {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  font-weight: 600;
}

@media (max-width: 768px) {
  .date-shift-toggle-group {
    margin-left: 0;
    margin-top: 8px;
    width: 100%;
    justify-content: center;
  }
}
/* Rate Type & Animal Type - 50-50 side-by-side on mobile */
@media (max-width: 480px) {
  .rate-settings-modal-row-dashboard {
    flex-direction: row !important;
    gap: 8px !important;
    margin-bottom: 10px !important;
  }
  .rate-settings-modal-row-dashboard .rate-settings-modal-section-dashboard {
    flex: 1 1 !important;
    min-width: 0 !important;
  }
}

/* Premium Rate Change Modal Styles */
.brc-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(15, 23, 42, 0.45) !important;
  backdrop-filter: blur(8px) !important;
  -webkit-backdrop-filter: blur(8px) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  z-index: 2000 !important;
  animation: brcFadeIn 0.25s ease-out;
}

.brc-modal-container {
  background: #ffffff !important;
  border-radius: 20px !important;
  width: 90% !important;
  max-width: 420px !important;
  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;
  border: 1px solid rgba(241, 245, 249, 0.8) !important;
  overflow: hidden !important;
  animation: brcScaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes brcFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes brcScaleIn {
  from { transform: scale(0.95) translateY(10px); opacity: 0; }
  to { transform: scale(1) translateY(0); opacity: 1; }
}

.brc-modal-header {
  padding: 24px 28px 16px !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.brc-modal-title {
  margin: 0 !important;
  font-size: 20px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
  letter-spacing: -0.02em !important;
}

.brc-modal-close-btn {
  background: #f8fafc !important;
  border: none !important;
  width: 36px !important;
  height: 36px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #64748b !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

.brc-modal-close-btn:hover {
  background: #e2e8f0 !important;
  color: #0f172a !important;
  transform: rotate(90deg) !important;
}

.brc-modal-body {
  padding: 28px 28px 24px !important;
}

.brc-modal-form-group {
  margin-bottom: 24px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
}

.brc-modal-label {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #475569 !important;
  margin-bottom: 0 !important;
  text-align: left !important;
}

.brc-modal-input-wrapper {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
}

.brc-modal-currency-symbol {
  position: absolute !important;
  left: 16px !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #94a3b8 !important;
  pointer-events: none !important;
}

.brc-modal-input {
  width: 100% !important;
  padding: 14px 16px 14px 36px !important;
  border: 2px solid #e2e8f0 !important;
  border-radius: 12px !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #0f172a !important;
  background-color: #f8fafc !important;
  transition: all 0.2s ease !important;
  box-sizing: border-box !important;
}

.brc-modal-input:focus {
  outline: none !important;
  border-color: #10b981 !important;
  background-color: #ffffff !important;
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.15) !important;
}

.brc-modal-input::placeholder {
  color: #cbd5e1 !important;
  font-size: 15px !important;
  font-weight: 400 !important;
}

.brc-modal-error-message {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  color: #ef4444 !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  margin-top: 12px !important;
  padding: 10px 14px !important;
  background: #fef2f2 !important;
  border-radius: 8px !important;
  border: 1px dashed rgba(239, 68, 68, 0.3) !important;
}

.brc-modal-footer {
  padding: 20px 28px 28px !important;
  background-color: #f8fafc !important;
  border-top: 1px solid #f1f5f9 !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-end !important;
  gap: 12px !important;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
}

.brc-modal-cancel-btn {
  flex: 1 1 !important;
  padding: 12px 20px !important;
  border: 1px solid #e2e8f0 !important;
  background: #ffffff !important;
  color: #64748b !important;
  border-radius: 12px !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
  margin-bottom: 0 !important;
  width: auto !important;
}

.brc-modal-cancel-btn:hover {
  background: #f1f5f9 !important;
  color: #0f172a !important;
  border-color: #cbd5e1 !important;
}

.brc-modal-cancel-btn:active {
  transform: scale(0.98) !important;
}

.brc-modal-confirm-btn {
  flex: 1.2 1 !important;
  padding: 12px 20px !important;
  border: none !important;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border-radius: 12px !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  box-shadow: 0 4px 6px -1px rgba(16, 185, 129, 0.2), 0 2px 4px -1px rgba(16, 185, 129, 0.1) !important;
  margin-bottom: 0 !important;
  width: auto !important;
}

.brc-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;
  box-shadow: 0 10px 15px -3px rgba(16, 185, 129, 0.3), 0 4px 6px -2px rgba(16, 185, 129, 0.15) !important;
}

.brc-modal-confirm-btn:active {
  transform: scale(0.98) !important;
}

.brc-modal-confirm-btn:disabled {
  background: #cbd5e1 !important;
  color: #94a3b8 !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/BulkCollectionV1.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,6DAA6D;EAC7D,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,8CAA8C;AAC9C;EACE,SAAO;EACP,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;AAC9D;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,yCAAyC;AACzC;EACE,SAAO;EACP,6DAA6D;EAC7D,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;AAC9D;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,yBAAyB;AACzB;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gDAAgD;EAChD,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,+CAA+C;EAC/C,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,aAAa;IACb,WAAW;EACb;AACF;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,aAAa;AACb;;EAEE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,gDAAgD;AAChD;EACE,SAAO;EACP,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;AAC9D;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA,wDAAwD;AACxD;EACE,SAAO;EACP,YAAY;EACZ,6DAA6D;EAC7D,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,sCAAsC;AACtC;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;AAC9D;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;AAC9C;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA,mDAAmD;;AAEnD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yDAA2R;EAC3R,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,gCAAgC;EAChC,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,6DAA6D;AAC7D;EACE;IACE,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,6DAA6D;EAC7D,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,6DAA6D;EAC7D,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD;EACE;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,QAAQ;EACV;AACF;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,6DAA6D;EAC7D,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,4DAA4D;AAC5D;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,6DAA6D;EAC7D,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;;EAEE,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,wDAAwD;AACxD;;EAEE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yDAA2R;EAC3R,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;EACd,8BAA8B;EAC9B,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,6EAA6E;AAC7E;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,2CAA2C;EAC3C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,0CAA0C;EAC1C,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gDAAgD;EAChD,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,6CAA6C;EAC7C,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA,qCAAqC;AACrC;;;EAGE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;EAeE,WAAW;EACX,eAAe;AACjB;;AAEA;;;;;;;;;EASE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,mDAAmD;;AAEnD,2CAA2C;AAC3C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,2CAA2C;EAC3C,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;EAChD,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,6DAA6D;EAC7D,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;;AAEtB,kCAAkC;AAClC;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;;IAGE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,SAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;;IAGE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;AAEF;;AAEA,kCAAkC;AAClC;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;;IAGE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;AAEF;;AAEA,wCAAwC;AACxC;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;;IAGE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;AAEF;;AAEA,sCAAsC;AACtC;EACE;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;EACb;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;EAGE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,4DAA4D;AAC5D;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE;IACE,eAAe;IACf,oCAAoC;IACpC,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;;IAEE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;;EAEE;;;IAGE,eAAe;IACf,WAAW;EACb;AACF;;AAEA,iCAAiC;AACjC;;EAEE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;;EAEE;;IAEE,0BAA0B;EAC5B;;EAEA;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,6DAA6D;IAC7D,mBAAmB;IACnB,0CAA0C;IAC1C,yBAAyB;IACzB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,6DAA6D;IAC7D,mBAAmB;IACnB,0CAA0C;IAC1C,yBAAyB;IACzB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;IACzC,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,SAAO;IACP,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,6DAA6D;IAC7D,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,QAAQ;IACR,WAAW;EACb;;EAEA;;IAEE,SAAO;IACP,YAAY;IACZ,UAAU;IACV,gCAAgC;IAChC,cAAc;IACd,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;IACf;MACE;IACF,SAAS;IACT,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;;IAEE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;IACjC,WAAW;EACb;;EAEA;;IAEE,eAAe;IACf,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,6CAA6C;IAC7C,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,6DAA6D;IAC7D,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;AACF;;;AAGA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,WAAW;EACX,6DAA6D;EAC7D,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,2DAA2D;AAC7D;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;;;EAGE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,SAAS;AACX;;AAEA;;;;;;;;;;;;EAYE,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;;;EAME,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,SAAS;AACX;;AAEA;;;;;;;;;;;;EAYE,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;EAIE,SAAS;EACT,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gEAAgE;EAChE,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,8BAA8B;EAC9B,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;EACV,kCAAkC;AACpC;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,6CAA6C;EAC7C,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA,qCAAqC;AACrC;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,iCAAiC;IACjC,0BAA0B;IAC1B,mBAAmB;IACnB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;EAChB;;EAEA,kCAAkC;EAClC;IACE,sBAAsB;IACtB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,uDAAuD;AACvD;;EAEE,oCAAoC;EACpC;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,SAAO;IACP,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA,6CAA6C;EAC7C;IACE,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;;IAEE,iBAAiB;IACjB,aAAa;EACf;;EAEA,wCAAwC;EACxC;;IAEE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA,wCAAwC;EACxC;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA,0CAA0C;EAC1C;;IAEE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,qCAAqC;EACrC;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,mBAAmB;IACnB,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,sBAAsB;IACtB,WAAW;IACX,wCAAwC;EAC1C;;EAEA,mDAAmD;EACnD;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;IACf,wBAAwB;IACxB,SAAO;IACP,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA,6BAA6B;EAC7B;IACE,gBAAgB;IAChB,iBAAiB;IACjB,SAAO;IACP,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA,kCAAkC;EAClC;;IAEE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA,4BAA4B;EAC5B;;IAEE,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;;IAEE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA,4BAA4B;EAC5B;;IAEE,WAAW;IACX,8BAA8B;IAC9B,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;EACxB;;EAEA,gCAAgC;EAChC;;IAEE,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA,gCAAgC;EAChC;;IAEE,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA,8CAA8C;EAC9C;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA,uCAAuC;EACvC;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,YAAY;EACd;;EAEA;;IAEE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA,kCAAkC;EAClC;;IAEE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA,8BAA8B;EAC9B;IACE,UAAU;IACV,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA,8BAA8B;EAC9B;IACE,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA,iCAAiC;EACjC;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA,+BAA+B;EAC/B;;IAEE,mBAAmB;IACnB,aAAa;EACf;;EAEA,oCAAoC;EACpC;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA,+BAA+B;EAC/B;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA,mCAAmC;EACnC;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,wCAAwC;EACxC;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;;;AAIA;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,6DAA6D;IAC7D,4BAA4B;IAC5B,0CAA0C;EAC5C;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,SAAO;EACT;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,+BAA+B;IAC/B,0BAA0B;IAC1B,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,2BAA2B;IAC3B,0CAA0C;EAC5C;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,6DAA6D;IAC7D,mBAAmB;IACnB,0CAA0C;IAC1C,yBAAyB;IACzB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,SAAO;EACT;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,qCAAqC;IACrC,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;IACzC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAO;IACP,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;IAC1C,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,6DAA6D;IAC7D,4CAA4C;IAC5C,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,6DAA6D;IAC7D,mBAAmB;IACnB,0CAA0C;IAC1C,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;AAEF;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,qBAAqB;EACrB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,6DAA6D;EAC7D,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;AAC9D;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAO;EACP,eAAe;EACf,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,6DAA6D;EAC7D,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qFAAqF;EACrF,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,cAAc;EACd,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,wEAAwE;EACxE,uBAAuB;EACvB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,iCAAiC;AACjC;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;;EAEE,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;;;;EAKE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;;;;;EAKE,aAAa;EACb,mCAAmC;AACrC;;AAEA;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,yDAA2R;EAC3R,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;AACjB;;AAEA;;;EAGE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;EACd,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;;EAGE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;EAGE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,mCAAmC;AACrC;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;;;;EAIE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE;;;;;IAKE,0BAA0B;EAC5B;;AAEF;;AAEA;;;EAGE,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE;IACE,eAAe;IACf,oCAAoC;IACpC,WAAW;IACX,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,+CAA+C;AAC/C;EACE;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;;;KAGG;;EAEH;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,QAAQ;EACV;;EAEA,oDAAoD;EACpD;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,QAAQ;IACR,oBAAoB;EACtB;AACF;;AAEA,4DAA4D;AAC5D;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,+CAA+C;EAC/C,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,uBAAuB;EACvB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,qBAAqB;EACrB,uBAAuB;EACvB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sEAAsE;AACtE;EACE;IACE,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,iCAAiC;IACjC,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;IACjB,wBAAwB;IACxB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA,4CAA4C;EAC5C;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA,+CAA+C;EAC/C;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA,+CAA+C;EAC/C;IACE,eAAe;IACf,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,mCAAmC;EACnC;IACE,QAAQ;IACR,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,yCAAyC;EACzC;IACE,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;EAC9C;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,QAAQ;IACR,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,oBAAoB;EACtB;AACF;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,SAAO;EACP,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,SAAO;EACP,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,wEAAwE;EACxE,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,yDAAyD;EACzD,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,wEAAwE;EACxE,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA;EACE,mCAAmC;EACnC,wDAAwD;AAC1D;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,iCAAiC;;AAEjC;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;;GAKG;;AAEH;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,yEAAyE;;AAEzE,wBAAwB;AACxB;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,wEAAwE;AAC1E;;AAEA;EACE,wEAAwE;AAC1E;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE;IACE,cAAc;IACd,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;;EAEA,mCAAmC;EACnC;IACE,wBAAwB;EAC1B;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,wBAAwB;IACxB,6BAA6B;IAC7B,oBAAoB;IACpB,2BAA2B;EAC7B;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,sBAAsB;EACtB,8EAA8E;EAC9E,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6EAA6E;EAC7E,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;;;EAGE,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;EAC7C;;EAEA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,uBAAuB;EACvB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,uBAAuB;EACzB;AACF;AACA,2DAA2D;AAC3D;EACE;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,oBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAmD;EACnD,qCAAqC;EACrC,6CAA6C;EAC7C,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,+DAA+D;EAC/D,qDAAqD;EACrD,2BAA2B;EAC3B,4DAA4D;AAC9D;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,uCAAuC,EAAE,UAAU,EAAE;EAC5D,KAAK,iCAAiC,EAAE,UAAU,EAAE;AACtD;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,oCAAoC;EACpC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;EACpC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,oDAAoD;AACtD;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,wCAAwC;EACxC,wBAAwB;EACxB,8BAA8B;EAC9B,oCAAoC;EACpC,oBAAoB;EACpB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,oBAAkB;EAClB,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,oDAAoD;EACpD,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,wEAAwE;EACxE,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,qGAAqG;EACrG,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,wEAAwE;EACxE,wGAAwG;AAC1G;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;AAC7B","sourcesContent":["* {\n  margin: 0px;\n  padding: 0px;\n}\n\n/* Base styling */\n.bulk-collection-v1-container {\n  padding: 0;\n  width: 100%;\n  margin: 0;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);\n  position: relative;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n  font-size: 0.9rem;\n  padding-top: 60px;\n}\n\n.bulk-collection-content {\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.bulk-collection-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n  border-bottom: none;\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  width: 100%;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);\n  position: relative;\n  z-index: 1001;\n}\n\n.back-button-bulk {\n  display: flex;\n  align-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  padding: 8px 12px;\n  margin-right: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: white;\n  font-weight: 500;\n  background: rgba(255, 255, 255, 0.2);\n  font-size: 13px;\n}\n\n.back-button-bulk:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.back-button-bulk svg {\n  margin-right: 8px;\n}\n\n.bulk-collection-header .bulk-heading {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #fff;\n  flex-grow: 1;\n  letter-spacing: -0.5px;\n}\n\n.bulk-collection-header .header-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* Premium Dairy Info Card - Updated Styling */\n.dairy-owner-info-card {\n  flex: 1;\n  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);\n  border-radius: 12px;\n  padding: 1rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 120px;\n  border: 1px solid rgba(59, 130, 246, 0.15);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.dairy-owner-info-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #3b82f6 0%, #8b5cf6 100%);\n}\n\n.dairy-owner-info-card:hover {\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n  transform: translateY(-2px);\n  border-color: rgba(59, 130, 246, 0.25);\n}\n\n/* Current Rate Info Card - New Styling */\n.current-rate-info-card-bulk {\n  flex: 1;\n  background: linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%);\n  border-radius: 12px;\n  padding: 0.5rem 1rem 1rem 1rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-height: 120px;\n  border: 1px solid rgba(34, 197, 94, 0.15);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.current-rate-info-card-bulk::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #22c55e 0%, #10b981 100%);\n}\n\n.current-rate-info-card-bulk:hover {\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n  transform: translateY(-2px);\n  border-color: rgba(34, 197, 94, 0.25);\n}\n\n/* Card Heading Styling */\n.card-heading {\n  /* margin: 0 0 1rem 0; */\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #1f2937;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid rgba(59, 130, 246, 0.2);\n  text-align: center;\n  letter-spacing: -0.3px;\n}\n\n.current-rate-info-card-bulk .card-heading {\n  border-bottom-color: rgba(34, 197, 94, 0.2);\n  color: #065f46;\n}\n\n/* Rate Card Heading - No Top Padding */\n.rate-card-heading {\n  margin-bottom: 20px;\n  padding: 0.5rem 0 0.5rem 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #065f46;\n  border-bottom: 2px solid rgba(34, 197, 94, 0.2);\n  text-align: center;\n  letter-spacing: -0.3px;\n}\n\n.dairy-owner-info-content {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.dairy-info-wrapper {\n  /* border: solid 2px red; */\n  display: flex;\n  gap: 16px;\n  width: 100%;\n  align-items: stretch;\n  margin-bottom: 10px;\n  padding: 12px;\n  border-radius: 12px;\n}\n\n/* Mobile and Tablet Layout - Stack cards vertically */\n@media (max-width: 1024px) {\n  .dairy-info-wrapper {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .rate-settings-modern-card,\n  .wallet-simple-card {\n    /* flex: 1; */\n    width: 100%;\n  }\n}\n\n.dairy-details-bulk,\n.owner-details-bulk {\n  flex: 0 1 auto;\n  min-width: 45%;\n  display: flex;\n  flex-direction: row;\n  gap: 6px;\n}\n\n.info-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0;\n  gap: 0.4rem;\n}\n\n.info-icon {\n  font-size: 0.9rem;\n  color: #2563eb;\n  margin-right: 0;\n  width: 16px;\n  flex-shrink: 0;\n}\n\n.info-label {\n  font-weight: 600;\n  color: #2563eb;\n  margin-right: 0.2rem;\n  min-width: auto;\n  font-size: 0.7rem;\n  white-space: nowrap;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.info-value {\n  color: #1f2937;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.info-loading {\n  color: #6c757d;\n  text-align: center;\n  padding: 10px;\n  font-style: italic;\n}\n\n/* Loading state */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n}\n\n.spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-left-color: #007bff;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Messages */\n.success-message,\n.error-message {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.success-message {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.error-message {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n  justify-content: space-between;\n}\n\n.success-message svg,\n.error-message svg {\n  margin-right: 10px;\n  font-size: 1.2em;\n}\n\n.close-error {\n  background: none;\n  border: none;\n  color: #721c24;\n  cursor: pointer;\n  padding: 5px;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Current Rate - Outer Card with Green Border */\n.current-rate-info {\n  flex: 1;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 8px;\n  padding: 12px 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 110px;\n  border: 1px solid #e5e7eb;\n  transition: all 0.3s ease;\n  margin-bottom: 12px;\n  position: relative;\n  overflow: hidden;\n}\n\n.current-rate-info::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #10b981 0%, #059669 100%);\n}\n\n.current-rate-info:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n/* 50-50 Layout for Rate Info */\n.rate-info-row {\n  display: flex;\n  gap: 12px;\n  align-items: stretch;\n}\n\n/* Premium Rate Info Items - Compact (No Green Border) */\n.rate-info-item {\n  flex: 1;\n  min-width: 0;\n  background: linear-gradient(135deg, #f0f9ff 0%, #ffffff 100%);\n  border: 1px solid rgba(59, 130, 246, 0.15);\n  border-radius: 8px;\n  padding: 0.6rem;\n  min-height: 45px;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.rate-info-item:hover {\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n  border-color: rgba(59, 130, 246, 0.25);\n}\n\n/* Premium Global Settings - Compact */\n.global-settings {\n  background: linear-gradient(135deg, #fef3c7 0%, #ffffff 100%);\n  border-radius: 10px;\n  padding: 0.75rem;\n  margin-bottom: 0.75rem;\n  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.06);\n  width: 100%;\n  max-width: 100%;\n  border: 1px solid rgba(251, 191, 36, 0.2);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.global-settings::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #f59e0b 0%, #f97316 100%);\n}\n\n.global-settings:hover {\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n  transform: translateY(-2px);\n  border-color: rgba(251, 191, 36, 0.3);\n}\n\n.global-settings-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n}\n\n.global-setting {\n  flex: 1;\n  min-width: 150px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.global-setting label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  color: #374151;\n  font-size: 13px;\n}\n\n.global-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 13px;\n  transition: all 0.2s ease;\n}\n\n.global-input:focus {\n  border-color: #2563eb;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n/* Rate display styles */\n.rate-display {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 1rem;\n}\n\n.rate-display p {\n  margin: 0;\n  font-weight: 500;\n  color: #333;\n}\n\n/* Rate Type Section - Now part of rate-info-item */\n\n.rate-type-display {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 1rem;\n}\n\n.rate-type-display p {\n  margin: 0;\n  font-weight: 500;\n  color: #333;\n}\n\n.rate-edit {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n}\n\n.rate-type-edit {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n}\n\n.rate-type-edit label {\n  margin: 0;\n  font-weight: 500;\n  color: #333;\n}\n\n.rate-type-input-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.rate-type-input-group label {\n  margin: 0;\n  font-weight: 500;\n  color: #333;\n  white-space: nowrap;\n}\n\n.rate-type-select {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n  background-size: 12px;\n  padding-right: 30px;\n  background-color: #fff;\n  font-size: 13px;\n  transition: all 0.2s ease;\n}\n\n.rate-type-select:hover {\n  border-color: #2563eb;\n}\n\n.rate-type-select:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.rate-type-saving-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #10b981;\n  font-size: 0.85rem;\n  margin-left: 10px;\n  padding: 4px 8px;\n  background-color: rgba(16, 185, 129, 0.1);\n  border-radius: 4px;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.6;\n  }\n}\n\n.edit-rate-button {\n  display: flex;\n  align-items: center;\n  background: #2563eb;\n  border: none;\n  border-radius: 6px;\n  padding: 8px 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: white !important;\n  font-weight: 500;\n  font-size: 13px;\n  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.15);\n}\n\n.edit-rate-button:hover {\n  background: #1d4ed8;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n}\n\n.edit-rate-button:hover svg {\n  color: black !important;\n}\n\n.edit-rate-button svg {\n  margin-right: 8px;\n  color: white !important;\n  transition: color 0.3s ease;\n}\n\n/* Rate Edit Form */\n.rate-edit {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.rate-edit label {\n  margin: 0;\n  font-weight: 500;\n  color: #333;\n}\n\n.rate-input {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  margin-right: 10px;\n  width: 120px;\n  font-size: 13px;\n  transition: all 0.2s ease;\n}\n\n.rate-input:focus {\n  border-color: #2563eb;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.save-rate-button-bulk {\n  display: flex;\n  align-items: center;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  border: none;\n  border-radius: 6px;\n  padding: 8px 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: white !important;\n  font-weight: 600;\n  font-size: 13px;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);\n}\n\n.save-rate-button-bulk:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.3);\n}\n\n.save-rate-button-bulk svg {\n  margin-right: 8px;\n}\n\n.save-rate-button-bulk:disabled {\n  background: #d1d5db;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* CSV/Excel Grid Layout */\n.csv-grid-container {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  margin-bottom: 12px;\n  width: 100%;\n  overflow-x: auto;\n  max-width: 100%;\n  margin: 0 auto;\n  border: 1px solid #e5e7eb;\n}\n\n.excel-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 14px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f0f4f8 100%);\n  border-bottom: 1px solid #e5e7eb;\n  border-radius: 8px 8px 0 0;\n  gap: 10px;\n}\n\n.toolbar-left {\n  display: flex;\n  gap: 8px;\n}\n\n.toolbar-right {\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n}\n\n/* Collection Date Time Controls - New Larger Design */\n.collection-date-time-controls {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  padding: 12px 16px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.collection-date-control,\n.collection-time-control {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 180px;\n}\n\n.collection-date-control label,\n.collection-time-control label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  white-space: nowrap;\n}\n\n.collection-date-input,\n.collection-time-input {\n  padding: 8px 12px;\n  margin: 0;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  color: #374151;\n  transition: all 0.2s ease;\n  width: 100%;\n  height: 36px;\n  text-align: center;\n  box-sizing: border-box;\n  font-weight: 500;\n}\n\n.collection-date-input:focus,\n.collection-time-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n\n.collection-date-input:hover,\n.collection-time-input:hover {\n  border-color: #94a3b8;\n}\n\n/* Responsive adjustments for collection date time controls */\n@media (max-width: 768px) {\n  .collection-date-time-controls {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 12px;\n    padding: 10px 12px;\n  }\n\n  .collection-date-control,\n  .collection-time-control {\n    min-width: 160px;\n  }\n\n  .collection-date-input,\n  .collection-time-input {\n    height: 32px;\n    font-size: 13px;\n    padding: 6px 10px;\n  }\n}\n\n.date-control,\n.time-control {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  min-width: 70px;\n}\n\n.date-control label,\n.time-control label {\n  font-size: 0.7rem;\n  font-weight: 500;\n  color: #64748b;\n  white-space: nowrap;\n  margin-bottom: 1px;\n}\n\n.toolbar-date-input,\n.toolbar-time-input {\n  padding: 2px 8px;\n  margin: 0;\n  border: 1px solid #cbd5e1;\n  border-radius: 3px;\n  font-size: 11px;\n  background: white;\n  color: #374151;\n  transition: all 0.2s ease;\n  width: 100%;\n  height: 22px;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.toolbar-date-input:focus,\n.toolbar-time-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.1);\n}\n\n.toolbar-date-input:hover,\n.toolbar-time-input:hover {\n  border-color: #94a3b8;\n}\n\n.add-row-button,\n.preview-button {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.add-row-button {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white !important;\n}\n\n.add-row-button:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n/* Mobile Add Customer Button Styling */\n.mobile-add-customer-button {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white !important;\n}\n\n.mobile-add-customer-button:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n.mobile-add-customer-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.mobile-add-customer-button svg {\n  margin-right: 6px;\n  font-size: 14px;\n}\n\n/* Edit Supplier Button Positioning */\n.edit-supplier-btn {\n  margin-left: auto !important;\n  position: relative;\n  z-index: 10;\n}\n\n.excel-toolbar {\n  position: relative;\n}\n\n/* Mobile responsive styles for Edit Supplier button */\n@media (max-width: 768px) {\n  .edit-supplier-btn {\n    width: 100%;\n    margin-left: 0 !important;\n    margin-top: 8px;\n    order: 3;\n  }\n\n  .excel-toolbar {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n  }\n\n  .submit-preview-button {\n    width: 100%;\n    margin-top: 10px;\n    order: 4;\n  }\n}\n\n@media (max-width: 576px) {\n  .edit-supplier-btn {\n    width: 100%;\n    margin-left: 0 !important;\n    margin-top: 8px;\n    order: 3;\n  }\n\n  .excel-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .submit-preview-button {\n    width: 100%;\n    margin-top: 10px;\n    order: 4;\n  }\n}\n\n/* Submit/Preview Button Styling */\n.submit-preview-button {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: white !important;\n}\n\n.submit-preview-button:hover {\n  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n}\n\n.submit-preview-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.submit-preview-button svg {\n  margin-right: 6px;\n  font-size: 14px;\n}\n\n/* Preview Button (for other uses) - keep existing styling */\n.preview-button {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: white !important;\n}\n\n.preview-button:hover {\n  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n}\n\n.preview-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.preview-button svg {\n  margin-right: 6px;\n  font-size: 14px;\n}\n\n.add-row-button svg,\n.preview-button svg {\n  margin-right: 6px;\n  font-size: 14px;\n}\n\n.preview-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Excel Table Styling */\n.excel-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1200px;\n  /* Ensure minimum width to fit all columns */\n}\n\n.excel-table th,\n.excel-table td {\n  border: 1px solid #e5e7eb;\n  padding: 0;\n  position: relative;\n  height: 34px;\n  overflow: visible;\n  font-size: 13px;\n}\n\n.excel-table th {\n  background-color: #f3f4f6;\n  font-weight: 600;\n  text-align: center;\n  padding: 8px 4px;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  border-bottom: 1px solid #e5e7eb;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #374151;\n}\n\n.excel-table tbody {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.excel-table .data-row:hover {\n  background-color: #f8fafc;\n}\n\n.excel-table .data-row:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.excel-table .data-row:nth-child(even):hover {\n  background-color: #f0f5fa;\n}\n\n.excel-table td.has-error {\n  background-color: rgba(255, 0, 0, 0.05);\n}\n\n.excel-cell-input,\n.excel-cell-select {\n  width: 100%;\n  height: 100%;\n  padding: 0 6px;\n  border: none;\n  background: transparent;\n  font-size: 16px !important;\n}\n\n/* Style for disabled inputs to make them appear faded */\n.excel-cell-input:disabled,\n.excel-cell-select:disabled {\n  background-color: #f5f5f5;\n  color: #9e9e9e;\n  cursor: not-allowed;\n  opacity: 0.7;\n  border-left: 2px solid #e0e0e0;\n}\n\n.excel-cell-input:focus,\n.excel-cell-select:focus {\n  outline: none;\n  box-shadow: inset 0 0 0 2px #4d90fe;\n}\n\n.excel-cell-select {\n  appearance: none;\n  -webkit-appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 6px center;\n  background-size: 12px;\n  padding-right: 24px;\n}\n\n.calculated-cell {\n  position: relative;\n}\n\n.calc-indicator {\n  position: absolute;\n  top: 0;\n  right: 2px;\n  color: #0066cc;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.calc-indicator.auto {\n  color: #28a745;\n  background-color: rgba(40, 167, 69, 0.1);\n  padding: 0 4px;\n  border-radius: 2px;\n  right: 4px;\n  top: 2px;\n  font-size: 10px;\n}\n\n/* Special styling for calculated fields based on rate type */\n.calculated-cell .excel-cell-input:disabled {\n  background-color: #f0f8ff;\n  /* Light blue background */\n  color: #006699;\n  border-left: 2px solid #4dabf7;\n  opacity: 0.8;\n}\n\n/* Auto-calculated field style */\n.excel-cell-input.auto-calculated {\n  background-color: #f0f8ff;\n  font-style: italic;\n}\n\n/* Disabled field container */\n.disabled-field {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n/* Readonly field container */\n.readonly-field {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n/* Editable field container */\n.editable-field {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n/* Editable Base SNF input style - removed color to look like regular input */\n.editable-field .excel-cell-input {\n  font-weight: 500;\n}\n\n.editable-field .excel-cell-input:focus {\n  outline: none;\n  box-shadow: inset 0 0 0 2px #4d90fe;\n}\n\n/* Readonly input style */\n.excel-cell-input.readonly-input {\n  background-color: #f0f7ff;\n  color: #495057;\n  cursor: default;\n  border-color: #b8daff;\n  font-weight: 500;\n}\n\n/* Readonly indicator */\n.readonly-indicator {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 12px;\n  color: #6c757d;\n  pointer-events: none;\n}\n\n/* Disabled input style */\n.excel-cell-input.disabled-input {\n  background-color: #f6f6f6;\n  color: #b0b0b0;\n  text-decoration: line-through;\n  opacity: 0.6;\n}\n\n/* Indicator for disabled fields */\n.disabled-indicator {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 10px;\n  color: #999;\n  background-color: rgba(0, 0, 0, 0.05);\n  padding: 1px 4px;\n  border-radius: 2px;\n  pointer-events: none;\n  /* Prevent it from blocking interactions */\n  white-space: nowrap;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  opacity: 0.8;\n}\n\n.calc-info {\n  margin-top: -15px;\n  margin-bottom: 15px;\n  color: #0066cc;\n  font-size: 13px;\n  font-style: italic;\n}\n\n.cell-error {\n  position: absolute;\n  bottom: -18px;\n  left: 0;\n  width: 100%;\n  background-color: #f8d7da;\n  color: #721c24;\n  font-size: 12px;\n  padding: 2px 4px;\n  text-align: center;\n  z-index: 20;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cell-warning {\n  position: absolute;\n  bottom: -18px;\n  left: 0;\n  width: 100%;\n  background-color: #fff3cd;\n  color: #856404;\n  font-size: 12px;\n  padding: 2px 4px;\n  text-align: center;\n  z-index: 20;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.empty-message {\n  text-align: center;\n  padding: 20px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.delete-row-btn {\n  background: none;\n  border: none;\n  color: #dc3545;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.delete-row-btn:hover {\n  background-color: rgba(220, 53, 69, 0.1);\n}\n\n/* Customer search cell and dropdown styling */\n.customer-search-cell {\n  position: relative;\n  width: 100%;\n}\n\n.excel-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n}\n\n.dropdown-item {\n  padding: 8px 12px;\n  border-bottom: 1px solid #eee;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.dropdown-item:hover {\n  background-color: #f8f9fa;\n  cursor: pointer;\n}\n\n.dropdown-item.selected {\n  background-color: #e9ecef;\n  font-weight: bold;\n}\n\n.dropdown-item.add-new {\n  color: #007bff;\n  font-weight: 500;\n  background-color: #f8f9fa;\n  border-top: 1px solid #ddd;\n}\n\n.no-results {\n  padding: 8px 12px;\n  color: #888;\n  font-style: italic;\n  text-align: center;\n}\n\n/* Make sure the dropdown appears above other elements */\n.excel-table .data-row td {\n  position: relative;\n}\n\n/* Highlight active search cell */\n.excel-cell-input:focus {\n  outline: 2px solid #1a73e8;\n  border-color: #1a73e8;\n}\n\n/* Enhance the visibility of customer cell */\n.excel-table td:first-child .excel-cell-input {\n  width: 100%;\n  min-width: 150px;\n}\n\n/* Premium Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1002;\n  overflow-y: auto;\n  padding: 20px;\n  backdrop-filter: blur(8px);\n  animation: modalFadeIn 0.3s ease-out;\n}\n\n.modal-content {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n  width: 90%;\n  max-width: 800px;\n  max-height: 95vh;\n  overflow: hidden;\n  position: relative;\n  border: 1px solid rgba(59, 130, 246, 0.1);\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n.modal-content::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #3b82f6 0%, #8b5cf6 100%);\n  border-radius: 16px 16px 0 0;\n}\n\n/* Modal Styles */\n.preview-modal,\n.new-customer-modal {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  max-width: 800px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  animation: modalFadeIn 0.3s ease-in-out;\n  overflow: hidden;\n}\n\n.new-customer-modal {\n  max-width: 550px;\n  /* Slightly wider */\n  margin: 20px;\n}\n\n.preview-modal {\n  max-width: 1600px;\n  /* Increased for better desktop viewing */\n  margin: 20px;\n  width: 98%;\n  /* Nearly full width */\n  max-height: 95vh;\n  /* Increased height to reduce scrolling */\n}\n\n/* Specific padding adjustments for the new customer modal */\n.new-customer-modal .modal-header {\n  padding: 22px 28px;\n}\n\n.new-customer-modal .modal-body {\n  padding: 28px 32px;\n}\n\n.new-customer-modal .modal-footer {\n  padding: 20px 28px;\n}\n\n.new-customer-modal .modal-footer button {\n  padding: 12px 20px;\n  min-width: 100px;\n}\n\n/* Specific styling for the preview modal */\n.preview-modal .modal-header {\n  padding: 22px 28px;\n}\n\n.preview-modal .modal-body {\n  padding: 24px 28px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  gap: 0;\n  /* Remove default gap to ensure proper spacing */\n}\n\n.preview-modal .modal-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 28px;\n}\n\n.preview-modal .modal-footer .rate-settings-btn {\n  order: -1;\n  /* Move rate settings button to the left */\n  margin-right: auto;\n  /* Push it to the far left */\n}\n\n.preview-modal .modal-footer .cancel-button {\n  margin-left: auto;\n  /* Keep cancel on the right */\n}\n\n.preview-modal .modal-footer .confirm-button {\n  margin-left: 12px;\n  /* Space between cancel and confirm */\n}\n\n.preview-modal .modal-footer button {\n  padding: 12px 20px;\n  min-width: 100px;\n}\n\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid rgba(59, 130, 246, 0.1);\n  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);\n  position: relative;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.2rem;\n  color: #1e293b;\n  font-weight: 700;\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.close-modal-button {\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\n  border: 1px solid rgba(148, 163, 184, 0.3);\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.close-modal-button:hover {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  border-color: #ef4444;\n  color: #ef4444;\n  transform: rotate(90deg);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);\n}\n\n.modal-body {\n  padding: 1.5rem;\n  overflow-y: auto;\n  flex-grow: 1;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid rgba(59, 130, 246, 0.1);\n  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);\n}\n\n.modal-footer button {\n  margin-left: 8px;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  transition: all 0.3s ease;\n  font-size: 0.85rem;\n}\n\n.cancel-button {\n  background: linear-gradient(135deg, #6c757d 0%, #dc3545 100%);\n  color: white;\n  border: 1px solid #dc3545;\n  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.2);\n}\n\n.cancel-button:hover {\n  background: linear-gradient(135deg, #5a6268 0%, #c53030 100%);\n  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);\n  transform: translateY(-1px);\n}\n\n.confirm-button {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  border: 1px solid #059669;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);\n}\n\n.confirm-button:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n  transform: translateY(-1px);\n}\n\n.save-button:disabled {\n  background: #c2c7c7;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.confirm-button svg,\n.save-button svg {\n  margin-right: 8px;\n}\n\n/* New customer form */\n.form-instructions {\n  margin-bottom: 24px;\n  color: #5f6368;\n  font-size: 14px;\n  grid-column: span 2;\n}\n\n.form-group {\n  margin-bottom: 10px;\n  position: relative;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: 500;\n  color: #3c4043;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 14px 16px;\n  border: 1px solid #dadce0;\n  border-radius: 4px;\n  font-size: 14px;\n  color: #202124;\n  transition: all 0.2s;\n  background-color: #fff;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  border-color: #1a73e8;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);\n}\n\n.form-group input::placeholder,\n.form-group textarea::placeholder {\n  color: #80868b;\n}\n\n.form-group input:hover,\n.form-group textarea:hover {\n  border-color: #bdc1c6;\n}\n\n/* Required field indicator */\n.form-group label[for=\"customer-name\"]::after {\n  content: \" *\";\n  color: #d93025;\n}\n\n/* Organize form in columns for larger screens */\n@media (min-width: 576px) {\n  .modal-body {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n  }\n\n  .new-customer-modal .modal-body {\n    gap: 24px;\n  }\n\n  .form-group:last-child {\n    grid-column: span 2;\n    margin-top: 8px;\n  }\n}\n\n/* Column widths in the Excel table */\n.excel-table th:nth-child(1),\n/* Serial Number */\n.excel-table td:nth-child(1) {\n  width: 50px;\n  min-width: 50px;\n  text-align: center;\n}\n\n.excel-table th:nth-child(2),\n/* Customer */\n.excel-table td:nth-child(2) {\n  width: 180px;\n  min-width: 180px;\n}\n\n.excel-table th:nth-child(3),\n/* Weight */\n.excel-table th:nth-child(4),\n/* Fat */\n.excel-table th:nth-child(5),\n/* SNF */\n.excel-table th:nth-child(6),\n/* CLR */\n.excel-table th:nth-child(7),\n/* Milk Rate */\n.excel-table td:nth-child(3),\n.excel-table td:nth-child(4),\n.excel-table td:nth-child(5),\n.excel-table td:nth-child(6),\n.excel-table td:nth-child(7) {\n  width: 85px;\n  min-width: 85px;\n}\n\n.excel-table th:nth-child(8),\n/* Base SNF */\n.excel-table th:nth-child(9),\n/* Time */\n.excel-table th:nth-child(10),\n/* Animal Type */\n.excel-table td:nth-child(8),\n.excel-table td:nth-child(9),\n.excel-table td:nth-child(10) {\n  width: 100px;\n  min-width: 100px;\n}\n\n.excel-table th:nth-child(11),\n/* Actions */\n.excel-table td:nth-child(11) {\n  width: 60px;\n  min-width: 60px;\n}\n\n/* Style the serial number cell */\n.serial-number-cell {\n  text-align: center;\n  font-weight: 500;\n  background-color: #f8f9fa;\n}\n\n/* Preview table column widths with serial number */\n\n/* Bulk Preview Modal - Responsive Design */\n.bulk-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  overflow-y: auto;\n  padding: 10px;\n  backdrop-filter: blur(8px);\n  animation: bulkModalFadeIn 0.3s ease-out;\n}\n\n.bulk-preview-modal {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n  width: 95%;\n  max-width: 1400px;\n  max-height: 95vh;\n  overflow: hidden;\n  position: relative;\n  border: 1px solid rgba(59, 130, 246, 0.1);\n  animation: bulkModalSlideIn 0.3s ease-out;\n}\n\n.bulk-preview-modal::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #3b82f6 0%, #8b5cf6 100%);\n  border-radius: 12px 12px 0 0;\n}\n\n@keyframes bulkModalFadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes bulkModalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n/* Modal Header */\n.bulk-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid rgba(59, 130, 246, 0.1);\n  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);\n  position: relative;\n}\n\n.bulk-modal-title {\n  margin: 0;\n  font-size: 1.25rem;\n  color: #1e293b;\n  font-weight: 700;\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.bulk-close-modal-button {\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\n  border: 1px solid rgba(148, 163, 184, 0.3);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: #64748b;\n  font-size: 1rem;\n}\n\n.bulk-close-modal-button:hover {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  border-color: #ef4444;\n  color: #ef4444;\n  transform: rotate(90deg);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);\n}\n\n/* Modal Body */\n.bulk-modal-body {\n  padding: 20px;\n  overflow-y: auto;\n  flex-grow: 1;\n  max-height: calc(95vh - 180px);\n}\n\n.bulk-preview-header {\n  margin-bottom: 20px;\n}\n\n.bulk-preview-info {\n  margin: 0;\n  color: #64748b;\n  font-size: 0.95rem;\n  font-weight: 500;\n  text-align: center;\n  padding: 12px;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  border-radius: 8px;\n  border: 1px solid rgba(59, 130, 246, 0.1);\n}\n\n/* Table Container */\n.bulk-preview-table-container {\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  overflow-x: hidden;\n  /* Hide horizontal scrollbar on desktop */\n}\n\n.bulk-table-wrapper {\n  min-width: 100%;\n}\n\n.bulk-preview-table {\n  width: 100%;\n  min-width: auto;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n  table-layout: fixed;\n}\n\n/* Table Header */\n.bulk-table-header {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.bulk-header-row {\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.bulk-header-row .bulk-cell {\n  padding: 12px 8px;\n  text-align: center;\n  font-weight: 600;\n  color: #374151;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-right: 1px solid #e5e7eb;\n  white-space: nowrap;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.bulk-header-row .bulk-cell:last-child {\n  border-right: none;\n}\n\n/* Table Body */\n.bulk-table-body .bulk-data-row {\n  border-bottom: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n}\n\n.bulk-table-body .bulk-data-row:hover {\n  background-color: #f8fafc;\n  transform: scale(1.001);\n}\n\n.bulk-table-body .bulk-data-row:nth-child(even) {\n  background-color: #fafbfc;\n}\n\n.bulk-table-body .bulk-cell {\n  padding: 10px 8px;\n  text-align: center;\n  border-right: 1px solid #f1f5f9;\n  font-size: 0.85rem;\n  color: #374151;\n  vertical-align: middle;\n}\n\n.bulk-table-body .bulk-cell:last-child {\n  border-right: none;\n}\n\n/* Cell Specific Styles */\n.bulk-cell-number {\n  width: 60px;\n  font-weight: 600;\n  background-color: #f8fafc !important;\n}\n\n.bulk-cell-customer {\n  width: 200px;\n  text-align: left;\n  font-weight: 500;\n  padding-left: 12px;\n}\n\n.bulk-cell-date {\n  width: 100px;\n}\n\n.bulk-cell-time {\n  width: 80px;\n}\n\n.bulk-cell-quantity {\n  width: 100px;\n}\n\n.bulk-quantity-value {\n  font-weight: 600;\n  color: #059669;\n}\n\n.bulk-cell-fat,\n.bulk-cell-clr,\n.bulk-cell-snf,\n.bulk-cell-base-snf {\n  width: 70px;\n}\n\n.bulk-cell-fat-kg,\n.bulk-cell-snf-kg {\n  width: 80px;\n}\n\n.bulk-cell-rate {\n  width: 90px;\n}\n\n.bulk-rate-value {\n  font-weight: 600;\n  color: #2563eb;\n}\n\n.bulk-cell-amount {\n  width: 100px;\n}\n\n.bulk-amount-value {\n  font-weight: 700;\n  color: #059669;\n  font-size: 0.9rem;\n}\n\n/* Table Footer */\n.bulk-table-footer {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-top: 2px solid #e5e7eb;\n  position: sticky;\n  bottom: 0;\n  z-index: 10;\n}\n\n.bulk-footer-row .bulk-cell {\n  padding: 12px 8px;\n  font-weight: 600;\n  border-right: 1px solid #e5e7eb;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n}\n\n.bulk-footer-row .bulk-cell:last-child {\n  border-right: none;\n}\n\n.bulk-total-label {\n  text-align: center;\n  color: #374151;\n  font-size: 16px !important;\n  font-weight: 700;\n}\n\n.bulk-total-label span {\n  color: #007bff;\n}\n\n.bulk-total-value {\n  text-align: center;\n  font-weight: 700;\n  font-size: 0.95rem;\n}\n\n.bulk-total-amount {\n  color: #059669;\n}\n\n.bulk-total-quantity {\n  color: #2563eb;\n}\n\n/* Modal Footer */\n.bulk-modal-footer {\n  padding: 16px 20px;\n  border-top: 1px solid rgba(59, 130, 246, 0.1);\n  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);\n}\n\n.bulk-footer-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.bulk-action-buttons {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.bulk-footer-actions button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  min-height: 40px;\n}\n\n.bulk-cancel-button {\n  background: #f8f9fa;\n  color: #6c757d;\n  border: 1px solid #dee2e6;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.bulk-cancel-button:hover {\n  background: #e9ecef;\n  color: #495057;\n  border-color: #adb5bd;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n  transform: translateY(-1px);\n}\n\n.bulk-preview-settings-button {\n  background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);\n  color: white;\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.2);\n  width: fit-content;\n  padding: 5px;\n}\n\n.bulk-preview-settings-button:hover {\n  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);\n  transform: translateY(-1px);\n}\n\n.bulk-confirm-button {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);\n}\n\n.bulk-confirm-button:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n  transform: translateY(-1px);\n}\n\n.bulk-confirm-button:disabled {\n  background: #d1d5db;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Responsive Design */\n\n/* Large Desktop (1200px and up) */\n@media (min-width: 1200px) {\n  .bulk-preview-modal {\n    width: 95%;\n    max-width: 1800px;\n    max-height: 95vh;\n    overflow: visible;\n  }\n\n  .bulk-modal-body {\n    max-height: calc(95vh - 180px);\n    overflow-x: hidden;\n    /* Hide horizontal scrollbar on desktop */\n    overflow-y: auto;\n  }\n\n  .bulk-preview-table-container {\n    overflow-x: hidden;\n    /* Hide horizontal scrollbar on desktop */\n  }\n\n  .bulk-preview-table {\n    width: 100%;\n    min-width: auto;\n    table-layout: fixed;\n  }\n\n  .bulk-cell-customer {\n    width: 200px;\n    min-width: 200px;\n  }\n}\n\n/* Desktop (992px to 1199px) */\n@media (max-width: 1199px) {\n  .bulk-preview-modal {\n    width: 95%;\n    max-width: 1400px;\n    max-height: 95vh;\n    overflow: visible;\n  }\n\n  .bulk-modal-body {\n    padding: 16px;\n    max-height: calc(95vh - 160px);\n    overflow-x: auto;\n    overflow-y: auto;\n  }\n\n  .bulk-preview-info {\n    font-size: 0.9rem;\n    padding: 12px;\n  }\n\n  .bulk-preview-table {\n    width: 100%;\n    min-width: auto;\n    table-layout: fixed;\n  }\n\n  .bulk-modal-header {\n    padding: 14px 18px;\n  }\n\n  .bulk-modal-footer {\n    padding: 14px 18px;\n  }\n}\n\n/* Tablet (768px to 991px) */\n@media (max-width: 991px) {\n  .bulk-modal-overlay {\n    padding: 8px;\n  }\n\n  .bulk-preview-modal {\n    width: 98%;\n    max-width: none;\n    border-radius: 8px;\n    max-height: 95vh;\n  }\n\n  .bulk-preview-table-container {\n    overflow-x: auto;\n  }\n\n  .bulk-preview-table {\n    width: 100%;\n    min-width: 700px;\n    font-size: 0.8rem;\n    table-layout: auto;\n  }\n\n  .bulk-modal-header {\n    padding: 12px 16px;\n  }\n\n  .bulk-modal-title {\n    font-size: 1.1rem;\n  }\n\n  .bulk-modal-body {\n    padding: 12px;\n    max-height: calc(95vh - 160px);\n    overflow-x: auto;\n    overflow-y: auto;\n  }\n\n  .bulk-preview-info {\n    font-size: 0.85rem;\n    padding: 10px;\n  }\n\n  .bulk-header-row .bulk-cell,\n  .bulk-table-body .bulk-cell {\n    padding: 6px 4px;\n    font-size: 0.75rem;\n  }\n\n  .bulk-footer-row .bulk-cell {\n    padding: 8px 4px;\n    font-size: 0.8rem;\n  }\n\n  .bulk-footer-actions {\n    gap: 8px;\n  }\n\n  .bulk-action-buttons {\n    gap: 6px;\n  }\n\n  .bulk-footer-actions button {\n    padding: 8px 12px;\n    font-size: 0.8rem;\n    min-height: 36px;\n  }\n\n  .bulk-cell-number {\n    width: 50px;\n  }\n\n  .bulk-cell-customer {\n    width: 120px;\n    min-width: 120px;\n  }\n\n  .bulk-cell-date {\n    width: 80px;\n    min-width: 80px;\n  }\n\n  .bulk-cell-time {\n    width: 60px;\n    min-width: 60px;\n  }\n\n  .bulk-cell-quantity {\n    width: 80px;\n    min-width: 80px;\n  }\n\n  .bulk-cell-fat,\n  .bulk-cell-clr,\n  .bulk-cell-snf {\n    width: 60px;\n    min-width: 60px;\n  }\n\n  .bulk-cell-fat-kg,\n  .bulk-cell-snf-kg {\n    width: 70px;\n    min-width: 70px;\n  }\n\n  .bulk-cell-rate {\n    width: 70px;\n    min-width: 70px;\n  }\n\n  .bulk-cell-amount {\n    width: 80px;\n    min-width: 80px;\n  }\n}\n\n/* Mobile Large (576px to 767px) */\n@media (max-width: 767px) {\n  .bulk-modal-overlay {\n    padding: 4px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .bulk-preview-modal {\n    width: 95%;\n    max-width: none;\n    border-radius: 8px;\n    max-height: 95vh;\n    margin: auto;\n  }\n\n  .bulk-preview-table-container {\n    overflow-x: auto;\n  }\n\n  .bulk-preview-table {\n    width: 100%;\n    min-width: 550px;\n    font-size: 0.75rem;\n    table-layout: auto;\n  }\n\n  .bulk-modal-header {\n    padding: 12px;\n    position: sticky;\n    top: 0;\n    z-index: 20;\n  }\n\n  .bulk-modal-title {\n    font-size: 1rem;\n  }\n\n  .bulk-close-modal-button {\n    width: 32px;\n    height: 32px;\n    font-size: 0.9rem;\n  }\n\n  .bulk-modal-body {\n    padding: 8px;\n    max-height: calc(95vh - 140px);\n    overflow-x: auto;\n    overflow-y: auto;\n  }\n\n  .bulk-preview-header {\n    margin-bottom: 12px;\n  }\n\n  .bulk-preview-info {\n    font-size: 0.8rem;\n    padding: 8px;\n  }\n\n  .bulk-header-row .bulk-cell,\n  .bulk-table-body .bulk-cell {\n    padding: 5px 3px;\n    font-size: 0.7rem;\n  }\n\n  .bulk-footer-row .bulk-cell {\n    padding: 6px 3px;\n    font-size: 0.75rem;\n  }\n\n  .bulk-modal-footer {\n    padding: 12px;\n    position: sticky;\n    bottom: 0;\n    z-index: 20;\n  }\n\n  .bulk-footer-actions {\n    justify-content: center;\n    gap: 6px;\n  }\n\n  .bulk-action-buttons {\n    gap: 8px;\n    flex: 1;\n    justify-content: center;\n  }\n\n  .bulk-footer-actions button {\n    padding: 8px 14px;\n    font-size: 0.75rem;\n    min-height: 32px;\n    flex: 1;\n    min-width: 100px;\n  }\n\n  .bulk-footer-actions button span {\n    display: inline;\n    font-size: 0.55rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .bulk-cell-number {\n    width: 40px;\n  }\n\n  .bulk-cell-customer {\n    width: 100px;\n    min-width: 100px;\n  }\n\n  .bulk-cell-date {\n    width: 70px;\n    min-width: 70px;\n  }\n\n  .bulk-cell-time {\n    width: 50px;\n    min-width: 50px;\n  }\n\n  .bulk-cell-quantity {\n    width: 70px;\n    min-width: 70px;\n  }\n\n  .bulk-cell-fat,\n  .bulk-cell-clr,\n  .bulk-cell-snf {\n    width: 50px;\n    min-width: 50px;\n  }\n\n  .bulk-cell-fat-kg,\n  .bulk-cell-snf-kg {\n    width: 60px;\n    min-width: 60px;\n  }\n\n  .bulk-cell-rate {\n    width: 60px;\n    min-width: 60px;\n  }\n\n  .bulk-cell-amount {\n    width: 70px;\n    min-width: 70px;\n  }\n\n}\n\n/* Mobile Small (480px to 575px) */\n@media (max-width: 575px) {\n  .bulk-modal-overlay {\n    padding: 4px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .bulk-preview-modal {\n    width: 95%;\n    max-width: none;\n    border-radius: 8px;\n    max-height: 95vh;\n    margin: auto;\n  }\n\n  .bulk-preview-table-container {\n    overflow-x: auto;\n  }\n\n  .bulk-preview-table {\n    width: 100%;\n    min-width: 450px;\n    font-size: 0.7rem;\n    table-layout: auto;\n  }\n\n  .bulk-modal-header {\n    padding: 10px;\n  }\n\n  .bulk-modal-title {\n    font-size: 0.95rem;\n  }\n\n  .bulk-modal-body {\n    padding: 6px;\n    max-height: calc(95vh - 130px);\n    overflow-x: auto;\n    overflow-y: auto;\n  }\n\n  .bulk-preview-info {\n    font-size: 0.75rem;\n    padding: 6px;\n  }\n\n  .bulk-header-row .bulk-cell,\n  .bulk-table-body .bulk-cell {\n    padding: 4px 2px;\n    font-size: 0.65rem;\n  }\n\n  .bulk-footer-row .bulk-cell {\n    padding: 6px 2px;\n    font-size: 0.7rem;\n  }\n\n  .bulk-modal-footer {\n    padding: 8px;\n  }\n\n  .bulk-footer-actions {\n    gap: 4px;\n  }\n\n  .bulk-action-buttons {\n    gap: 6px;\n    flex-direction: column;\n  }\n\n  .bulk-footer-actions button {\n    padding: 6px 10px;\n    font-size: 0.7rem;\n    min-height: 30px;\n    min-width: 85px;\n  }\n\n  .bulk-footer-actions button span {\n    display: inline;\n    font-size: 0.5rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .bulk-cell-number {\n    width: 35px;\n  }\n\n  .bulk-cell-customer {\n    width: 80px;\n    min-width: 80px;\n  }\n\n  .bulk-cell-date {\n    width: 65px;\n    min-width: 65px;\n  }\n\n  .bulk-cell-time {\n    width: 45px;\n    min-width: 45px;\n  }\n\n  .bulk-cell-quantity {\n    width: 65px;\n    min-width: 65px;\n  }\n\n  .bulk-cell-fat,\n  .bulk-cell-clr,\n  .bulk-cell-snf {\n    width: 45px;\n    min-width: 45px;\n  }\n\n  .bulk-cell-fat-kg,\n  .bulk-cell-snf-kg {\n    width: 50px;\n    min-width: 50px;\n  }\n\n  .bulk-cell-rate {\n    width: 50px;\n    min-width: 50px;\n  }\n\n  .bulk-cell-amount {\n    width: 55px;\n    min-width: 55px;\n  }\n\n}\n\n/* Extra Small Mobile (320px to 479px) */\n@media (max-width: 479px) {\n  .bulk-modal-overlay {\n    padding: 4px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .bulk-preview-modal {\n    width: 95%;\n    max-width: none;\n    border-radius: 8px;\n    max-height: 80vh;\n    margin: auto;\n  }\n\n  .bulk-preview-table-container {\n    overflow-x: auto;\n  }\n\n  .bulk-preview-table {\n    width: 100%;\n    min-width: 380px;\n    font-size: 0.65rem;\n    table-layout: auto;\n  }\n\n  .bulk-modal-title {\n    font-size: 0.9rem;\n  }\n\n  .bulk-modal-body {\n    padding: 4px;\n    max-height: calc(80vh - 120px);\n    overflow-x: auto;\n    overflow-y: auto;\n  }\n\n  .bulk-preview-info {\n    font-size: 0.7rem;\n    padding: 4px;\n  }\n\n  .bulk-header-row .bulk-cell,\n  .bulk-table-body .bulk-cell {\n    padding: 3px 1px;\n    font-size: 0.6rem;\n  }\n\n  .bulk-footer-row .bulk-cell {\n    padding: 4px 1px;\n    font-size: 0.65rem;\n  }\n\n  .bulk-footer-actions button {\n    padding: 4px 8px;\n    font-size: 0.65rem;\n    min-height: 28px;\n    min-width: 75px;\n  }\n\n  .bulk-action-buttons {\n    gap: 4px;\n  }\n\n  .bulk-footer-actions button span {\n    display: inline;\n    font-size: 0.45rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .bulk-cell-number {\n    width: 30px;\n  }\n\n  .bulk-cell-customer {\n    width: 70px;\n    min-width: 70px;\n  }\n\n  .bulk-cell-date {\n    width: 55px;\n    min-width: 55px;\n  }\n\n  .bulk-cell-time {\n    width: 40px;\n    min-width: 40px;\n  }\n\n  .bulk-cell-quantity {\n    width: 55px;\n    min-width: 55px;\n  }\n\n  .bulk-cell-fat,\n  .bulk-cell-clr,\n  .bulk-cell-snf {\n    width: 40px;\n    min-width: 40px;\n  }\n\n  .bulk-cell-fat-kg,\n  .bulk-cell-snf-kg {\n    width: 45px;\n    min-width: 45px;\n  }\n\n  .bulk-cell-rate {\n    width: 45px;\n    min-width: 45px;\n  }\n\n  .bulk-cell-amount {\n    width: 50px;\n    min-width: 50px;\n  }\n\n}\n\n/* Landscape Orientation Adjustments */\n@media (max-height: 600px) and (orientation: landscape) {\n  .bulk-modal-overlay {\n    padding: 4px;\n  }\n\n  .bulk-preview-modal {\n    max-height: 95vh;\n  }\n\n  .bulk-modal-body {\n    max-height: calc(95vh - 120px);\n  }\n\n  .bulk-preview-header {\n    margin-bottom: 8px;\n  }\n\n  .bulk-preview-info {\n    padding: 4px 8px;\n    font-size: 0.75rem;\n  }\n\n  .bulk-header-row .bulk-cell,\n  .bulk-table-body .bulk-cell {\n    padding: 4px 2px;\n    font-size: 0.7rem;\n  }\n\n  .bulk-footer-row .bulk-cell {\n    padding: 6px 2px;\n    font-size: 0.75rem;\n  }\n\n  .bulk-modal-header {\n    padding: 8px 12px;\n  }\n\n  .bulk-modal-footer {\n    padding: 8px 12px;\n  }\n\n  .bulk-footer-actions button {\n    padding: 6px 10px;\n    font-size: 0.75rem;\n    min-height: 32px;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .bulk-modal-overlay {\n    position: static;\n    background: white;\n    padding: 0;\n  }\n\n  .bulk-preview-modal {\n    box-shadow: none;\n    border: 1px solid #000;\n    max-height: none;\n    width: 100%;\n  }\n\n  .bulk-modal-header,\n  .bulk-modal-footer {\n    display: none;\n  }\n\n  .bulk-preview-table {\n    min-width: auto;\n    width: 100%;\n    font-size: 0.8rem;\n  }\n\n  .bulk-preview-table-container {\n    overflow: visible;\n  }\n}\n\n.preview-table th:nth-child(1),\n/* Serial Number */\n.preview-table td:nth-child(1) {\n  width: 40px;\n  min-width: 40px;\n  text-align: center;\n}\n\n.preview-table th:nth-child(2),\n/* Customer */\n.preview-table td:nth-child(2) {\n  width: 20%;\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* For responsive behavior, adjust the container and table */\n.excel-container {\n  width: 100%;\n  overflow-x: auto;\n  padding: 0;\n  margin: 0;\n}\n\n@media (max-width: 1200px) {\n  .excel-table {\n    font-size: 12px;\n    /* Smaller font on smaller screens */\n    width: 100%;\n    min-width: 1200px;\n  }\n\n  .csv-grid-container {\n    overflow-x: auto;\n    width: 100%;\n  }\n\n  .excel-table th,\n  .excel-table td {\n    padding: 4px 6px;\n    height: 32px;\n  }\n}\n\n@media (max-width: 992px) {\n\n  .cell-customer select,\n  .cell-animal-type select,\n  .cell-milk-type select {\n    min-width: auto;\n    width: 100%;\n  }\n}\n\n/* Make all inputs more compact */\n.excel-table input,\n.excel-table select {\n  padding: 4px 6px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Table header font size fix */\n.excel-table th {\n  font-size: 16px !important;\n  font-weight: 600;\n}\n\n/* Mobile and tablet font size fix for excel-cell-input */\n@media (max-width: 1024px) {\n\n  .excel-cell-input,\n  .excel-cell-select {\n    font-size: 14px !important;\n  }\n\n  .global-time-header-select,\n  .global-base-snf-header-select,\n  .global-animal-type-header-select {\n    font-size: 14px !important;\n  }\n}\n\n/* Responsive styles */\n@media (max-width: 1400px) {\n  .bulk-collection-content {\n    width: 100%;\n    max-width: 100%;\n    padding: 0 15px;\n  }\n\n  .csv-grid-container {\n    max-width: 100%;\n    overflow-x: auto;\n  }\n}\n\n@media (max-width: 1200px) {\n  .preview-modal {\n    max-width: 95%;\n    margin: 15px;\n  }\n\n  .preview-table {\n    min-width: 800px;\n  }\n}\n\n@media (max-width: 992px) {\n  .preview-modal {\n    max-width: 98%;\n    margin: 10px;\n  }\n\n  .preview-table {\n    min-width: 700px;\n  }\n}\n\n/* Tablet specific styles */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .bulk-collection-v1-container {\n    padding: 1rem;\n    padding-top: 60px;\n  }\n\n  .dairy-info-wrapper {\n    flex-direction: row;\n    gap: 1.5rem;\n    padding: 1.5rem;\n    align-items: flex-start;\n    width: 100%;\n  }\n\n  .rate-settings-info-card {\n    min-height: 110px;\n    padding: 1.25rem;\n  }\n\n  .rate-settings-info-header {\n    margin-bottom: 0.875rem;\n  }\n\n  .rate-settings-icon-bg {\n    width: 34px;\n    height: 34px;\n    font-size: 15px;\n  }\n\n  .rate-settings-info-title {\n    font-size: 1.05rem;\n  }\n\n  .rate-settings-checklist li {\n    font-size: 0.85rem;\n    margin-bottom: 0.45rem;\n  }\n\n  .rate-settings-action-btn {\n    padding: 11px 18px;\n    font-size: 0.85rem;\n  }\n\n  .rate-settings-heading {\n    font-size: 1.05rem;\n    margin-bottom: 0.875rem;\n  }\n\n  .rate-settings-primary-btn {\n    padding: 11px 22px !important;\n    font-size: 0.9rem !important;\n    min-width: 130px !important;\n  }\n\n  .dairy-info-container {\n    flex: 1;\n    min-width: 0;\n    padding: 1.25rem;\n    overflow: visible;\n    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n    border-radius: 16px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n    border: 1px solid #e5e7eb;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .rate-info-container {\n    flex: 1;\n    min-width: 0;\n    padding: 1.25rem;\n    overflow: visible;\n    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n    border-radius: 16px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n    border: 1px solid #e5e7eb;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .dairy-info-content {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: 0.8rem;\n  }\n\n  .dairy-details-bulk,\n  .owner-details-bulk {\n    gap: 0.6rem;\n    flex: 1 1 100%;\n  }\n\n  .info-item {\n    padding: 0.6rem 0.8rem;\n    min-height: auto;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    background: rgba(255, 255, 255, 0.95);\n    border-radius: 12px;\n    border: 1px solid #f0f0f0;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .info-label {\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: #6b7280;\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n\n  .info-value {\n    font-size: 0.85rem;\n    color: #1f2937;\n    font-weight: 500;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1;\n    min-width: 0;\n  }\n\n  .rate-info-row {\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    align-items: stretch;\n    width: 100%;\n  }\n\n  .bulk-preview-settings-button {\n    width: 100%;\n    max-width: 200px;\n    padding: 8px 12px;\n    font-size: 0.85rem;\n  }\n\n  .rate-info-item {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    min-width: 0;\n    width: 100%;\n  }\n\n  .current-rate-info {\n    padding: 1rem;\n    display: flex;\n    flex-direction: row;\n    gap: 0.5rem;\n  }\n\n  .rate-type-input-group {\n    display: flex;\n    flex-direction: row;\n    gap: 0.5rem;\n    width: 100%;\n    align-items: center;\n  }\n\n  .rate-type-input-group label {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: #374151;\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n\n  .rate-type-select {\n    flex: 1;\n    min-width: 0;\n    padding: 0.5rem;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    font-size: 0.9rem;\n    background: white;\n  }\n\n  .submit-btn {\n    width: 100%;\n    padding: 0.6rem 1rem;\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    margin-top: 0.5rem;\n  }\n\n  .submit-btn:hover {\n    background: linear-gradient(135deg, #059669 0%, #047857 100%);\n    transform: translateY(-1px);\n  }\n\n  .submit-btn:disabled {\n    background: #9ca3af;\n    cursor: not-allowed;\n    transform: none;\n  }\n\n  .dairy-details-bulk,\n  .owner-details-bulk {\n    gap: 0.6rem;\n  }\n\n  .info-item {\n    padding: 0.6rem 1rem;\n    min-height: 40px;\n  }\n\n  .info-icon {\n    font-size: 0.9rem;\n    width: 18px;\n  }\n\n  .info-label {\n    font-size: 0.8rem;\n  }\n\n  .info-value {\n    font-size: 0.9rem;\n    gap: 1rem;\n  }\n\n  .add-money-btn {\n    padding: 0.35rem 0.6rem;\n    font-size: 0.75rem;\n    height: 30px;\n    min-width: 80px;\n  }\n\n  .current-rate-info {\n    padding: 1rem;\n  }\n\n  .rate-info-item {\n    padding: 0.8rem;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .rate-info-item .rate-type-dropdown {\n    width: 100%;\n  }\n\n  .rate-info-item .submit-btn {\n    margin-top: 0.5rem;\n    width: 100%;\n  }\n\n  .collection-controls {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .customer-management,\n  .rate-configuration {\n    width: 100%;\n  }\n\n  .preview-table {\n    min-width: 600px;\n    font-size: 0.9rem;\n  }\n\n  .preview-table th,\n  .preview-table td {\n    padding: 10px 8px;\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .bulk-collection-v1-container {\n    padding: 10px;\n    padding-top: 56px;\n  }\n\n  .bulk-collection-content {\n    padding: 0 5px;\n  }\n\n  .excel-toolbar {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .toolbar-left {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 8px;\n    width: 100%;\n  }\n\n  .toolbar-left .add-row-button,\n  .toolbar-left .submit-preview-button {\n    flex: 1;\n    min-width: 0;\n    width: 48%;\n    /* 50-50 layout with small gap */\n    max-width: 48%;\n    justify-content: center;\n    padding: 10px 8px;\n    font-size: 12px;\n    min-height: 44px;\n  }\n\n  .toolbar-right {\n    justify-content: center;\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .date-time-controls {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 6px;\n    padding: 4px 8px;\n  }\n\n  .date-control,\n  .time-control {\n    min-width: 60px;\n  }\n\n  .toolbar-date-input,\n  .toolbar-time-input {\n    width: 100%;\n    height: 20px;\n    font-size: 10px;\n    /* padding: 2px 4px;\n     */\n    margin: 0;\n    box-sizing: border-box;\n  }\n\n  .add-row-button,\n  .preview-button {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .preview-modal,\n  .new-customer-modal {\n    padding: 1rem;\n    margin-bottom: 20px;\n  }\n\n  .bulk-collection-header .bulk-heading {\n    font-size: 20px;\n  }\n\n  .back-button-bulk {\n    padding: 0.5rem 1rem;\n    font-size: 0.85rem;\n  }\n\n  .dairy-info-container {\n    padding: 0.6rem;\n    min-height: 90px;\n  }\n\n  .dairy-info-content {\n    flex-direction: column !important;\n    gap: 0.6rem;\n  }\n\n  .dairy-details-bulk,\n  .owner-details-bulk {\n    min-width: 100%;\n    flex-direction: column;\n    gap: 0.4rem;\n  }\n\n  .info-item {\n    gap: 0.3rem;\n  }\n\n  .info-label {\n    font-size: 0.65rem;\n  }\n\n  .info-value {\n    gap: 0.8rem;\n  }\n\n  .add-money-btn {\n    padding: 0.3rem 0.5rem;\n    font-size: 0.7rem;\n    font-weight: 600;\n    border-radius: 6px;\n    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n    color: white;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 4px rgba(40, 167, 69, 0.15);\n    flex-shrink: 0;\n    height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    min-width: 70px;\n  }\n\n  .add-money-btn:hover {\n    background: linear-gradient(135deg, #218838 0%, #1ea085 100%);\n    transform: translateY(-1px);\n    box-shadow: 0 3px 6px rgba(40, 167, 69, 0.3);\n  }\n\n  .rate-info-row {\n    flex-direction: row;\n    gap: 0.8rem;\n  }\n}\n\n\n/* Preview modal */\n.preview-header {\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e8eaed;\n  width: 100%;\n}\n\n.preview-info {\n  margin-bottom: 0;\n  color: #5f6368;\n  font-size: 14px;\n  display: block;\n  width: 100%;\n}\n\n.preview-table-container {\n  overflow-x: auto;\n  margin-bottom: 20px;\n  border-radius: 4px;\n  border: 1px solid #e8eaed;\n  margin-top: 0;\n  display: block;\n  width: 100%;\n  /* Remove max-height to prevent scrolling issues on desktop */\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.preview-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n  min-width: 1000px;\n  /* Increased from 900px to accommodate the new CLR column */\n}\n\n.preview-table th,\n.preview-table td {\n  padding: 14px 16px;\n  border-bottom: 1px solid #e8eaed;\n  white-space: nowrap;\n}\n\n/* Column width adjustments for preview table */\n.preview-table th:nth-child(1),\n/* Customer */\n.preview-table td:nth-child(1) {\n  width: 22%;\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.preview-table th:nth-child(2),\n/* Date */\n.preview-table td:nth-child(2) {\n  width: 11%;\n}\n\n.preview-table th:nth-child(3),\n/* Time */\n.preview-table td:nth-child(3) {\n  width: 9%;\n}\n\n.preview-table th:nth-child(4),\n/* Weight */\n.preview-table th:nth-child(5),\n/* Fat % */\n.preview-table th:nth-child(6),\n/* CLR */\n.preview-table th:nth-child(7),\n/* SNF % */\n.preview-table td:nth-child(4),\n.preview-table td:nth-child(5),\n.preview-table td:nth-child(6),\n.preview-table td:nth-child(7) {\n  width: 9%;\n  text-align: right;\n}\n\n.preview-table th:nth-child(8),\n/* Rate */\n.preview-table th:nth-child(9),\n/* Amount */\n.preview-table td:nth-child(8),\n.preview-table td:nth-child(9) {\n  width: 10.5%;\n  text-align: right;\n}\n\n.preview-table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  color: #3c4043;\n  font-size: 14px;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.preview-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.preview-table tfoot tr {\n  font-weight: 600;\n}\n\n.preview-table tfoot td {\n  padding: 16px;\n  border-top: 2px solid #e8eaed;\n}\n\n.total-label {\n  text-align: right;\n  color: #3c4043;\n  font-weight: 500;\n}\n\n.total-value {\n  color: #1a73e8;\n  font-weight: 700;\n}\n\n/* Preview table styles */\n.preview-modal .preview-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1300px;\n  /* Increased to match modal width */\n}\n\n.preview-modal .preview-table th,\n.preview-modal .preview-table td {\n  padding: 8px 4px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n}\n\n.preview-modal .preview-table th:first-child,\n.preview-modal .preview-table td:first-child {\n  width: 18%;\n  max-width: 250px;\n}\n\n.preview-modal .preview-table th:nth-child(2),\n.preview-modal .preview-table td:nth-child(2) {\n  width: 10%;\n}\n\n.preview-modal .preview-table th:nth-child(3),\n.preview-modal .preview-table td:nth-child(3) {\n  width: 8%;\n}\n\n.preview-modal .preview-table th:nth-child(4),\n.preview-modal .preview-table td:nth-child(4),\n.preview-modal .preview-table th:nth-child(5),\n.preview-modal .preview-table td:nth-child(5),\n.preview-modal .preview-table th:nth-child(6),\n.preview-modal .preview-table td:nth-child(6),\n.preview-modal .preview-table th:nth-child(7),\n.preview-modal .preview-table td:nth-child(7),\n.preview-modal .preview-table th:nth-child(8),\n.preview-modal .preview-table td:nth-child(8),\n.preview-modal .preview-table th:nth-child(9),\n.preview-modal .preview-table td:nth-child(9) {\n  width: 8%;\n  text-align: right;\n}\n\n.preview-modal .preview-table th:nth-child(10),\n.preview-modal .preview-table td:nth-child(10),\n.preview-modal .preview-table th:nth-child(11),\n.preview-modal .preview-table td:nth-child(11) {\n  width: 9%;\n  text-align: right;\n}\n\n/* For read-only calculated fields */\ninput.excel-cell-input[readonly] {\n  background-color: #f8f9fa;\n  color: #495057;\n  cursor: default;\n  border: 1px solid #e0e0e0;\n}\n\n/* Highlight calculated SNF fields */\n.calculated-cell input[readonly] {\n  background-color: #e8f4ff;\n  border-color: #b8daff;\n  font-weight: 500;\n}\n\n/* Full-screen loading overlay */\n.submission-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  backdrop-filter: blur(4px);\n}\n\n.submission-spinner {\n  border: 6px solid rgba(255, 255, 255, 0.3);\n  border-top: 6px solid #007bff;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n.submission-message {\n  color: white;\n  font-size: 18px;\n  text-align: center;\n  max-width: 80%;\n  margin-bottom: 15px;\n  font-weight: 500;\n}\n\n.submission-progress {\n  color: #fff;\n  font-size: 14px;\n  margin-top: 10px;\n}\n\n.global-button {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  transition: all 0.2s;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.add-customer-button {\n  background-color: #17a2b8;\n  color: white;\n  width: 100%;\n  justify-content: center;\n}\n\n.add-customer-button:hover {\n  background-color: #138496;\n}\n\n.add-customer-button svg {\n  margin-right: 8px;\n}\n\n/* Delete Confirmation Modal Styles */\n.delete-confirmation-modal {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n  width: 90%;\n  max-width: 420px;\n  margin: auto;\n  overflow: hidden;\n  animation: modalPop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  transform-origin: center;\n}\n\n@keyframes modalPop {\n  0% {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.warning-header {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n  color: #343a40;\n  display: flex;\n  align-items: center;\n  padding: 18px 24px;\n  position: relative;\n}\n\n.warning-header h2 {\n  font-size: 18px;\n  margin: 0;\n  font-weight: 600;\n}\n\n.warning-icon {\n  font-size: 22px;\n  margin-right: 12px;\n  color: #e74c3c;\n}\n\n.delete-confirmation-modal .modal-body {\n  padding: 28px 24px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: white;\n}\n\n.confirmation-icon-container {\n  margin-bottom: 20px;\n  width: 64px;\n  height: 64px;\n  background-color: rgba(231, 76, 60, 0.1);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.warning-text {\n  color: #e74c3c;\n  font-weight: 600;\n  margin-bottom: 16px;\n  padding: 8px 12px;\n  border-radius: 4px;\n  background-color: rgba(231, 76, 60, 0.08);\n  font-size: 15px;\n  border-left: 3px solid #e74c3c;\n  width: 100%;\n  max-width: 90%;\n  text-align: left;\n}\n\n\n.delete-confirmation-modal .modal-body p:last-child {\n  margin-bottom: 0;\n  color: #495057;\n  font-size: 15px;\n}\n\n.delete-confirmation-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 24px 20px;\n  background-color: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n}\n\n.delete-confirmation-modal .cancel-button {\n  background-color: #f8f9fa;\n  color: #495057;\n  border: 1px solid #ced4da;\n  padding: 10px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-right: 12px;\n}\n\n.delete-confirmation-modal .cancel-button:hover {\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.delete-confirmation-modal .delete-button {\n  background-color: #e74c3c;\n  color: white;\n  border: none;\n  padding: 10px 18px;\n  border-radius: 6px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(231, 76, 60, 0.2);\n}\n\n.delete-confirmation-modal .delete-button:hover {\n  background-color: #c0392b;\n  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.3);\n}\n\n.delete-button svg {\n  font-size: 14px;\n  margin-right: 8px;\n}\n\n.cancel-button svg {\n  font-size: 14px;\n  margin-right: 8px;\n}\n\n.delete-confirmation-modal .close-modal-button {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #6c757d;\n  transition: all 0.2s;\n}\n\n.delete-confirmation-modal .close-modal-button:hover {\n  background-color: rgba(108, 117, 125, 0.1);\n  color: #343a40;\n}\n\n/* Add styles for the low balance alert popup */\n.alert-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  animation: fadeIn 0.3s ease;\n}\n\n.alert-popup {\n  background-color: #fff;\n  width: 90%;\n  max-width: 400px;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  animation: slideUp 0.3s ease;\n}\n\n.alert-popup-header {\n  background-color: #f8d7da;\n  color: #721c24;\n  padding: 15px 20px;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #f5c6cb;\n}\n\n.alert-popup-header h3 {\n  margin: 0;\n  font-size: 18px;\n  flex-grow: 1;\n}\n\n.alert-icon {\n  margin-right: 10px;\n  font-size: 20px;\n}\n\n.close-alert-button {\n  background: none;\n  border: none;\n  color: #721c24;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 0;\n  margin-left: 10px;\n}\n\n.alert-popup-body {\n  padding: 20px;\n  color: #333;\n}\n\n.alert-balance {\n  margin-top: 15px;\n  padding: 10px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.low-balance-amount {\n  font-weight: bold;\n  color: #dc3545;\n  font-size: 18px;\n}\n\n.alert-popup-footer {\n  padding: 15px 20px;\n  display: flex;\n  justify-content: flex-end;\n  border-top: 1px solid #e9ecef;\n}\n\n.close-alert-btn {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 20px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.close-alert-btn:hover {\n  background-color: #5a6268;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Date input wrapper styles */\n.date-input-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.date-input-wrapper input[type=\"date\"] {\n  width: 100%;\n  cursor: pointer;\n  padding-right: 30px;\n  /* Make room for the calendar icon */\n  position: relative;\n  z-index: 1;\n  /* Ensure the input is clickable */\n}\n\n/* Style to make it more obvious the entire field is clickable */\n.date-input-wrapper::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 30px;\n  /* Width of the clickable area on the right */\n  background-color: transparent;\n  cursor: pointer;\n  pointer-events: none;\n  /* Allow clicks to pass through to the input */\n}\n\n/* Delete confirmation modal styles */\n.confirmation-modal {\n  background-color: white;\n  border-radius: 8px;\n  width: 400px;\n  max-width: 90%;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n\n.confirmation-modal .modal-header {\n  background-color: #f8f9fa;\n  padding: 15px 20px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.confirmation-modal .modal-header h3 {\n  margin: 0;\n  color: #343a40;\n}\n\n.confirmation-modal .modal-body {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.confirmation-modal .modal-body p {\n  margin-bottom: 10px;\n}\n\n.confirmation-modal .warning-text {\n  color: #dc3545;\n  font-weight: bold;\n  margin-top: 10px;\n  background-color: rgba(220, 53, 69, 0.1);\n  padding: 8px 12px;\n  border-radius: 4px;\n  border-left: 3px solid #dc3545;\n}\n\n.confirmation-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 15px 20px;\n  background-color: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n  gap: 10px;\n}\n\n.confirmation-modal .cancel-button {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.confirmation-modal .delete-button {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.confirmation-modal .cancel-button:hover {\n  background-color: #5a6268;\n}\n\n.confirmation-modal .delete-button:hover {\n  background-color: #c82333;\n}\n\n/* Confirmation Modal Styles */\n.confirmation-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  padding: 16px;\n}\n\n.confirmation-modal-container {\n  background: white;\n  width: 100%;\n  max-width: 350px;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.confirmation-modal-header {\n  padding: 16px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.confirmation-modal-header h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin: 0;\n}\n\n.confirmation-modal-close-btn {\n  background: none;\n  border: none;\n  font-size: 18px;\n  color: #666;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n}\n\n.confirmation-modal-close-btn:hover {\n  background: #f5f5f5;\n}\n\n.confirmation-modal-body {\n  padding: 16px 20px;\n  text-align: center;\n}\n\n.confirmation-modal-message {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 12px;\n  font-weight: 500;\n}\n\n.confirmation-modal-value-display {\n  background: #0047AB;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  display: inline-block;\n  margin-bottom: 12px;\n}\n\n.confirmation-modal-description {\n  font-size: 12px;\n  color: #666;\n  margin: 0;\n}\n\n.confirmation-modal-footer {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  padding: 16px 20px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.confirmation-modal-cancel-btn {\n  padding: 10px 16px;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  font-weight: 500;\n  color: #666;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.confirmation-modal-cancel-btn:hover {\n  background: #f8f9fa;\n}\n\n.confirmation-modal-confirm-btn {\n  padding: 10px 16px;\n  background-color: #0047AB;\n  border: none;\n  border-radius: 8px;\n  color: white;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.confirmation-modal-confirm-btn:hover {\n  background-color: #003680;\n}\n\n/* Total row styles */\n.excel-table tfoot {\n  background-color: #f0f7ff;\n  border-top: 2px solid #d0e3ff;\n}\n\n.excel-table .total-row {\n  font-weight: bold;\n  background-color: #f0f7ff;\n}\n\n.excel-table .total-label {\n  text-align: right;\n  padding-right: 15px;\n  font-weight: bold;\n  color: #333;\n}\n\n.excel-table .total-value {\n  text-align: left;\n  font-weight: bold;\n  font-size: 1.1em;\n  color: #0056b3;\n}\n\n/* Add styles for the weight and amount totals */\n.excel-table .total-value.weight-total {\n  color: #116644;\n  font-size: 1.15em;\n  background-color: #e3f5ee;\n  border-radius: 4px;\n  padding: 5px 10px;\n}\n\n.excel-table .total-value.amount-total {\n  color: #662211;\n  font-size: 1.15em;\n  background-color: #f9e8e3;\n  border-radius: 4px;\n  padding: 5px 10px;\n}\n\n@media(max-width: 768px) {\n  .bulk-collection-header {\n    flex-direction: row;\n    gap: 0.5rem;\n    padding: 0.75rem;\n    align-items: center;\n    min-height: auto;\n    justify-content: space-between;\n    position: relative;\n    z-index: 1001;\n  }\n\n  .bulk-collection-header .bulk-heading {\n    font-size: 20px !important;\n    /* Increased from 16px */\n    text-align: center;\n    order: 2;\n    margin: 0;\n    line-height: 1.2;\n    padding: 0.25rem 0;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .back-button-bulk {\n    order: 1;\n    align-self: center;\n    padding: 0.4rem 0.8rem !important;\n    font-size: 12px !important;\n    white-space: nowrap;\n    margin: 0;\n    flex-shrink: 0;\n  }\n\n  .bulk-collection-header .header-actions {\n    order: 3;\n    align-self: center;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    flex-shrink: 0;\n  }\n\n  /* Mobile header actions styling */\n  .bulk-collection-header .header-actions .lang-btn {\n    padding: 0.3rem 0.6rem;\n    font-size: 11px;\n    white-space: nowrap;\n  }\n\n  .bulk-collection-header .profile-button {\n    padding: 0.3rem 0.6rem;\n    font-size: 11px;\n  }\n\n  .bulk-collection-header .profile-icon {\n    font-size: 14px;\n  }\n}\n\n/* Tablet responsive styles - maintain desktop layout */\n@media (min-width: 769px) and (max-width: 1024px) {\n\n  /* Keep desktop layout for tablets */\n  .bulk-collection-header {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    height: 70px;\n  }\n\n  .bulk-collection-header .bulk-heading {\n    font-size: 20px;\n    text-align: center;\n    flex: 1;\n    order: 2;\n  }\n\n  .back-button-bulk {\n    order: 1;\n    padding: 8px 12px;\n    font-size: 14px;\n  }\n\n  .bulk-collection-header .header-actions {\n    order: 3;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  /* Keep cards in desktop layout for tablets */\n  .dairy-info-wrapper {\n    flex-direction: row;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .rate-settings-modern-card,\n  .wallet-simple-card {\n    flex: 0 1 280px;\n    min-height: 120px;\n    /* padding: 0.875rem; */\n  }\n\n  .rate-settings-info-card,\n  .wallet-info-card {\n    min-height: 120px;\n    padding: 1rem;\n  }\n\n  /* Keep desktop font sizes for tablets */\n  .rate-settings-title,\n  .wallet-title {\n    font-size: 0.95rem;\n  }\n\n  .rate-settings-info-title {\n    font-size: 1rem;\n  }\n\n  .rate-card-title h4,\n  .wallet-card-title h4 {\n    font-size: 1rem;\n  }\n\n  /* Keep desktop icon sizes for tablets */\n  .rate-settings-icon-bg,\n  .wallet-icon-bg {\n    width: 32px;\n    height: 32px;\n    font-size: 14px;\n  }\n\n  .rate-card-icon,\n  .wallet-card-icon {\n    width: 32px;\n    height: 32px;\n    font-size: 14px;\n  }\n\n  /* Keep desktop button sizes for tablets */\n  .rate-settings-action-button,\n  .wallet-action-button {\n    padding: 8px 12px;\n    font-size: 0.75rem;\n    min-height: 44px;\n    margin-top: 0.75rem;\n  }\n\n  /* Keep desktop spacing for tablets */\n  .rate-card-content,\n  .wallet-card-content {\n    padding: 0.5rem 0;\n  }\n\n  .dairy-owner-info-card,\n  .current-rate-info-card-bulk {\n    margin-bottom: 12px;\n    padding: 12px;\n    min-height: 80px;\n  }\n}\n\n/* Additional mobile responsive styles */\n@media(max-width: 768px) {\n  .dairy-info-wrapper {\n    flex-direction: column;\n    gap: 0.5rem;\n    /* Reduced gap for more compact layout */\n  }\n\n  /* Make cards smaller and more compact for mobile */\n  .rate-settings-modern-card {\n    min-height: 60px;\n    /* Further reduced from 80px */\n    padding: 0.4rem;\n    /* Reduced from 0.5rem */\n    flex: 1;\n    width: 100%;\n  }\n\n  .rate-settings-info-card {\n    min-height: 60px;\n    /* Further reduced from 80px */\n    padding: 0.4rem;\n    /* Reduced from 0.6rem */\n  }\n\n  .rate-settings-info-header {\n    margin-bottom: 0.3rem;\n    /* Reduced from 0.5rem */\n  }\n\n  .rate-settings-icon-bg {\n    width: 20px;\n    /* Further reduced from 24px */\n    height: 20px;\n    /* Further reduced from 24px */\n    font-size: 10px;\n    /* Reduced from 12px */\n  }\n\n  .rate-settings-info-title {\n    font-size: 0.8rem;\n    /* Reduced from 0.9rem */\n  }\n\n  .rate-settings-checklist li {\n    font-size: 0.7rem;\n    /* Reduced from 0.75rem */\n    margin-bottom: 0.2rem;\n    /* Reduced from 0.3rem */\n  }\n\n  .rate-settings-action-btn {\n    padding: 6px 8px;\n    /* Reduced from 8px 12px */\n    font-size: 0.7rem;\n    min-height: 30px;\n    /* Reduced from 36px */\n  }\n\n  /* Make wallet card smaller */\n  .wallet-simple-card {\n    min-height: 50px;\n    padding: 8px 12px;\n    flex: 1;\n    width: 100%;\n  }\n\n  .wallet-top-right {\n    /* position: fixed; */\n    /* z-index: 100; */\n    margin: auto;\n    top: 60px;\n    right: 8px;\n    padding: 6px 10px;\n  }\n\n  .wallet-top-right .wallet-info {\n    gap: 4px;\n  }\n\n  .wallet-top-right .icon-wallet {\n    font-size: 12px;\n  }\n\n\n  .wallet-top-right .wallet-info span:last-child {\n    font-size: 0.7rem;\n  }\n\n  .wallet-info-card {\n    min-height: 60px;\n    /* Further reduced from 80px */\n    padding: 0.4rem;\n    /* Reduced from 0.6rem */\n  }\n\n  .wallet-info-header {\n    margin-bottom: 0.3rem;\n    /* Reduced from 0.5rem */\n  }\n\n  .wallet-icon-bg {\n    width: 20px;\n    /* Further reduced from 24px */\n    height: 20px;\n    /* Further reduced from 24px */\n    font-size: 10px;\n    /* Reduced from 12px */\n  }\n\n  .wallet-title {\n    font-size: 0.8rem;\n    /* Reduced from 0.9rem */\n  }\n\n  .wallet-description {\n    font-size: 0.7rem;\n    /* Reduced from 0.75rem */\n  }\n\n  .wallet-balance-amount {\n    font-size: 0.9rem;\n    /* Reduced from 1rem */\n  }\n\n  .wallet-balance-label {\n    font-size: 0.65rem;\n    /* Reduced from 0.7rem */\n  }\n\n  /* Make dairy info cards smaller */\n  .dairy-owner-info-card,\n  .current-rate-info-card-bulk {\n    margin-bottom: 6px;\n    /* Reduced from 8px */\n    padding: 0.4rem;\n    /* Reduced from 0.6rem */\n    min-height: 50px;\n    /* Further reduced from 60px */\n  }\n\n  /* Reduce card title sizes */\n  .rate-card-title h4,\n  .wallet-card-title h4 {\n    font-size: 0.8rem;\n    /* Reduced from 0.9rem */\n  }\n\n  .rate-card-title p,\n  .wallet-card-title p {\n    font-size: 0.65rem;\n    /* Reduced from 0.7rem */\n  }\n\n  /* Make card icons smaller */\n  .rate-card-icon,\n  .wallet-card-icon {\n    width: 28px;\n    /* Further reduced from 32px */\n    height: 28px;\n    /* Further reduced from 32px */\n    font-size: 12px;\n    /* Reduced from 14px */\n  }\n\n  /* Reduce card content padding */\n  .rate-card-content,\n  .wallet-card-content {\n    padding: 0.3rem 0;\n    /* Reduced from 0.5rem 0 */\n  }\n\n  /* Make action buttons smaller */\n  .rate-settings-action-button,\n  .wallet-action-button {\n    padding: 4px 8px;\n    /* Reduced from 6px 10px */\n    font-size: 0.65rem;\n    /* Reduced from 0.7rem */\n    min-height: 28px;\n    /* Reduced from 32px */\n    margin-top: 0.3rem;\n    /* Reduced from 0.5rem */\n  }\n\n  /* Improved mobile spacing and touch targets */\n  .bulk-collection-v1-container {\n    padding: 8px !important;\n    padding-top: 56px !important;\n  }\n\n  .bulk-collection-content {\n    padding: 0 2px;\n  }\n\n  /* Better mobile table responsiveness */\n  .excel-table {\n    font-size: 12px;\n  }\n\n  .excel-table th,\n  .excel-table td {\n    padding: 6px 4px;\n    height: 40px;\n  }\n\n  .excel-cell-input,\n  .excel-cell-select {\n    font-size: 14px !important;\n    padding: 8px 6px;\n  }\n\n  /* Improved mobile button sizing */\n  .add-row-button,\n  .preview-button {\n    padding: 10px 14px;\n    font-size: 12px;\n    min-height: 44px;\n    /* Better touch target */\n  }\n\n  /* Mobile modal improvements */\n  .modal-content {\n    width: 95%;\n    margin: 10px auto;\n    max-height: 90vh;\n  }\n\n  .modal-header {\n    padding: 12px 16px;\n  }\n\n  .modal-body {\n    padding: 16px;\n  }\n\n  .modal-footer {\n    padding: 12px 16px;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .modal-footer button {\n    width: 100%;\n    min-height: 44px;\n  }\n\n  /* Better mobile form inputs */\n  .global-input {\n    padding: 12px;\n    font-size: 16px;\n    /* Prevents zoom on iOS */\n    min-height: 44px;\n  }\n\n  .global-button {\n    padding: 12px 16px;\n    font-size: 14px;\n    min-height: 44px;\n  }\n\n  /* Mobile dropdown improvements */\n  .excel-dropdown {\n    max-height: 150px;\n  }\n\n  .dropdown-item {\n    padding: 12px;\n    font-size: 14px;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n  }\n\n  /* Better mobile card spacing */\n  .dairy-owner-info-card,\n  .current-rate-info-card-bulk {\n    margin-bottom: 12px;\n    padding: 12px;\n  }\n\n  /* Mobile-specific utility classes */\n  .mobile-hidden {\n    display: none;\n  }\n\n  .mobile-full-width {\n    width: 100%;\n  }\n\n  .mobile-text-center {\n    text-align: center;\n  }\n\n  .mobile-stack {\n    flex-direction: column;\n  }\n\n  /* Improved mobile navigation */\n  .back-button-bulk {\n    min-width: 80px;\n    justify-content: center;\n  }\n\n  /* Better mobile profile dropdown */\n  .profile-dropdown {\n    z-index: 1003;\n  }\n\n  .profile-menu {\n    right: 0;\n    min-width: 200px;\n    max-width: 250px;\n  }\n\n  /* Mobile-specific rate settings modal */\n  .change-rates-modal-bulkcollection {\n    width: 98%;\n    max-width: none;\n    margin: 5px auto;\n    max-height: 95vh;\n  }\n\n  .change-rates-section-bulkcollection {\n    margin-bottom: 8px;\n    padding: 8px;\n  }\n\n  .option-btn {\n    padding: 12px 8px;\n    font-size: 12px;\n    min-height: 44px;\n  }\n}\n\n.rate-settings-heading {\n  font-size: 1rem;\n  margin-bottom: 0.75rem;\n}\n\n.rate-settings-primary-btn {\n  padding: 10px 20px !important;\n  font-size: 0.85rem !important;\n  min-width: 120px !important;\n}\n\n.dairy-info-container {\n  width: 100%;\n  padding: 0.75rem;\n  overflow: visible;\n}\n\n.dairy-info-content {\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.info-item {\n  padding: 0.4rem 0.6rem;\n  min-height: 32px;\n  overflow: visible;\n  white-space: normal;\n}\n\n.info-label {\n  font-size: 0.7rem;\n  margin-right: 0.25rem;\n}\n\n.info-value {\n  font-size: 0.75rem;\n  gap: 0.4rem;\n  overflow: visible;\n}\n\n.add-money-btn {\n  padding: 0.2rem 0.4rem;\n  font-size: 0.65rem;\n  height: 24px;\n  min-width: 60px;\n}\n\n.rate-type-input-group {\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.rate-info-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.save-rate-button-bulk {\n  width: 80%;\n  padding: 5px 7px;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n}\n\n\n\n@media(width: 768px) {\n  .bulk-collection-header {\n    padding: 1rem 1.5rem;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    background: linear-gradient(135deg, #0056b3 0%, #003d82 100%);\n    border-radius: 0 0 16px 16px;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);\n  }\n\n  .bulk-collection-header .bulk-heading {\n    font-size: 18px !important;\n    text-align: center;\n    order: unset;\n    margin: 0;\n    line-height: 1.3;\n    padding: 0;\n    font-weight: 600;\n    letter-spacing: -0.3px;\n    flex: 1;\n  }\n\n  .back-button-bulk {\n    order: unset;\n    align-self: auto;\n    padding: 0.5rem 1rem !important;\n    font-size: 13px !important;\n    white-space: nowrap;\n    margin: 0;\n    border-radius: 8px;\n    background: rgba(255, 255, 255, 0.15);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n  }\n\n  .bulk-collection-header .header-actions {\n    order: unset;\n    align-self: auto;\n    display: flex;\n    align-items: center;\n    margin: 0;\n  }\n\n  .dairy-info-wrapper {\n    flex-direction: row;\n    gap: 1.5rem;\n    padding: 1.5rem;\n    align-items: flex-start;\n    width: 100%;\n  }\n\n  .dairy-info-container {\n    flex: 1;\n    min-width: 0;\n    padding: 1.5rem;\n    overflow: visible;\n    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n    border-radius: 16px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n    border: 1px solid #e5e7eb;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .dairy-info-content {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    flex: 1;\n  }\n\n  .dairy-details-bulk {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    width: 100%;\n    margin-bottom: 1rem;\n  }\n\n  .owner-details-bulk {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    width: 100%;\n  }\n\n  .info-item {\n    padding: 0.75rem 1rem;\n    min-height: 44px;\n    overflow: hidden;\n    white-space: nowrap;\n    background: rgba(255, 255, 255, 0.95);\n    border-radius: 12px;\n    border: 1px solid #f0f0f0;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex: 1;\n    min-width: 0;\n    transition: all 0.2s ease;\n  }\n\n  .info-item:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    border-color: #e0e0e0;\n  }\n\n  .info-label {\n    font-size: 0.85rem;\n    margin-right: 0.6rem;\n    color: #666;\n    font-weight: 600;\n    flex-shrink: 0;\n  }\n\n  .info-value {\n    font-size: 0.95rem;\n    gap: 0.6rem;\n    overflow: hidden;\n    font-weight: 700;\n    color: #333;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .add-money-btn {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.75rem;\n    height: 32px;\n    min-width: 80px;\n    border-radius: 8px;\n    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n    box-shadow: 0 3px 8px rgba(40, 167, 69, 0.2);\n    flex-shrink: 0;\n    transition: all 0.2s ease;\n  }\n\n  .add-money-btn:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n  }\n\n  .current-rate-info {\n    flex: 1;\n    min-width: 0;\n    padding: 1.25rem;\n    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n    border-radius: 16px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n    border: 1px solid #e5e7eb;\n  }\n\n  .rate-info-item {\n    padding: 1rem;\n    background: rgba(255, 255, 255, 0.9);\n    border-radius: 10px;\n    border: 1px solid #f0f0f0;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .rate-type-input-group {\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  .rate-info-row {\n    flex-direction: row;\n    align-items: stretch;\n    gap: 0.75rem;\n  }\n\n  .collection-controls {\n    padding: 1rem 1.5rem;\n    gap: 1rem;\n  }\n\n  .preview-table {\n    font-size: 0.9rem;\n    min-width: 700px;\n  }\n\n  .preview-table th,\n  .preview-table td {\n    padding: 12px 10px;\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .bulk-collection-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n}\n\n/* Change Rates Modal Styles */\n.change-rates-modal {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  animation: modalSlideIn 0.3s ease-out;\n  font-size: 0.8rem;\n}\n\n.change-rates-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #007bff;\n  border-radius: 12px 12px 0 0;\n}\n\n.change-rates-header h3 {\n  margin: 0;\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.change-rates-body {\n  padding: 20px;\n  font-size: 0.8rem;\n}\n\n/* Premium Change Rates Section - Compact */\n.change-rates-section {\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  border: 1px solid rgba(59, 130, 246, 0.15);\n  border-radius: 10px;\n  background: linear-gradient(135deg, #f8faff 0%, #ffffff 100%);\n  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05);\n  position: relative;\n  overflow: hidden;\n}\n\n.change-rates-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #8b5cf6 0%, #ec4899 100%);\n}\n\n.change-rates-section h4 {\n  margin: 0 0 0.75rem 0;\n  color: #1e293b;\n  font-size: 1rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.section-description {\n  margin: 0 0 1rem 0;\n  color: #64748b;\n  font-size: 0.85rem;\n  line-height: 1.4;\n  font-weight: 500;\n}\n\n.option-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.option-btn {\n  flex: 1;\n  min-width: 80px;\n  padding: 0.5rem 0.75rem;\n  border: 2px solid rgba(148, 163, 184, 0.3);\n  border-radius: 6px;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #475569;\n  position: relative;\n  overflow: hidden;\n}\n\n.option-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.1), transparent);\n  transition: left 0.5s ease;\n}\n\n.option-btn:hover {\n  border-color: #3b82f6;\n  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n  color: #1e40af;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);\n}\n\n.option-btn:hover::before {\n  left: 100%;\n}\n\n.option-btn.active {\n  border-color: #3b82f6 !important;\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;\n  color: white !important;\n  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);\n  transform: translateY(-1px);\n}\n\n.edit-rate-btn {\n  background: none;\n  border: none;\n  color: #007bff;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n  font-size: 0.75rem;\n}\n\n.edit-rate-btn:hover {\n  background-color: #e3f2fd;\n}\n\n.option-buttons {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.option-btn {\n  padding: 10px 16px;\n  border: 2px solid #007bff;\n  background: white;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #007bff;\n  flex: 1;\n  min-width: 150px;\n}\n\n.option-btn:hover {\n  border-color: #0056b3;\n  background: #e3f2fd;\n  color: #0056b3;\n}\n\n.option-btn.active {\n  border-color: #007bff;\n  background: #007bff;\n  color: white;\n}\n\n.change-rates-footer {\n  padding: 16px 20px;\n  border-top: 1px solid #e0e0e0;\n  background: #f8f9fa;\n  border-radius: 0 0 12px 12px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.change-rates-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n}\n\n.change-rates-button:hover {\n  background: #0056b3;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Make content smaller overall */\n.bulk-collection-v1-container {\n  font-size: 0.85rem !important;\n}\n\n.bulk-collection-v1-container .global-heading {\n  font-size: 1.5rem !important;\n}\n\n.bulk-collection-v1-container .section-title {\n  font-size: 1.1rem !important;\n}\n\n.bulk-collection-v1-container .global-input {\n  padding: 8px 12px !important;\n  font-size: 0.85rem !important;\n}\n\n.bulk-collection-v1-container .global-button {\n  padding: 8px 12px !important;\n  font-size: 0.85rem !important;\n}\n\n/* Bulk Data Table Styling - Same as ProRataCollection */\n.bulk-data-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1200px;\n  margin-bottom: 50px;\n  table-layout: fixed;\n  /* Ensure minimum width to fit all columns */\n}\n\n.bulk-data-table th,\n.bulk-data-table td {\n  border: 1px solid #dee2e6;\n  padding: 0;\n  position: relative;\n  height: 32px;\n  overflow: visible;\n  font-size: 12px;\n}\n\n.bulk-data-table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  text-align: center;\n  vertical-align: middle;\n  position: relative;\n  user-select: none;\n}\n\n.bulk-data-table th:hover {\n  background-color: #e9ecef;\n}\n\n.bulk-data-table th:nth-child(2):hover {\n  background-color: #e3f2fd;\n  cursor: pointer;\n}\n\n.bulk-data-table th:nth-child(2):active {\n  background-color: #bbdefb;\n}\n\n.bulk-data-table th:nth-child(3):hover {\n  background-color: #fff3e0;\n  cursor: pointer;\n}\n\n.bulk-data-table th:nth-child(3):active {\n  background-color: #ffe0b2;\n}\n\n.bulk-data-table th:nth-child(10):hover {\n  background-color: #e8f5e8;\n  cursor: pointer;\n}\n\n.bulk-data-table th:nth-child(10):active {\n  background-color: #c8e6c9;\n}\n\n.bulk-data-table th:nth-child(11):hover {\n  background-color: #fff3e0;\n  cursor: pointer;\n}\n\n.bulk-data-table th:nth-child(11):active {\n  background-color: #ffe0b2;\n}\n\n.bulk-data-table th {\n  padding: 6px 3px;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  border-bottom: 2px solid #dee2e6;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 16px !important;\n  /* Updated from 18px */\n  font-weight: 600;\n}\n\n.bulk-data-table tbody {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.bulk-data-table .bulk-data-row:hover {\n  background-color: #f5f9fc;\n}\n\n.bulk-data-table .bulk-data-row:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.bulk-data-table .bulk-data-row:nth-child(even):hover {\n  background-color: #f0f5fa;\n}\n\n.bulk-data-table td.bulk-collection-has-error {\n  background-color: rgba(255, 0, 0, 0.05);\n}\n\n.bulk-text-input,\n.bulk-select-input {\n  width: 100%;\n  height: 100%;\n  padding: 0 4px;\n  border: none;\n  background: transparent;\n  font-size: 16px !important;\n}\n\n.bulk-collection-excel-cell-input,\n.bulk-collection-excel-cell-select,\n.bulk-collection-text-input {\n  width: 100%;\n  height: 100%;\n  padding: 0 4px;\n  border: none;\n  background: transparent;\n  font-size: 16px !important;\n}\n\n.bulk-text-input:disabled,\n.bulk-select-input:disabled,\n.bulk-collection-excel-cell-input:disabled,\n.bulk-collection-excel-cell-select:disabled,\n.bulk-collection-text-input:disabled {\n  background-color: #f5f5f5;\n  color: #9e9e9e;\n  cursor: not-allowed;\n  opacity: 0.7;\n  border-left: 2px solid #e0e0e0;\n}\n\n.bulk-text-input:focus,\n.bulk-select-input:focus,\n.bulk-collection-excel-cell-input:focus,\n.bulk-collection-excel-cell-select:focus,\n.bulk-collection-text-input:focus {\n  outline: none;\n  box-shadow: inset 0 0 0 2px #4d90fe;\n}\n\n.bulk-select-input,\n.bulk-collection-excel-cell-select {\n  appearance: none;\n  -webkit-appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 6px center;\n  background-size: 12px;\n  padding-right: 24px;\n}\n\n.bulk-collection-calculated-cell {\n  position: relative;\n}\n\n.bulk-collection-calc-indicator {\n  position: absolute;\n  top: 0;\n  right: 2px;\n  color: #0066cc;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.bulk-collection-calc-indicator.auto {\n  color: #28a745;\n  background-color: rgba(40, 167, 69, 0.1);\n  padding: 0 4px;\n  border-radius: 2px;\n  right: 4px;\n  top: 2px;\n  font-size: 10px;\n}\n\n.bulk-collection-calculated-cell .bulk-text-input:disabled,\n.bulk-collection-calculated-cell .bulk-collection-excel-cell-input:disabled,\n.bulk-collection-calculated-cell .bulk-collection-text-input:disabled {\n  background-color: #f0f8ff;\n  /* Light blue background */\n  color: #006699;\n  border-left: 2px solid #4dabf7;\n  opacity: 0.8;\n}\n\n.bulk-text-input.bulk-collection-auto-calculated,\n.bulk-collection-excel-cell-input.bulk-collection-auto-calculated,\n.bulk-collection-text-input.bulk-collection-auto-calculated {\n  background-color: #f0f8ff;\n  font-style: italic;\n}\n\n.bulk-collection-disabled-field {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.bulk-text-input.bulk-collection-disabled-input,\n.bulk-collection-excel-cell-input.bulk-collection-disabled-input,\n.bulk-collection-text-input.bulk-collection-disabled-input {\n  background-color: #f6f6f6;\n  color: #b0b0b0;\n  text-decoration: line-through;\n  opacity: 0.6;\n}\n\n.bulk-collection-disabled-indicator {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 10px;\n  color: #999;\n  background-color: rgba(0, 0, 0, 0.05);\n  padding: 1px 4px;\n  border-radius: 2px;\n  pointer-events: none;\n  /* Prevent it from blocking interactions */\n  white-space: nowrap;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  opacity: 0.8;\n}\n\n.bulk-collection-cell-error {\n  position: absolute;\n  bottom: -18px;\n  left: 0;\n  width: 100%;\n  background-color: #f8d7da;\n  color: #721c24;\n  font-size: 12px;\n  padding: 2px 4px;\n  text-align: center;\n  z-index: 20;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.bulk-collection-cell-warning {\n  position: absolute;\n  bottom: -18px;\n  left: 0;\n  width: 100%;\n  background-color: #fff3cd;\n  color: #856404;\n  font-size: 12px;\n  padding: 2px 4px;\n  text-align: center;\n  z-index: 20;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.bulk-empty-message {\n  text-align: center;\n  padding: 20px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.bulk-delete-btn,\n.bulk-collection-delete-btn {\n  background: none;\n  border: none;\n  color: #dc3545;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.bulk-delete-btn:hover,\n.bulk-collection-delete-btn:hover {\n  background-color: rgba(220, 53, 69, 0.1);\n}\n\n.bulk-customer-search-cell {\n  position: relative;\n  width: 100%;\n}\n\n.bulk-collection-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #ccc;\n  border-top: none;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 1000;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.bulk-collection-dropdown-item {\n  padding: 8px 12px;\n  border-bottom: 1px solid #eee;\n  font-size: 14px;\n  transition: background-color 0.2s;\n  cursor: pointer;\n}\n\n.bulk-collection-dropdown-item:hover,\n.bulk-collection-dropdown-item.bulk-collection-selected {\n  background-color: #a7a7a7;\n  color: #212529;\n}\n\n.bulk-collection-dropdown-item-add-new {\n  padding: 8px 12px;\n  border-bottom: 1px solid #eee;\n  font-size: 14px;\n  transition: background-color 0.2s;\n  cursor: pointer;\n  background-color: #007bff;\n  color: white;\n  font-weight: bold;\n}\n\n.bulk-collection-dropdown-item-add-new:hover {\n  background-color: #0056b3;\n}\n\n.bulk-collection-no-results {\n  padding: 8px 12px;\n  color: #888;\n  font-style: italic;\n  text-align: center;\n}\n\n.bulk-text-input:focus,\n.bulk-collection-excel-cell-input:focus,\n.bulk-collection-text-input:focus {\n  outline: 2px solid #1a73e8;\n  border-color: #1a73e8;\n}\n\n.bulk-data-table td:first-child .bulk-text-input,\n.bulk-data-table td:first-child .bulk-collection-excel-cell-input,\n.bulk-data-table td:first-child .bulk-collection-text-input {\n  width: 100%;\n  min-width: 150px;\n}\n\n.bulk-serial-cell {\n  text-align: center;\n  font-weight: 500;\n  background-color: #f8f9fa;\n}\n\n.bulk-date-input-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.bulk-date-input-wrapper input[type=\"date\"] {\n  width: 100%;\n  cursor: pointer;\n}\n\n.bulk-collection-editable-field .bulk-text-input,\n.bulk-collection-editable-field .bulk-collection-excel-cell-input,\n.bulk-collection-editable-field .bulk-collection-text-input {\n  font-weight: 500;\n}\n\n.bulk-collection-editable-field .bulk-text-input:focus,\n.bulk-collection-editable-field .bulk-collection-excel-cell-input:focus,\n.bulk-collection-editable-field .bulk-collection-text-input:focus {\n  outline: none;\n  box-shadow: inset 0 0 0 2px #4d90fe;\n}\n\n.bulk-data-table th:nth-child(1),\n.bulk-data-table td:nth-child(1) {\n  width: 50px;\n  min-width: 50px;\n  text-align: center;\n}\n\n.bulk-data-table th:nth-child(2),\n.bulk-data-table td:nth-child(2) {\n  width: 120px;\n  min-width: 120px;\n}\n\n.bulk-data-table th:nth-child(3),\n.bulk-data-table td:nth-child(3) {\n  width: 90px;\n  min-width: 90px;\n}\n\n.bulk-data-table th:nth-child(4),\n.bulk-data-table td:nth-child(4) {\n  width: 180px;\n  min-width: 180px;\n}\n\n.bulk-data-table th:nth-child(5),\n.bulk-data-table th:nth-child(6),\n.bulk-data-table th:nth-child(7),\n.bulk-data-table th:nth-child(8) {\n  width: 80px;\n  min-width: 80px;\n  max-width: 80px;\n}\n\n.bulk-data-table td:nth-child(5),\n.bulk-data-table td:nth-child(6),\n.bulk-data-table td:nth-child(7),\n.bulk-data-table td:nth-child(8) {\n  width: 80px;\n  min-width: 80px;\n  max-width: 80px;\n}\n\n.bulk-data-table th:nth-child(9),\n.bulk-data-table td:nth-child(9) {\n  width: 85px;\n  min-width: 85px;\n}\n\n.bulk-data-table th:nth-child(10),\n.bulk-data-table th:nth-child(11),\n.bulk-data-table td:nth-child(10),\n.bulk-data-table td:nth-child(11) {\n  width: 100px;\n  min-width: 100px;\n}\n\n.bulk-data-table th:nth-child(12),\n.bulk-data-table td:nth-child(12) {\n  width: 60px;\n  min-width: 60px;\n}\n\n@media (max-width: 1024px) {\n\n  .bulk-text-input,\n  .bulk-select-input,\n  .bulk-collection-excel-cell-input,\n  .bulk-collection-excel-cell-select,\n  .bulk-collection-text-input {\n    font-size: 14px !important;\n  }\n\n}\n\n.global-time-header-select,\n.global-base-snf-header-select,\n.global-animal-type-header-select {\n  border: none !important;\n  outline: none !important;\n  background: transparent !important;\n  font-weight: 600;\n  font-size: 16px !important;\n  /* Updated from 18px */\n  color: inherit;\n  text-align: center;\n  width: 100%;\n}\n\ninput.bulk-text-input[readonly],\ninput.bulk-collection-excel-cell-input[readonly],\ninput.bulk-collection-text-input[readonly] {\n  background-color: #f8f9fa;\n  color: #495057;\n  cursor: default;\n}\n\n.bulk-collection-total-row {\n  background-color: #f0f7ff;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.bulk-collection-total-label {\n  text-align: right;\n  font-weight: 700;\n  color: #495057;\n  font-size: 16px !important;\n}\n\n.bulk-collection-total-value {\n  text-align: center;\n  font-weight: 700;\n  color: #007bff;\n  font-size: 1.2em;\n}\n\n.bulk-collection-weight-total {\n  color: #28a745;\n  font-size: 16px !important;\n}\n\n.bulk-excel-container {\n  width: 100%;\n  overflow-x: auto;\n  padding: 0;\n  margin: 0;\n}\n\n@media (max-width: 1200px) {\n  .bulk-data-table {\n    font-size: 12px;\n    /* Smaller font on smaller screens */\n    width: 100%;\n    min-width: 1200px;\n  }\n\n  .bulk-data-table th,\n  .bulk-data-table td {\n    padding: 4px 6px;\n    height: 32px;\n  }\n}\n\n.bulk-collection-v1-container .add-row-button,\n.bulk-collection-v1-container .preview-button {\n  padding: 8px 12px !important;\n  font-size: 0.85rem !important;\n}\n\n.bulk-collection-v1-container .modal-btn {\n  padding: 8px 16px !important;\n  font-size: 0.85rem !important;\n}\n\n/* Responsive adjustments for smaller content */\n@media(max-width: 768px) {\n  .bulk-collection-v1-container {\n    font-size: 0.8rem !important;\n    padding: 10px !important;\n    padding-top: 56px !important;\n  }\n\n  .bulk-collection-v1-container .global-input {\n    padding: 6px 10px !important;\n    font-size: 0.8rem !important;\n  }\n\n  .bulk-collection-v1-container .global-button {\n    padding: 6px 10px !important;\n    font-size: 0.8rem !important;\n  }\n\n  /* .bulk-collection-v1-container .excel-cell-input {\n    font-size: 0.75rem !important;\n    padding: 4px 6px !important;\n  } */\n\n  .change-rates-modal {\n    width: 95%;\n    max-width: 400px;\n    font-size: 0.7rem;\n  }\n\n  .change-rates-header {\n    padding: 12px 16px;\n  }\n\n  .change-rates-header h3 {\n    font-size: 0.9rem;\n  }\n\n  .change-rates-body {\n    padding: 16px;\n    font-size: 0.7rem;\n  }\n\n  .change-rates-section {\n    margin-bottom: 16px;\n  }\n\n  .change-rates-section h4 {\n    font-size: 0.75rem;\n  }\n\n  .section-description {\n    font-size: 0.7rem;\n  }\n\n  .current-milk-rate-display {\n    padding: 10px;\n  }\n\n  .rate-label {\n    font-size: 0.7rem;\n  }\n\n  .rate-value {\n    font-size: 0.8rem;\n  }\n\n  .edit-rate-btn {\n    font-size: 0.7rem;\n    padding: 3px;\n  }\n\n  .option-btn {\n    padding: 8px 12px;\n    font-size: 0.7rem;\n    min-width: 80px;\n  }\n\n  .change-rates-footer {\n    padding: 12px 16px;\n  }\n\n  .change-rates-button {\n    padding: 6px 10px;\n    font-size: 0.7rem;\n    gap: 4px;\n  }\n\n  /* Mobile responsive header with language switcher */\n  .bulk-collection-header {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .bulk-collection-header .bulk-heading {\n    text-align: center;\n    order: 2;\n    font-size: 1.2rem;\n  }\n\n  .back-button-bulk {\n    order: 1;\n    align-self: flex-start;\n  }\n\n  .bulk-collection-header .header-actions {\n    order: 3;\n    align-self: flex-end;\n  }\n}\n\n/* Language Switcher Styling for Bulk Collection V1 Header */\n.bulk-collection-header .lang-btn {\n  background: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.bulk-collection-header .lang-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.bulk-collection-header .lang-icon {\n  color: white;\n}\n\n.bulk-collection-header .lang-text {\n  color: white;\n}\n\n.bulk-collection-header .lang-chevron {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.bulk-collection-header .lang-menu {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 150px;\n}\n\n.bulk-collection-header .lang-item {\n  color: #333;\n  padding: 10px 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 13px;\n}\n\n.bulk-collection-header .lang-item:hover {\n  background-color: #f5f5f5;\n}\n\n.bulk-collection-header .lang-item.active {\n  background-color: #e3f2fd;\n  color: #2563eb;\n  font-weight: 600;\n}\n\n/* BulkCollectionV1 Rate Settings Modal Styles */\n.change-rates-modal-bulkcollection {\n  background: #f0f8ff;\n  /* Single blue background color */\n  border-radius: 16px;\n  max-width: 800px;\n  width: 95%;\n  height: auto;\n  max-height: 95vh;\n  overflow-y: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(37, 99, 235, 0.15);\n  font-size: 0.9rem;\n  border: 1px solid #2563eb;\n  margin: 20px auto;\n}\n\n.change-rates-header-bulkcollection {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: #2563eb;\n  /* Blue header */\n  color: white;\n  border-radius: 16px 16px 0 0;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);\n}\n\n.change-rates-body-bulkcollection {\n  padding: 16px;\n  overflow-y: hidden;\n  flex: 1;\n  font-size: 0.85rem;\n  background: #f0f8ff;\n  /* Single blue background */\n  min-height: 0;\n  max-height: calc(95vh - 140px);\n  /* Account for header and footer */\n}\n\n.change-rates-section-bulkcollection {\n  margin-bottom: 12px;\n  /* Reduced from 16px */\n  padding: 12px;\n  /* Reduced from 14px */\n  background: #e6f3ff;\n  /* Light blue background */\n  border-radius: 8px;\n  /* Reduced from 10px */\n  /* border removed */\n  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.1);\n  /* Blue shadow */\n}\n\n.change-rates-section-bulkcollection:last-child {\n  margin-bottom: 0;\n}\n\n.change-rates-section-bulkcollection h4 {\n  margin: 0 0 6px 0;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #1e40af;\n  /* Dark blue text */\n  letter-spacing: -0.01em;\n}\n\n.section-description {\n  font-size: 0.7rem;\n  /* Reduced from 0.75rem */\n  color: #1e40af;\n  /* Dark blue text */\n  line-height: 1.3;\n  /* Reduced from 1.4 */\n  margin-bottom: 8px;\n  /* Reduced from 10px */\n  font-weight: 400;\n}\n\n.option-btn {\n  padding: 6px 12px;\n  /* Reduced from 8px 16px */\n  border: 1px solid #2563eb;\n  /* Blue border */\n  border-radius: 4px;\n  /* Reduced from 6px */\n  background: #ffffff;\n  /* White background */\n  color: #1e40af;\n  /* Dark blue text */\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.8rem;\n  /* Reduced from 0.85rem */\n  font-weight: 500;\n  min-width: 80px;\n  /* Added for consistency */\n}\n\n.option-btn:hover {\n  border-color: #1e40af;\n  /* Darker blue border */\n  background: #f0f8ff;\n  /* Light blue background */\n}\n\n.option-btn.active {\n  background: #2563eb;\n  /* Blue background */\n  color: white;\n  border-color: #2563eb;\n  /* Blue border */\n}\n\n.rate-settings-modal-option-btn {\n  padding: 10px 12px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  background: white;\n  color: #374151;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.rate-settings-modal-option-btn:hover {\n  border-color: #2563eb;\n  color: #2563eb;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);\n  transform: translateY(-1px);\n}\n\n.rate-settings-modal-option-btn.active {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  border-color: #2563eb;\n  color: white !important;\n  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Current Milk Rate Display */\n.current-milk-rate-display {\n  background: #e6f3ff;\n  /* Light blue background */\n  border: 1px solid #2563eb;\n  /* Blue border */\n  border-radius: 8px;\n  padding: 8px;\n  /* Reduced padding for smaller card */\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.1);\n  /* Blue shadow */\n  position: relative;\n  /* Add relative positioning for edit button */\n}\n\n.current-milk-rate-display:hover {\n  background: #d1e7ff;\n  /* Lighter blue background */\n  border-color: #1e40af;\n  /* Darker blue border */\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);\n  transform: translateY(-1px);\n}\n\n.rate-label {\n  font-weight: 500;\n  color: #1e40af;\n  /* Dark blue text */\n  font-size: 0.85rem;\n  margin-right: 8px;\n}\n\n.rate-value {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #2563eb;\n  /* Blue text */\n}\n\n.edit-icon {\n  color: #1e40af;\n  /* Dark blue icon */\n  margin-left: 8px;\n  font-size: 0.9rem;\n}\n\n/* Edit button styling for milk rate display */\n.edit-rate-btn {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.8rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  min-height: 32px;\n}\n\n.edit-rate-btn:hover {\n  background: #1e40af;\n  transform: scale(1.05);\n}\n\n.edit-rate-btn svg {\n  margin: 0;\n}\n\n.change-rates-footer-bulkcollection {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: #f0f8ff;\n  /* Light blue background */\n  border-top: 1px solid #2563eb;\n  /* Blue border */\n  border-radius: 0 0 16px 16px;\n  justify-content: flex-end;\n}\n\n/* Two-row layout for top sections in BulkCollectionV1 */\n.change-rates-top-row-bulkcollection {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.change-rates-top-row-bulkcollection .change-rates-section-bulkcollection {\n  margin-bottom: 0;\n}\n\n/* Second row layout for Base SNF and CLR sections */\n.change-rates-bottom-row-bulkcollection {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.change-rates-bottom-row-bulkcollection .change-rates-section-bulkcollection {\n  margin-bottom: 0;\n}\n\n/* Mobile responsive styles for BulkCollectionV1 Rate Settings Modal */\n@media (max-width: 768px) {\n  .change-rates-modal-bulkcollection {\n    max-width: 98%;\n    width: 95%;\n    margin: 2px auto;\n    /* Minimal margin */\n    max-height: 98vh;\n    /* Maximum height */\n    overflow-y: auto;\n    /* Enable scrolling for mobile */\n  }\n\n  .change-rates-header-bulkcollection {\n    padding: 8px 12px;\n    /* Minimal header padding */\n  }\n\n  .change-rates-header-bulkcollection h3 {\n    font-size: 0.85rem;\n    /* Smaller header */\n  }\n\n  .change-rates-body-bulkcollection {\n    padding: 8px;\n    /* Minimal body padding */\n    font-size: 0.75rem;\n    /* Smaller font */\n    max-height: calc(98vh - 80px);\n    /* Optimized height calculation */\n    overflow-y: auto;\n    /* Enable scrolling for mobile */\n  }\n\n  .change-rates-section-bulkcollection {\n    margin-bottom: 8px;\n    /* Minimal margin */\n    padding: 8px;\n    /* Minimal padding */\n  }\n\n  .change-rates-section-bulkcollection h4 {\n    font-size: 0.75rem;\n    /* Smaller headers */\n    margin-bottom: 2px;\n    /* Minimal margin */\n  }\n\n  .section-description {\n    font-size: 0.65rem;\n    /* Smaller descriptions */\n    margin-bottom: 4px;\n    /* Minimal margin */\n    line-height: 1.2;\n  }\n\n  .rate-value {\n    font-size: 0.9rem;\n    /* Smaller rate value */\n  }\n\n  .current-milk-rate-display span {\n    font-size: 0.7rem;\n    /* Smaller milk rate label */\n    margin-bottom: 2px;\n  }\n\n  .option-btn {\n    padding: 6px 8px;\n    /* Minimal button padding */\n    font-size: 0.7rem;\n    /* Smaller button font */\n    max-width: 80px;\n    /* Smaller max width */\n    min-height: 32px;\n    /* Touch-friendly but compact */\n  }\n\n  /* Mobile single column layout for top row */\n  .change-rates-top-row-bulkcollection {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  /* Mobile single column layout for bottom row */\n  .change-rates-bottom-row-bulkcollection {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  /* Enhanced mobile styling for option buttons */\n  .option-buttons {\n    flex-wrap: wrap;\n    gap: 4px;\n    /* Reduced gap */\n  }\n\n  .option-btn {\n    flex: 1 1 calc(50% - 2px);\n    min-width: 70px;\n    /* Smaller min width */\n    padding: 6px 8px;\n    font-size: 0.7rem;\n  }\n\n  /* Mobile edit button positioning */\n  .edit-rate-btn {\n    top: 6px;\n    right: 6px;\n    min-width: 28px;\n    min-height: 28px;\n    font-size: 0.7rem;\n  }\n\n  /* Mobile milk rate display adjustments */\n  .current-milk-rate-display {\n    padding: 6px;\n    /* Smaller padding */\n  }\n\n  .rate-label {\n    font-size: 0.65rem;\n    /* Smaller label */\n  }\n\n  .rate-value {\n    font-size: 0.8rem;\n    /* Smaller value */\n  }\n}\n\n/* Very small mobile screens */\n@media (max-width: 480px) {\n  .change-rates-modal-bulkcollection {\n    margin: 2px auto;\n    /* Minimal margin */\n    overflow-y: auto;\n    /* Enable scrolling for very small screens */\n  }\n\n  .change-rates-body-bulkcollection {\n    padding: 6px;\n    /* Even smaller padding */\n    max-height: calc(98vh - 70px);\n    /* Optimized height */\n  }\n\n  .change-rates-section-bulkcollection {\n    padding: 6px;\n    /* Minimal padding */\n    margin-bottom: 6px;\n    /* Minimal margin */\n  }\n\n  .change-rates-section-bulkcollection h4 {\n    font-size: 0.7rem;\n    /* Even smaller headers */\n  }\n\n  .section-description {\n    font-size: 0.6rem;\n    /* Even smaller descriptions */\n    margin-bottom: 3px;\n  }\n\n  .option-btn {\n    padding: 5px 6px;\n    /* Minimal padding */\n    font-size: 0.65rem;\n    /* Even smaller font */\n    min-width: 60px;\n    /* Smaller min width */\n    min-height: 28px;\n  }\n\n  .edit-rate-btn {\n    top: 4px;\n    right: 4px;\n    min-width: 24px;\n    min-height: 24px;\n    font-size: 0.6rem;\n  }\n\n  .rate-label {\n    font-size: 0.6rem;\n  }\n\n  .rate-value {\n    font-size: 0.7rem;\n  }\n\n  .current-milk-rate-display {\n    padding: 4px;\n    /* Minimal padding */\n  }\n}\n\n/* Profile Dropdown Styles */\n.profile-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.profile-button {\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  padding: 8px 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n}\n\n.profile-button:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.profile-icon {\n  font-size: 18px;\n}\n\n.profile-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  min-width: 280px;\n  z-index: 1000;\n  margin-top: 8px;\n  overflow: hidden;\n  animation: dropdownSlideDown 0.3s ease;\n}\n\n@keyframes dropdownSlideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.profile-header {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: white;\n  padding: 12px 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.profile-header h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.profile-content {\n  padding: 16px;\n}\n\n.profile-content .info-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 0;\n  position: relative;\n  border: none !important;\n  border-bottom: none !important;\n  border-top: none !important;\n  border-left: none !important;\n  border-right: none !important;\n}\n\n.wallet-section {\n  padding: 12px 16px;\n  border-top: 1px solid #f0f0f0;\n  background: #f8f9fa;\n}\n\n.wallet-section .info-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 0;\n  position: relative;\n  border: none !important;\n  border-bottom: none !important;\n  border-top: none !important;\n  border-left: none !important;\n  border-right: none !important;\n}\n\n.profile-content .info-item:last-child {\n  border-bottom: none;\n}\n\n.profile-content .info-icon {\n  color: #2563eb;\n  font-size: 14px;\n  width: 20px;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.profile-content .info-label {\n  font-weight: 500;\n  color: #374151;\n  margin-right: 8px;\n  min-width: 80px;\n  flex-shrink: 0;\n}\n\n.profile-content .info-value {\n  color: #1f2937;\n  font-weight: 400;\n  flex-grow: 1;\n}\n\n.profile-content .add-money-btn {\n  background: #10b981;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 4px 8px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n  margin-left: 8px;\n  flex-shrink: 0;\n}\n\n.profile-content .add-money-btn:hover {\n  background: #059669;\n}\n\n.info-loading {\n  padding: 16px;\n  text-align: center;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* Rate Settings Card Styles */\n.rate-settings-card-bulk {\n  flex: 1;\n  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);\n  border-radius: 12px;\n  padding: 1rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 120px;\n  border: 1px solid rgba(59, 130, 246, 0.15);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Wallet Card Styles */\n.wallet-card-bulk {\n  flex: 1;\n  background: linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%);\n  border-radius: 12px;\n  padding: 1rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 120px;\n  border: 1px solid rgba(16, 185, 129, 0.15);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Rate Settings Card Styles */\n.rate-settings-dairy-card {\n  flex: 1;\n  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);\n  border-radius: 12px;\n  padding: 1.25rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 120px;\n  border: 1px solid rgba(251, 191, 36, 0.2);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.rate-settings-heading {\n  margin: 0 0 1rem 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #92400e;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.rate-settings-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n}\n\n.rate-settings-primary-btn {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 8px !important;\n  padding: 14px 28px !important;\n  font-size: 0.9rem !important;\n  font-weight: 600 !important;\n  cursor: pointer !important;\n  transition: all 0.3s ease !important;\n  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.25) !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  min-width: 160px !important;\n  justify-content: center !important;\n}\n\n.rate-settings-primary-btn:hover {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4) !important;\n}\n\n.rate-settings-primary-btn:active {\n  transform: translateY(0) !important;\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3) !important;\n}\n\n/* Modern Rate Settings Card */\n.rate-settings-modern-card {\n  flex: 1 1 350px;\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 0.8rem;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\n  /* border: 1px solid #e5e7eb; */\n  border: solid 2px black;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  min-height: 70px;\n}\n\n.rate-settings-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 0.3rem;\n}\n\n.rate-settings-icon-wrapper {\n  background: #3b82f6;\n  color: white;\n  width: 28px;\n  height: 28px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n}\n\n.rate-settings-title {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.rate-settings-list {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.5rem;\n}\n\n/* Desktop: 3 columns */\n@media (min-width: 1024px) {\n  .rate-settings-list {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.rate-settings-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.65rem;\n  color: #4b5563;\n}\n\n.check-icon {\n  color: #10b981;\n  font-size: 10px;\n  flex-shrink: 0;\n}\n\n.rate-settings-action-button {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 6px 10px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  margin-top: 0.5rem;\n  transition: all 0.2s ease;\n}\n\n.rate-settings-action-button:hover {\n  background: #2563eb;\n  transform: translateY(-1px);\n}\n\n/* Top Right Wallet Positioning */\n\n.wallet-rate-card {\n  /* border: solid 2px red; */\n  display: flex;\n  flex-direction: column;\n}\n\n.wallet-top-right {\n  display: inline;\n  margin-top: 10px;\n  max-width: 300px;\n  margin-left: auto;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 12px 18px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  border: 1px solid #e5e7eb;\n}\n\n.wallet-top-right .wallet-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wallet-top-right .icon-wallet {\n  color: #16a34a;\n  font-size: 18px;\n}\n\n\n.wallet-top-right .wallet-info span:last-child {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n/* Simple Wallet Card */\n.wallet-simple-card {\n  flex: 0 1 240px;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 12px 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e5e7eb;\n}\n\n.wallet-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.icon-wallet {\n  color: #16a34a;\n  font-size: 16px;\n}\n\n.wallet-recharge-link {\n  color: #3b82f6;\n  font-size: 18px !important;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.wallet-recharge-link:hover {\n  color: #2563eb;\n  text-decoration: underline;\n}\n\n.wallet-amount {\n  font-size: 18px;\n  font-weight: 700;\n  color: #000 !important;\n}\n\n/* .wallet-simple-card .wallet-info span:last-child {\n  margin-left: auto;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #1f2937;\n} */\n\n.wallet-card-heading {\n  margin: 0 0 1rem 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #059669;\n  text-align: center;\n}\n\n.wallet-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.wallet-info-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: rgba(16, 185, 129, 0.1);\n  border-radius: 8px;\n  border: none;\n}\n\n.wallet-icon {\n  color: #059669;\n  font-size: 1.2rem;\n  flex-shrink: 0;\n}\n\n.wallet-label {\n  font-weight: 500;\n  color: #374151;\n  font-size: 0.9rem;\n}\n\n.wallet-value {\n  color: #1f2937;\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n\n.add-money-btn-main {\n  background: #059669;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n}\n\n.add-money-btn-main:hover {\n  background: #047857;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n/* ==================== EDIT SUPPLIER MODAL STYLES ==================== */\n\n/* Edit Supplier Modal */\n.edit-supplier-modal {\n  max-width: 500px;\n  width: 95%;\n  max-height: 85vh;\n  overflow: hidden;\n}\n\n.edit-supplier-modal .modal-body {\n  padding: 0;\n  overflow-y: auto;\n  max-height: calc(85vh - 120px);\n  display: flex;\n  flex-direction: column;\n}\n\n/* Search Input Wrapper with Icon */\n.supplier-search-input-wrapper {\n  position: relative;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f8f9fa;\n}\n\n.supplier-search-input-wrapper .search-icon {\n  position: absolute;\n  left: 32px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  font-size: 16px;\n  z-index: 1;\n}\n\n.supplier-search-input {\n  width: 100%;\n  padding: 12px 16px 12px 44px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 15px;\n  background: white;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.supplier-search-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Supplier List Container - Simple */\n.supplier-list-container-simple {\n  width: 100%;\n  background: white;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n/* Supplier List - Simple */\n.supplier-list-simple {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Supplier List Item - Simple */\n.supplier-list-item-simple {\n  padding: 16px 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-bottom: 1px solid #f3f4f6;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.supplier-list-item-simple:hover {\n  background: #f9fafb;\n}\n\n.supplier-list-item-simple:active {\n  background: #f3f4f6;\n}\n\n.supplier-name-simple {\n  font-weight: 500;\n  font-size: 16px;\n  color: #1f2937;\n}\n\n.supplier-id-simple {\n  font-size: 14px;\n  color: #6b7280;\n}\n\n/* No Suppliers Found - Simple */\n.no-suppliers-found-simple {\n  padding: 40px 20px;\n  text-align: center;\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n/* Edit Supplier Button - Green styling */\n.edit-supplier-btn {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;\n}\n\n.edit-supplier-btn:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;\n}\n\n/* Selected Supplier Info */\n.edit-supplier-modal .form-instructions strong {\n  color: #3b82f6;\n}\n\n/* Responsive adjustments for Edit Supplier Modal */\n@media (max-width: 768px) {\n  .edit-supplier-modal {\n    max-width: 95%;\n    width: 95%;\n    max-height: 90vh;\n  }\n\n  .edit-supplier-modal .modal-body {\n    max-height: calc(90vh - 100px);\n  }\n\n  .supplier-search-input-wrapper {\n    padding: 12px 16px;\n  }\n\n  .supplier-list-container-simple {\n    max-height: 350px;\n  }\n\n  .supplier-list-item-simple {\n    padding: 14px 16px;\n  }\n\n  .supplier-name-simple {\n    font-size: 15px;\n  }\n\n  .bulk-dairy-info-wrapper {\n    width: 100% !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .edit-supplier-modal {\n    max-width: 98%;\n    width: 98%;\n  }\n\n  .bulk-dairy-info-wrapper {\n    width: 100%;\n  }\n\n  .supplier-list-item-simple {\n    padding: 12px 14px;\n  }\n\n  .supplier-name-simple {\n    font-size: 14px;\n  }\n\n  .supplier-id-simple {\n    font-size: 13px;\n  }\n}\n\n/* Bulk Collection V1 - Modern Rate Settings and Dairy Info Cards */\n.bulk-dairy-info-wrapper {\n  display: flex;\n  gap: 16px;\n  width: 40%;\n  align-items: stretch;\n  margin-bottom: 10px;\n  padding: 12px;\n  border-radius: 12px;\n}\n\n/* Mobile and Tablet Layout - Stack cards vertically */\n@media (max-width: 1024px) {\n  .bulk-dairy-info-wrapper {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .bulk-rate-settings-card,\n  .bulk-dairy-info-card {\n    width: 100%;\n  }\n\n  /* Hide dairy info card on mobile */\n  .bulk-dairy-info-card {\n    display: none !important;\n  }\n}\n\n/* Additional mobile-specific rule for smaller screens */\n@media (max-width: 768px) {\n  .bulk-dairy-info-card {\n    display: none !important;\n    visibility: hidden !important;\n    height: 0 !important;\n    overflow: hidden !important;\n  }\n}\n\n/* Bulk Rate Settings Card */\n.bulk-rate-settings-card {\n  flex: 1 1 50%;\n  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 12px;\n  padding: 0.6rem 0.8rem;\n  box-shadow: 0 2px 12px rgba(59, 130, 246, 0.06), 0 1px 3px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.bulk-rate-settings-card:hover {\n  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.12), 0 2px 6px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n  border-color: rgba(59, 130, 246, 0.15);\n}\n\n.bulk-rate-settings-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #3b82f6 0%, #8b5cf6 50%, #06b6d4 100%);\n}\n\n.bulk-rate-settings-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  padding-bottom: 0.4rem;\n  border-bottom: 1px solid rgba(59, 130, 246, 0.08);\n}\n\n.bulk-rate-settings-title-section {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.bulk-rate-settings-icon-bg {\n  width: 28px;\n  height: 28px;\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);\n}\n\n.bulk-rate-settings-main-icon {\n  color: white;\n  font-size: 12px;\n}\n\n.bulk-rate-settings-title {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.bulk-rate-settings-subtitle {\n  display: none !important;\n  color: #64748b;\n  margin: 0;\n  font-weight: 400;\n}\n\n.bulk-rate-settings-btn {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  border: none;\n  border-radius: 6px;\n  padding: 0.25rem 0.5rem;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);\n}\n\n.bulk-rate-settings-btn:hover {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);\n}\n\n.bulk-rate-settings-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.bulk-rate-settings-row {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.bulk-rate-settings-row .bulk-rate-setting-item {\n  flex: 1;\n  min-width: 0;\n}\n\n.bulk-rate-setting-item {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 8px;\n  border: 1px solid rgba(59, 130, 246, 0.06);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.bulk-rate-setting-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 2px;\n  height: 100%;\n  background: linear-gradient(180deg, #3b82f6 0%, #8b5cf6 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.bulk-rate-setting-item:hover::before {\n  opacity: 1;\n}\n\n.bulk-rate-setting-item:hover {\n  background: rgba(255, 255, 255, 1);\n  border-color: rgba(59, 130, 246, 0.15);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.08);\n}\n\n.bulk-setting-icon-wrapper {\n  width: 28px;\n  height: 28px;\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.bulk-setting-icon {\n  color: #3b82f6;\n  font-size: 12px;\n}\n\n.bulk-setting-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.bulk-setting-name {\n  font-size: 0.6rem;\n  color: #64748b;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.bulk-setting-value {\n  font-size: 0.8rem;\n  color: #1e293b;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.bulk-setting-value.highlight {\n  color: #3b82f6;\n  font-size: 0.85rem;\n}\n\n/* Mobile responsive - Hide dairy info cards */\n@media (max-width: 768px) {\n  .wallet-rate-card>div:first-child {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .bulk-dairy-info-item {\n    display: none !important;\n  }\n\n  .wallet-info {\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n\n/* Single line card layout */\n.wallet-rate-card>div:first-child {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 1rem;\n}\n\n.wallet-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.25rem;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-weight: 700;\n  white-space: nowrap;\n  color: #1e293b;\n}\n\n.wallet-recharge-link {\n  cursor: pointer;\n  text-decoration: underline;\n  color: #3b82f6;\n}\n\n.wallet-recharge-link:hover {\n  color: #10b981;\n}\n\n/* .wallet-info span:last-child {\n  font-weight: 600;\n  font-size: 1rem;\n} */\n\n.bulk-dairy-info-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.5rem 0.75rem;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.bulk-dairy-info-item:hover {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.bulk-dairy-info-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  background: #3b82f6;\n  color: white;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.bulk-dairy-info-content {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n}\n\n.bulk-dairy-info-name {\n  font-size: 1rem;\n  color: #000000;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n\n.bulk-dairy-info-value {\n  font-size: 18px;\n  color: #1e293b;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n}\n\n/* Global header dropdown styling */\n.global-time-header-select,\n.global-base-snf-header-select,\n.global-animal-type-header-select {\n  border: none !important;\n  outline: none !important;\n  background: transparent !important;\n  font-weight: 600;\n  font-size: 16px !important;\n  color: inherit;\n  text-align: center;\n  width: 100%;\n}\n\n.global-time-header-select:focus {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.global-animal-type-header-select:focus {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.global-base-snf-header-select:focus {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n/* Rate Change Modal Styling */\n.rate-change-modal {\n  background: white;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 400px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.rate-change-modal .modal-header {\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid #e8eaed;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.rate-change-modal .modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #202124;\n}\n\n.rate-change-modal .modal-body {\n  padding: 20px 24px;\n}\n\n.rate-change-modal .form-group {\n  margin-bottom: 20px;\n}\n\n.rate-change-modal .form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #3c4043;\n  font-size: 14px;\n}\n\n.rate-change-modal .rate-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #dadce0;\n  border-radius: 4px;\n  font-size: 16px;\n  color: #202124;\n  transition: border-color 0.2s;\n}\n\n.rate-change-modal .rate-input:focus {\n  outline: none;\n  border-color: #1a73e8;\n  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);\n}\n\n.rate-change-modal .modal-footer {\n  padding: 16px 24px 20px;\n  border-top: 1px solid #e8eaed;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.rate-change-modal .cancel-button {\n  padding: 10px 20px;\n  border: 1px solid #dadce0;\n  background: white;\n  color: #3c4043;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.rate-change-modal .cancel-button:hover {\n  background: #f8f9fa;\n}\n\n.rate-change-modal .confirm-button {\n  padding: 10px 20px;\n  border: none;\n  background: #1a73e8;\n  color: white;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.rate-change-modal .confirm-button:hover {\n  background: #1765cc;\n}\n\n.rate-change-modal .confirm-button:disabled {\n  background: #9aa0a6;\n  cursor: not-allowed;\n}\n\n/* Centered confirmation message positioning */\n.success-message-centered {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1000;\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n  border-radius: 8px;\n  padding: 20px 30px;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  animation: fadeInScale 0.3s ease-in-out;\n  min-width: 300px;\n  max-width: 500px;\n}\n\n.success-message-centered svg {\n  margin-right: 12px;\n  font-size: 1.4em;\n  flex-shrink: 0;\n}\n\n.success-message-centered span {\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.success-message-close-btn {\n  background: none;\n  border: none;\n  color: #155724;\n  cursor: pointer;\n  padding: 4px;\n  margin-left: 12px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.success-message-close-btn:hover {\n  background-color: rgba(21, 87, 36, 0.1);\n  color: #0d5422;\n}\n\n.success-message-close-btn svg {\n  font-size: 14px;\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(0.9);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n/* Date/Shift Mode Toggle Segmented Control */\n.date-shift-toggle-group {\n  display: flex;\n  align-items: center;\n  background-color: #e9ecef;\n  border-radius: 6px;\n  padding: 3px;\n  margin-left: 12px;\n}\n\n.date-shift-toggle-btn {\n  padding: 6px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #495057;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.date-shift-toggle-btn.active {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white !important;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  font-weight: 600;\n}\n\n@media (max-width: 768px) {\n  .date-shift-toggle-group {\n    margin-left: 0;\n    margin-top: 8px;\n    width: 100%;\n    justify-content: center;\n  }\n}\n/* Rate Type & Animal Type - 50-50 side-by-side on mobile */\n@media (max-width: 480px) {\n  .rate-settings-modal-row-dashboard {\n    flex-direction: row !important;\n    gap: 8px !important;\n    margin-bottom: 10px !important;\n  }\n  .rate-settings-modal-row-dashboard .rate-settings-modal-section-dashboard {\n    flex: 1 1 0 !important;\n    min-width: 0 !important;\n  }\n}\n\n/* Premium Rate Change Modal Styles */\n.brc-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(15, 23, 42, 0.45) !important;\n  backdrop-filter: blur(8px) !important;\n  -webkit-backdrop-filter: blur(8px) !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  z-index: 2000 !important;\n  animation: brcFadeIn 0.25s ease-out;\n}\n\n.brc-modal-container {\n  background: #ffffff !important;\n  border-radius: 20px !important;\n  width: 90% !important;\n  max-width: 420px !important;\n  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;\n  border: 1px solid rgba(241, 245, 249, 0.8) !important;\n  overflow: hidden !important;\n  animation: brcScaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes brcFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes brcScaleIn {\n  from { transform: scale(0.95) translateY(10px); opacity: 0; }\n  to { transform: scale(1) translateY(0); opacity: 1; }\n}\n\n.brc-modal-header {\n  padding: 24px 28px 16px !important;\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n  border-bottom: 1px solid #f1f5f9 !important;\n}\n\n.brc-modal-title {\n  margin: 0 !important;\n  font-size: 20px !important;\n  font-weight: 700 !important;\n  color: #0f172a !important;\n  letter-spacing: -0.02em !important;\n}\n\n.brc-modal-close-btn {\n  background: #f8fafc !important;\n  border: none !important;\n  width: 36px !important;\n  height: 36px !important;\n  border-radius: 50% !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: #64748b !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n}\n\n.brc-modal-close-btn:hover {\n  background: #e2e8f0 !important;\n  color: #0f172a !important;\n  transform: rotate(90deg) !important;\n}\n\n.brc-modal-body {\n  padding: 28px 28px 24px !important;\n}\n\n.brc-modal-form-group {\n  margin-bottom: 24px !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 10px !important;\n}\n\n.brc-modal-label {\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  color: #475569 !important;\n  margin-bottom: 0 !important;\n  text-align: left !important;\n}\n\n.brc-modal-input-wrapper {\n  position: relative !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.brc-modal-currency-symbol {\n  position: absolute !important;\n  left: 16px !important;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  color: #94a3b8 !important;\n  pointer-events: none !important;\n}\n\n.brc-modal-input {\n  width: 100% !important;\n  padding: 14px 16px 14px 36px !important;\n  border: 2px solid #e2e8f0 !important;\n  border-radius: 12px !important;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  color: #0f172a !important;\n  background-color: #f8fafc !important;\n  transition: all 0.2s ease !important;\n  box-sizing: border-box !important;\n}\n\n.brc-modal-input:focus {\n  outline: none !important;\n  border-color: #10b981 !important;\n  background-color: #ffffff !important;\n  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.15) !important;\n}\n\n.brc-modal-input::placeholder {\n  color: #cbd5e1 !important;\n  font-size: 15px !important;\n  font-weight: 400 !important;\n}\n\n.brc-modal-error-message {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  color: #ef4444 !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  margin-top: 12px !important;\n  padding: 10px 14px !important;\n  background: #fef2f2 !important;\n  border-radius: 8px !important;\n  border: 1px dashed rgba(239, 68, 68, 0.3) !important;\n}\n\n.brc-modal-footer {\n  padding: 20px 28px 28px !important;\n  background-color: #f8fafc !important;\n  border-top: 1px solid #f1f5f9 !important;\n  display: flex !important;\n  flex-direction: row !important;\n  justify-content: flex-end !important;\n  gap: 12px !important;\n  border-bottom-left-radius: 20px !important;\n  border-bottom-right-radius: 20px !important;\n}\n\n.brc-modal-cancel-btn {\n  flex: 1 !important;\n  padding: 12px 20px !important;\n  border: 1px solid #e2e8f0 !important;\n  background: #ffffff !important;\n  color: #64748b !important;\n  border-radius: 12px !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;\n  margin-bottom: 0 !important;\n  width: auto !important;\n}\n\n.brc-modal-cancel-btn:hover {\n  background: #f1f5f9 !important;\n  color: #0f172a !important;\n  border-color: #cbd5e1 !important;\n}\n\n.brc-modal-cancel-btn:active {\n  transform: scale(0.98) !important;\n}\n\n.brc-modal-confirm-btn {\n  flex: 1.2 !important;\n  padding: 12px 20px !important;\n  border: none !important;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;\n  color: white !important;\n  border-radius: 12px !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  box-shadow: 0 4px 6px -1px rgba(16, 185, 129, 0.2), 0 2px 4px -1px rgba(16, 185, 129, 0.1) !important;\n  margin-bottom: 0 !important;\n  width: auto !important;\n}\n\n.brc-modal-confirm-btn:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;\n  box-shadow: 0 10px 15px -3px rgba(16, 185, 129, 0.3), 0 4px 6px -2px rgba(16, 185, 129, 0.15) !important;\n}\n\n.brc-modal-confirm-btn:active {\n  transform: scale(0.98) !important;\n}\n\n.brc-modal-confirm-btn:disabled {\n  background: #cbd5e1 !important;\n  color: #94a3b8 !important;\n  cursor: not-allowed !important;\n  box-shadow: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
